var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
System.register([], function(exports, module) {
  "use strict";
  return {
    execute: function() {
      var _a, _b;
      function _mergeNamespaces(n2, m2) {
        for (var i2 = 0; i2 < m2.length; i2++) {
          const e2 = m2[i2];
          if (typeof e2 !== "string" && !Array.isArray(e2)) {
            for (const k in e2) {
              if (k !== "default" && !(k in n2)) {
                const d2 = Object.getOwnPropertyDescriptor(e2, k);
                if (d2) {
                  Object.defineProperty(n2, k, d2.get ? d2 : {
                    enumerable: true,
                    get: () => e2[k]
                  });
                }
              }
            }
          }
        }
        return Object.freeze(Object.defineProperty(n2, Symbol.toStringTag, { value: "Module" }));
      }
      exports({
        a: requireReact,
        b: hex2rgb,
        c: isBreakpoint,
        e: getDefaultExportFromCjs,
        i: isMobile,
        j,
        u
      });
      function getDefaultExportFromCjs(x) {
        return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
      }
      var react = { exports: {} };
      var react_production_min = {};
      /**
       * @license React
       * react.production.min.js
       *
       * Copyright (c) Facebook, Inc. and its affiliates.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */
      var hasRequiredReact_production_min;
      function requireReact_production_min() {
        if (hasRequiredReact_production_min) return react_production_min;
        hasRequiredReact_production_min = 1;
        var l2 = Symbol.for("react.element"), n2 = Symbol.for("react.portal"), p2 = Symbol.for("react.fragment"), q = Symbol.for("react.strict_mode"), r = Symbol.for("react.profiler"), t2 = Symbol.for("react.provider"), u2 = Symbol.for("react.context"), v = Symbol.for("react.forward_ref"), w = Symbol.for("react.suspense"), x = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), z = Symbol.iterator;
        function A(a2) {
          if (null === a2 || "object" !== typeof a2) return null;
          a2 = z && a2[z] || a2["@@iterator"];
          return "function" === typeof a2 ? a2 : null;
        }
        var B = { isMounted: function() {
          return false;
        }, enqueueForceUpdate: function() {
        }, enqueueReplaceState: function() {
        }, enqueueSetState: function() {
        } }, C = Object.assign, D = {};
        function E(a2, b, e2) {
          this.props = a2;
          this.context = b;
          this.refs = D;
          this.updater = e2 || B;
        }
        E.prototype.isReactComponent = {};
        E.prototype.setState = function(a2, b) {
          if ("object" !== typeof a2 && "function" !== typeof a2 && null != a2) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
          this.updater.enqueueSetState(this, a2, b, "setState");
        };
        E.prototype.forceUpdate = function(a2) {
          this.updater.enqueueForceUpdate(this, a2, "forceUpdate");
        };
        function F() {
        }
        F.prototype = E.prototype;
        function G(a2, b, e2) {
          this.props = a2;
          this.context = b;
          this.refs = D;
          this.updater = e2 || B;
        }
        var H = G.prototype = new F();
        H.constructor = G;
        C(H, E.prototype);
        H.isPureReactComponent = true;
        var I = Array.isArray, J = Object.prototype.hasOwnProperty, K = { current: null }, L = { key: true, ref: true, __self: true, __source: true };
        function M(a2, b, e2) {
          var d2, c2 = {}, k = null, h2 = null;
          if (null != b) for (d2 in void 0 !== b.ref && (h2 = b.ref), void 0 !== b.key && (k = "" + b.key), b) J.call(b, d2) && !L.hasOwnProperty(d2) && (c2[d2] = b[d2]);
          var g2 = arguments.length - 2;
          if (1 === g2) c2.children = e2;
          else if (1 < g2) {
            for (var f2 = Array(g2), m2 = 0; m2 < g2; m2++) f2[m2] = arguments[m2 + 2];
            c2.children = f2;
          }
          if (a2 && a2.defaultProps) for (d2 in g2 = a2.defaultProps, g2) void 0 === c2[d2] && (c2[d2] = g2[d2]);
          return { $$typeof: l2, type: a2, key: k, ref: h2, props: c2, _owner: K.current };
        }
        function N(a2, b) {
          return { $$typeof: l2, type: a2.type, key: b, ref: a2.ref, props: a2.props, _owner: a2._owner };
        }
        function O(a2) {
          return "object" === typeof a2 && null !== a2 && a2.$$typeof === l2;
        }
        function escape(a2) {
          var b = { "=": "=0", ":": "=2" };
          return "$" + a2.replace(/[=:]/g, function(a3) {
            return b[a3];
          });
        }
        var P = /\/+/g;
        function Q(a2, b) {
          return "object" === typeof a2 && null !== a2 && null != a2.key ? escape("" + a2.key) : b.toString(36);
        }
        function R(a2, b, e2, d2, c2) {
          var k = typeof a2;
          if ("undefined" === k || "boolean" === k) a2 = null;
          var h2 = false;
          if (null === a2) h2 = true;
          else switch (k) {
            case "string":
            case "number":
              h2 = true;
              break;
            case "object":
              switch (a2.$$typeof) {
                case l2:
                case n2:
                  h2 = true;
              }
          }
          if (h2) return h2 = a2, c2 = c2(h2), a2 = "" === d2 ? "." + Q(h2, 0) : d2, I(c2) ? (e2 = "", null != a2 && (e2 = a2.replace(P, "$&/") + "/"), R(c2, b, e2, "", function(a3) {
            return a3;
          })) : null != c2 && (O(c2) && (c2 = N(c2, e2 + (!c2.key || h2 && h2.key === c2.key ? "" : ("" + c2.key).replace(P, "$&/") + "/") + a2)), b.push(c2)), 1;
          h2 = 0;
          d2 = "" === d2 ? "." : d2 + ":";
          if (I(a2)) for (var g2 = 0; g2 < a2.length; g2++) {
            k = a2[g2];
            var f2 = d2 + Q(k, g2);
            h2 += R(k, b, e2, f2, c2);
          }
          else if (f2 = A(a2), "function" === typeof f2) for (a2 = f2.call(a2), g2 = 0; !(k = a2.next()).done; ) k = k.value, f2 = d2 + Q(k, g2++), h2 += R(k, b, e2, f2, c2);
          else if ("object" === k) throw b = String(a2), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a2).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
          return h2;
        }
        function S(a2, b, e2) {
          if (null == a2) return a2;
          var d2 = [], c2 = 0;
          R(a2, d2, "", "", function(a3) {
            return b.call(e2, a3, c2++);
          });
          return d2;
        }
        function T(a2) {
          if (-1 === a2._status) {
            var b = a2._result;
            b = b();
            b.then(function(b2) {
              if (0 === a2._status || -1 === a2._status) a2._status = 1, a2._result = b2;
            }, function(b2) {
              if (0 === a2._status || -1 === a2._status) a2._status = 2, a2._result = b2;
            });
            -1 === a2._status && (a2._status = 0, a2._result = b);
          }
          if (1 === a2._status) return a2._result.default;
          throw a2._result;
        }
        var U = { current: null }, V = { transition: null }, W = { ReactCurrentDispatcher: U, ReactCurrentBatchConfig: V, ReactCurrentOwner: K };
        function X() {
          throw Error("act(...) is not supported in production builds of React.");
        }
        react_production_min.Children = { map: S, forEach: function(a2, b, e2) {
          S(a2, function() {
            b.apply(this, arguments);
          }, e2);
        }, count: function(a2) {
          var b = 0;
          S(a2, function() {
            b++;
          });
          return b;
        }, toArray: function(a2) {
          return S(a2, function(a3) {
            return a3;
          }) || [];
        }, only: function(a2) {
          if (!O(a2)) throw Error("React.Children.only expected to receive a single React element child.");
          return a2;
        } };
        react_production_min.Component = E;
        react_production_min.Fragment = p2;
        react_production_min.Profiler = r;
        react_production_min.PureComponent = G;
        react_production_min.StrictMode = q;
        react_production_min.Suspense = w;
        react_production_min.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = W;
        react_production_min.act = X;
        react_production_min.cloneElement = function(a2, b, e2) {
          if (null === a2 || void 0 === a2) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a2 + ".");
          var d2 = C({}, a2.props), c2 = a2.key, k = a2.ref, h2 = a2._owner;
          if (null != b) {
            void 0 !== b.ref && (k = b.ref, h2 = K.current);
            void 0 !== b.key && (c2 = "" + b.key);
            if (a2.type && a2.type.defaultProps) var g2 = a2.type.defaultProps;
            for (f2 in b) J.call(b, f2) && !L.hasOwnProperty(f2) && (d2[f2] = void 0 === b[f2] && void 0 !== g2 ? g2[f2] : b[f2]);
          }
          var f2 = arguments.length - 2;
          if (1 === f2) d2.children = e2;
          else if (1 < f2) {
            g2 = Array(f2);
            for (var m2 = 0; m2 < f2; m2++) g2[m2] = arguments[m2 + 2];
            d2.children = g2;
          }
          return { $$typeof: l2, type: a2.type, key: c2, ref: k, props: d2, _owner: h2 };
        };
        react_production_min.createContext = function(a2) {
          a2 = { $$typeof: u2, _currentValue: a2, _currentValue2: a2, _threadCount: 0, Provider: null, Consumer: null, _defaultValue: null, _globalName: null };
          a2.Provider = { $$typeof: t2, _context: a2 };
          return a2.Consumer = a2;
        };
        react_production_min.createElement = M;
        react_production_min.createFactory = function(a2) {
          var b = M.bind(null, a2);
          b.type = a2;
          return b;
        };
        react_production_min.createRef = function() {
          return { current: null };
        };
        react_production_min.forwardRef = function(a2) {
          return { $$typeof: v, render: a2 };
        };
        react_production_min.isValidElement = O;
        react_production_min.lazy = function(a2) {
          return { $$typeof: y, _payload: { _status: -1, _result: a2 }, _init: T };
        };
        react_production_min.memo = function(a2, b) {
          return { $$typeof: x, type: a2, compare: void 0 === b ? null : b };
        };
        react_production_min.startTransition = function(a2) {
          var b = V.transition;
          V.transition = {};
          try {
            a2();
          } finally {
            V.transition = b;
          }
        };
        react_production_min.unstable_act = X;
        react_production_min.useCallback = function(a2, b) {
          return U.current.useCallback(a2, b);
        };
        react_production_min.useContext = function(a2) {
          return U.current.useContext(a2);
        };
        react_production_min.useDebugValue = function() {
        };
        react_production_min.useDeferredValue = function(a2) {
          return U.current.useDeferredValue(a2);
        };
        react_production_min.useEffect = function(a2, b) {
          return U.current.useEffect(a2, b);
        };
        react_production_min.useId = function() {
          return U.current.useId();
        };
        react_production_min.useImperativeHandle = function(a2, b, e2) {
          return U.current.useImperativeHandle(a2, b, e2);
        };
        react_production_min.useInsertionEffect = function(a2, b) {
          return U.current.useInsertionEffect(a2, b);
        };
        react_production_min.useLayoutEffect = function(a2, b) {
          return U.current.useLayoutEffect(a2, b);
        };
        react_production_min.useMemo = function(a2, b) {
          return U.current.useMemo(a2, b);
        };
        react_production_min.useReducer = function(a2, b, e2) {
          return U.current.useReducer(a2, b, e2);
        };
        react_production_min.useRef = function(a2) {
          return U.current.useRef(a2);
        };
        react_production_min.useState = function(a2) {
          return U.current.useState(a2);
        };
        react_production_min.useSyncExternalStore = function(a2, b, e2) {
          return U.current.useSyncExternalStore(a2, b, e2);
        };
        react_production_min.useTransition = function() {
          return U.current.useTransition();
        };
        react_production_min.version = "18.3.1";
        return react_production_min;
      }
      var hasRequiredReact;
      function requireReact() {
        if (hasRequiredReact) return react.exports;
        hasRequiredReact = 1;
        {
          react.exports = requireReact_production_min();
        }
        return react.exports;
      }
      var reactExports = exports("r", requireReact());
      const React = exports("f", /* @__PURE__ */ getDefaultExportFromCjs(reactExports));
      const React$1 = /* @__PURE__ */ _mergeNamespaces({
        __proto__: null,
        default: React
      }, [reactExports]);
      exports("R", React$1);
      let e = { data: "" }, t = (t2) => "object" == typeof window ? ((t2 ? t2.querySelector("#_goober") : window._goober) || Object.assign((t2 || document.head).appendChild(document.createElement("style")), { innerHTML: " ", id: "_goober" })).firstChild : t2 || e, l = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g, a = /\/\*[^]*?\*\/|  +/g, n$1 = /\n+/g, o = (e2, t2) => {
        let r = "", l2 = "", a2 = "";
        for (let n2 in e2) {
          let c2 = e2[n2];
          "@" == n2[0] ? "i" == n2[1] ? r = n2 + " " + c2 + ";" : l2 += "f" == n2[1] ? o(c2, n2) : n2 + "{" + o(c2, "k" == n2[1] ? "" : t2) + "}" : "object" == typeof c2 ? l2 += o(c2, t2 ? t2.replace(/([^,])+/g, (e3) => n2.replace(/(^:.*)|([^,])+/g, (t3) => /&/.test(t3) ? t3.replace(/&/g, e3) : e3 ? e3 + " " + t3 : t3)) : n2) : null != c2 && (n2 = /^--/.test(n2) ? n2 : n2.replace(/[A-Z]/g, "-$&").toLowerCase(), a2 += o.p ? o.p(n2, c2) : n2 + ":" + c2 + ";");
        }
        return r + (t2 && a2 ? t2 + "{" + a2 + "}" : a2) + l2;
      }, c = {}, s = (e2) => {
        if ("object" == typeof e2) {
          let t2 = "";
          for (let r in e2) t2 += r + s(e2[r]);
          return t2;
        }
        return e2;
      }, i$1 = (e2, t2, r, i2, p2) => {
        let u2 = s(e2), d2 = c[u2] || (c[u2] = ((e3) => {
          let t3 = 0, r2 = 11;
          for (; t3 < e3.length; ) r2 = 101 * r2 + e3.charCodeAt(t3++) >>> 0;
          return "go" + r2;
        })(u2));
        if (!c[d2]) {
          let t3 = u2 !== e2 ? e2 : ((e3) => {
            let t4, r2, o2 = [{}];
            for (; t4 = l.exec(e3.replace(a, "")); ) t4[4] ? o2.shift() : t4[3] ? (r2 = t4[3].replace(n$1, " ").trim(), o2.unshift(o2[0][r2] = o2[0][r2] || {})) : o2[0][t4[1]] = t4[2].replace(n$1, " ").trim();
            return o2[0];
          })(e2);
          c[d2] = o(p2 ? { ["@keyframes " + d2]: t3 } : t3, r ? "" : "." + d2);
        }
        let f2 = r && c.g ? c.g : null;
        return r && (c.g = c[d2]), ((e3, t3, r2, l2) => {
          l2 ? t3.data = t3.data.replace(l2, e3) : -1 === t3.data.indexOf(e3) && (t3.data = r2 ? e3 + t3.data : t3.data + e3);
        })(c[d2], t2, i2, f2), d2;
      }, p = (e2, t2, r) => e2.reduce((e3, l2, a2) => {
        let n2 = t2[a2];
        if (n2 && n2.call) {
          let e4 = n2(r), t3 = e4 && e4.props && e4.props.className || /^go/.test(e4) && e4;
          n2 = t3 ? "." + t3 : e4 && "object" == typeof e4 ? e4.props ? "" : o(e4, "") : false === e4 ? "" : e4;
        }
        return e3 + l2 + (null == n2 ? "" : n2);
      }, "");
      function u(e2) {
        let r = this || {}, l2 = e2.call ? e2(r.p) : e2;
        return i$1(l2.unshift ? l2.raw ? p(l2, [].slice.call(arguments, 1), r.p) : l2.reduce((e3, t2) => Object.assign(e3, t2 && t2.call ? t2(r.p) : t2), {}) : l2, t(r.target), r.g, r.o, r.k);
      }
      let d, f, g;
      u.bind({ g: 1 });
      let h = exports("h", u.bind({ k: 1 }));
      function m(e2, t2, r, l2) {
        o.p = t2, d = e2, f = r, g = l2;
      }
      function j(e2, t2) {
        let r = this || {};
        return function() {
          let l2 = arguments;
          function a2(n2, o2) {
            let c2 = Object.assign({}, n2), s2 = c2.className || a2.className;
            r.p = Object.assign({ theme: f && f() }, c2), r.o = / *go\d+/.test(s2), c2.className = u.apply(r, l2) + (s2 ? " " + s2 : ""), t2 && (c2.ref = o2);
            let i2 = e2;
            return e2[0] && (i2 = c2.as || e2, delete c2.as), g && i2[0] && g(c2), d(i2, c2);
          }
          return t2 ? t2(a2) : a2;
        };
      }
      var i = /* @__PURE__ */ new Map([["align-self", "-ms-grid-row-align"], ["color-adjust", "-webkit-print-color-adjust"], ["column-gap", "grid-column-gap"], ["gap", "grid-gap"], ["grid-template-columns", "-ms-grid-columns"], ["grid-template-rows", "-ms-grid-rows"], ["justify-self", "-ms-grid-column-align"], ["margin-inline-end", "-webkit-margin-end"], ["margin-inline-start", "-webkit-margin-start"], ["overflow-wrap", "word-wrap"], ["padding-inline-end", "-webkit-padding-end"], ["padding-inline-start", "-webkit-padding-start"], ["row-gap", "grid-row-gap"], ["scroll-margin-bottom", "scroll-snap-margin-bottom"], ["scroll-margin-left", "scroll-snap-margin-left"], ["scroll-margin-right", "scroll-snap-margin-right"], ["scroll-margin-top", "scroll-snap-margin-top"], ["scroll-margin", "scroll-snap-margin"], ["text-combine-upright", "-ms-text-combine-horizontal"]]);
      function n(n2, r) {
        let t2 = "";
        const a2 = i.get(n2);
        a2 && (t2 += `${a2}:${r};`);
        const o2 = function(i2) {
          var n3 = /^(?:(text-(?:decoration$|e|or|si)|back(?:ground-cl|d|f)|box-d|(?:mask(?:$|-[ispro]|-cl)))|(tab-|column(?!-s)|text-align-l)|(ap)|(u|hy))/i.exec(i2);
          return n3 ? n3[1] ? 1 : n3[2] ? 2 : n3[3] ? 3 : 5 : 0;
        }(n2);
        1 & o2 && (t2 += `-webkit-${n2}:${r};`), 2 & o2 && (t2 += `-moz-${n2}:${r};`), 4 & o2 && (t2 += `-ms-${n2}:${r};`);
        const l2 = function(i2, n3) {
          var r2 = /^(?:(pos)|(background-i)|((?:max-|min-)?(?:block-s|inl|he|widt))|(dis))/i.exec(i2);
          return r2 ? r2[1] ? /^sti/i.test(n3) ? 1 : 0 : r2[2] ? /^image-/i.test(n3) ? 1 : 0 : r2[3] ? "-" === n3[3] ? 2 : 0 : /^(inline-)?grid$/i.test(n3) ? 4 : 0 : 0;
        }(n2, r);
        return 1 & l2 ? t2 += `${n2}:-webkit-${r};` : 2 & l2 ? t2 += `${n2}:-moz-${r};` : 4 & l2 && (t2 += `${n2}:-ms-${r};`), t2 += `${n2}:${r};`, t2;
      }
      const get = (value, path, defaultValue) => {
        const segments = path.split(/[\.\[\]]/g);
        let current = value;
        for (const key of segments) {
          if (current === null)
            return defaultValue;
          if (current === void 0)
            return defaultValue;
          const dequoted = key.replace(/['"]/g, "");
          if (dequoted.trim() === "")
            continue;
          current = current[dequoted];
        }
        if (current === void 0)
          return defaultValue;
        return current;
      };
      var client = {};
      var reactDom = { exports: {} };
      var reactDom_production_min = {};
      var scheduler = { exports: {} };
      var scheduler_production_min = {};
      /**
       * @license React
       * scheduler.production.min.js
       *
       * Copyright (c) Facebook, Inc. and its affiliates.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */
      var hasRequiredScheduler_production_min;
      function requireScheduler_production_min() {
        if (hasRequiredScheduler_production_min) return scheduler_production_min;
        hasRequiredScheduler_production_min = 1;
        (function(exports2) {
          function f2(a2, b) {
            var c2 = a2.length;
            a2.push(b);
            a: for (; 0 < c2; ) {
              var d2 = c2 - 1 >>> 1, e2 = a2[d2];
              if (0 < g2(e2, b)) a2[d2] = b, a2[c2] = e2, c2 = d2;
              else break a;
            }
          }
          function h2(a2) {
            return 0 === a2.length ? null : a2[0];
          }
          function k(a2) {
            if (0 === a2.length) return null;
            var b = a2[0], c2 = a2.pop();
            if (c2 !== b) {
              a2[0] = c2;
              a: for (var d2 = 0, e2 = a2.length, w = e2 >>> 1; d2 < w; ) {
                var m2 = 2 * (d2 + 1) - 1, C = a2[m2], n2 = m2 + 1, x = a2[n2];
                if (0 > g2(C, c2)) n2 < e2 && 0 > g2(x, C) ? (a2[d2] = x, a2[n2] = c2, d2 = n2) : (a2[d2] = C, a2[m2] = c2, d2 = m2);
                else if (n2 < e2 && 0 > g2(x, c2)) a2[d2] = x, a2[n2] = c2, d2 = n2;
                else break a;
              }
            }
            return b;
          }
          function g2(a2, b) {
            var c2 = a2.sortIndex - b.sortIndex;
            return 0 !== c2 ? c2 : a2.id - b.id;
          }
          if ("object" === typeof performance && "function" === typeof performance.now) {
            var l2 = performance;
            exports2.unstable_now = function() {
              return l2.now();
            };
          } else {
            var p2 = Date, q = p2.now();
            exports2.unstable_now = function() {
              return p2.now() - q;
            };
          }
          var r = [], t2 = [], u2 = 1, v = null, y = 3, z = false, A = false, B = false, D = "function" === typeof setTimeout ? setTimeout : null, E = "function" === typeof clearTimeout ? clearTimeout : null, F = "undefined" !== typeof setImmediate ? setImmediate : null;
          "undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
          function G(a2) {
            for (var b = h2(t2); null !== b; ) {
              if (null === b.callback) k(t2);
              else if (b.startTime <= a2) k(t2), b.sortIndex = b.expirationTime, f2(r, b);
              else break;
              b = h2(t2);
            }
          }
          function H(a2) {
            B = false;
            G(a2);
            if (!A) if (null !== h2(r)) A = true, I(J);
            else {
              var b = h2(t2);
              null !== b && K(H, b.startTime - a2);
            }
          }
          function J(a2, b) {
            A = false;
            B && (B = false, E(L), L = -1);
            z = true;
            var c2 = y;
            try {
              G(b);
              for (v = h2(r); null !== v && (!(v.expirationTime > b) || a2 && !M()); ) {
                var d2 = v.callback;
                if ("function" === typeof d2) {
                  v.callback = null;
                  y = v.priorityLevel;
                  var e2 = d2(v.expirationTime <= b);
                  b = exports2.unstable_now();
                  "function" === typeof e2 ? v.callback = e2 : v === h2(r) && k(r);
                  G(b);
                } else k(r);
                v = h2(r);
              }
              if (null !== v) var w = true;
              else {
                var m2 = h2(t2);
                null !== m2 && K(H, m2.startTime - b);
                w = false;
              }
              return w;
            } finally {
              v = null, y = c2, z = false;
            }
          }
          var N = false, O = null, L = -1, P = 5, Q = -1;
          function M() {
            return exports2.unstable_now() - Q < P ? false : true;
          }
          function R() {
            if (null !== O) {
              var a2 = exports2.unstable_now();
              Q = a2;
              var b = true;
              try {
                b = O(true, a2);
              } finally {
                b ? S() : (N = false, O = null);
              }
            } else N = false;
          }
          var S;
          if ("function" === typeof F) S = function() {
            F(R);
          };
          else if ("undefined" !== typeof MessageChannel) {
            var T = new MessageChannel(), U = T.port2;
            T.port1.onmessage = R;
            S = function() {
              U.postMessage(null);
            };
          } else S = function() {
            D(R, 0);
          };
          function I(a2) {
            O = a2;
            N || (N = true, S());
          }
          function K(a2, b) {
            L = D(function() {
              a2(exports2.unstable_now());
            }, b);
          }
          exports2.unstable_IdlePriority = 5;
          exports2.unstable_ImmediatePriority = 1;
          exports2.unstable_LowPriority = 4;
          exports2.unstable_NormalPriority = 3;
          exports2.unstable_Profiling = null;
          exports2.unstable_UserBlockingPriority = 2;
          exports2.unstable_cancelCallback = function(a2) {
            a2.callback = null;
          };
          exports2.unstable_continueExecution = function() {
            A || z || (A = true, I(J));
          };
          exports2.unstable_forceFrameRate = function(a2) {
            0 > a2 || 125 < a2 ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : P = 0 < a2 ? Math.floor(1e3 / a2) : 5;
          };
          exports2.unstable_getCurrentPriorityLevel = function() {
            return y;
          };
          exports2.unstable_getFirstCallbackNode = function() {
            return h2(r);
          };
          exports2.unstable_next = function(a2) {
            switch (y) {
              case 1:
              case 2:
              case 3:
                var b = 3;
                break;
              default:
                b = y;
            }
            var c2 = y;
            y = b;
            try {
              return a2();
            } finally {
              y = c2;
            }
          };
          exports2.unstable_pauseExecution = function() {
          };
          exports2.unstable_requestPaint = function() {
          };
          exports2.unstable_runWithPriority = function(a2, b) {
            switch (a2) {
              case 1:
              case 2:
              case 3:
              case 4:
              case 5:
                break;
              default:
                a2 = 3;
            }
            var c2 = y;
            y = a2;
            try {
              return b();
            } finally {
              y = c2;
            }
          };
          exports2.unstable_scheduleCallback = function(a2, b, c2) {
            var d2 = exports2.unstable_now();
            "object" === typeof c2 && null !== c2 ? (c2 = c2.delay, c2 = "number" === typeof c2 && 0 < c2 ? d2 + c2 : d2) : c2 = d2;
            switch (a2) {
              case 1:
                var e2 = -1;
                break;
              case 2:
                e2 = 250;
                break;
              case 5:
                e2 = 1073741823;
                break;
              case 4:
                e2 = 1e4;
                break;
              default:
                e2 = 5e3;
            }
            e2 = c2 + e2;
            a2 = { id: u2++, callback: b, priorityLevel: a2, startTime: c2, expirationTime: e2, sortIndex: -1 };
            c2 > d2 ? (a2.sortIndex = c2, f2(t2, a2), null === h2(r) && a2 === h2(t2) && (B ? (E(L), L = -1) : B = true, K(H, c2 - d2))) : (a2.sortIndex = e2, f2(r, a2), A || z || (A = true, I(J)));
            return a2;
          };
          exports2.unstable_shouldYield = M;
          exports2.unstable_wrapCallback = function(a2) {
            var b = y;
            return function() {
              var c2 = y;
              y = b;
              try {
                return a2.apply(this, arguments);
              } finally {
                y = c2;
              }
            };
          };
        })(scheduler_production_min);
        return scheduler_production_min;
      }
      var hasRequiredScheduler;
      function requireScheduler() {
        if (hasRequiredScheduler) return scheduler.exports;
        hasRequiredScheduler = 1;
        {
          scheduler.exports = requireScheduler_production_min();
        }
        return scheduler.exports;
      }
      /**
       * @license React
       * react-dom.production.min.js
       *
       * Copyright (c) Facebook, Inc. and its affiliates.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */
      var hasRequiredReactDom_production_min;
      function requireReactDom_production_min() {
        if (hasRequiredReactDom_production_min) return reactDom_production_min;
        hasRequiredReactDom_production_min = 1;
        var aa = requireReact(), ca = requireScheduler();
        function p2(a2) {
          for (var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a2, c2 = 1; c2 < arguments.length; c2++) b += "&args[]=" + encodeURIComponent(arguments[c2]);
          return "Minified React error #" + a2 + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
        }
        var da = /* @__PURE__ */ new Set(), ea = {};
        function fa(a2, b) {
          ha(a2, b);
          ha(a2 + "Capture", b);
        }
        function ha(a2, b) {
          ea[a2] = b;
          for (a2 = 0; a2 < b.length; a2++) da.add(b[a2]);
        }
        var ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ja = Object.prototype.hasOwnProperty, ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, la = {}, ma = {};
        function oa(a2) {
          if (ja.call(ma, a2)) return true;
          if (ja.call(la, a2)) return false;
          if (ka.test(a2)) return ma[a2] = true;
          la[a2] = true;
          return false;
        }
        function pa(a2, b, c2, d2) {
          if (null !== c2 && 0 === c2.type) return false;
          switch (typeof b) {
            case "function":
            case "symbol":
              return true;
            case "boolean":
              if (d2) return false;
              if (null !== c2) return !c2.acceptsBooleans;
              a2 = a2.toLowerCase().slice(0, 5);
              return "data-" !== a2 && "aria-" !== a2;
            default:
              return false;
          }
        }
        function qa(a2, b, c2, d2) {
          if (null === b || "undefined" === typeof b || pa(a2, b, c2, d2)) return true;
          if (d2) return false;
          if (null !== c2) switch (c2.type) {
            case 3:
              return !b;
            case 4:
              return false === b;
            case 5:
              return isNaN(b);
            case 6:
              return isNaN(b) || 1 > b;
          }
          return false;
        }
        function v(a2, b, c2, d2, e2, f2, g2) {
          this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
          this.attributeName = d2;
          this.attributeNamespace = e2;
          this.mustUseProperty = c2;
          this.propertyName = a2;
          this.type = b;
          this.sanitizeURL = f2;
          this.removeEmptyString = g2;
        }
        var z = {};
        "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a2) {
          z[a2] = new v(a2, 0, false, a2, null, false, false);
        });
        [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(a2) {
          var b = a2[0];
          z[b] = new v(b, 1, false, a2[1], null, false, false);
        });
        ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(a2) {
          z[a2] = new v(a2, 2, false, a2.toLowerCase(), null, false, false);
        });
        ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(a2) {
          z[a2] = new v(a2, 2, false, a2, null, false, false);
        });
        "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a2) {
          z[a2] = new v(a2, 3, false, a2.toLowerCase(), null, false, false);
        });
        ["checked", "multiple", "muted", "selected"].forEach(function(a2) {
          z[a2] = new v(a2, 3, true, a2, null, false, false);
        });
        ["capture", "download"].forEach(function(a2) {
          z[a2] = new v(a2, 4, false, a2, null, false, false);
        });
        ["cols", "rows", "size", "span"].forEach(function(a2) {
          z[a2] = new v(a2, 6, false, a2, null, false, false);
        });
        ["rowSpan", "start"].forEach(function(a2) {
          z[a2] = new v(a2, 5, false, a2.toLowerCase(), null, false, false);
        });
        var ra = /[\-:]([a-z])/g;
        function sa(a2) {
          return a2[1].toUpperCase();
        }
        "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a2) {
          var b = a2.replace(
            ra,
            sa
          );
          z[b] = new v(b, 1, false, a2, null, false, false);
        });
        "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a2) {
          var b = a2.replace(ra, sa);
          z[b] = new v(b, 1, false, a2, "http://www.w3.org/1999/xlink", false, false);
        });
        ["xml:base", "xml:lang", "xml:space"].forEach(function(a2) {
          var b = a2.replace(ra, sa);
          z[b] = new v(b, 1, false, a2, "http://www.w3.org/XML/1998/namespace", false, false);
        });
        ["tabIndex", "crossOrigin"].forEach(function(a2) {
          z[a2] = new v(a2, 1, false, a2.toLowerCase(), null, false, false);
        });
        z.xlinkHref = new v("xlinkHref", 1, false, "xlink:href", "http://www.w3.org/1999/xlink", true, false);
        ["src", "href", "action", "formAction"].forEach(function(a2) {
          z[a2] = new v(a2, 1, false, a2.toLowerCase(), null, true, true);
        });
        function ta(a2, b, c2, d2) {
          var e2 = z.hasOwnProperty(b) ? z[b] : null;
          if (null !== e2 ? 0 !== e2.type : d2 || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) qa(b, c2, e2, d2) && (c2 = null), d2 || null === e2 ? oa(b) && (null === c2 ? a2.removeAttribute(b) : a2.setAttribute(b, "" + c2)) : e2.mustUseProperty ? a2[e2.propertyName] = null === c2 ? 3 === e2.type ? false : "" : c2 : (b = e2.attributeName, d2 = e2.attributeNamespace, null === c2 ? a2.removeAttribute(b) : (e2 = e2.type, c2 = 3 === e2 || 4 === e2 && true === c2 ? "" : "" + c2, d2 ? a2.setAttributeNS(d2, b, c2) : a2.setAttribute(b, c2)));
        }
        var ua = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, va = Symbol.for("react.element"), wa = Symbol.for("react.portal"), ya = Symbol.for("react.fragment"), za = Symbol.for("react.strict_mode"), Aa = Symbol.for("react.profiler"), Ba = Symbol.for("react.provider"), Ca = Symbol.for("react.context"), Da = Symbol.for("react.forward_ref"), Ea = Symbol.for("react.suspense"), Fa = Symbol.for("react.suspense_list"), Ga = Symbol.for("react.memo"), Ha = Symbol.for("react.lazy");
        var Ia = Symbol.for("react.offscreen");
        var Ja = Symbol.iterator;
        function Ka(a2) {
          if (null === a2 || "object" !== typeof a2) return null;
          a2 = Ja && a2[Ja] || a2["@@iterator"];
          return "function" === typeof a2 ? a2 : null;
        }
        var A = Object.assign, La;
        function Ma(a2) {
          if (void 0 === La) try {
            throw Error();
          } catch (c2) {
            var b = c2.stack.trim().match(/\n( *(at )?)/);
            La = b && b[1] || "";
          }
          return "\n" + La + a2;
        }
        var Na = false;
        function Oa(a2, b) {
          if (!a2 || Na) return "";
          Na = true;
          var c2 = Error.prepareStackTrace;
          Error.prepareStackTrace = void 0;
          try {
            if (b) if (b = function() {
              throw Error();
            }, Object.defineProperty(b.prototype, "props", { set: function() {
              throw Error();
            } }), "object" === typeof Reflect && Reflect.construct) {
              try {
                Reflect.construct(b, []);
              } catch (l2) {
                var d2 = l2;
              }
              Reflect.construct(a2, [], b);
            } else {
              try {
                b.call();
              } catch (l2) {
                d2 = l2;
              }
              a2.call(b.prototype);
            }
            else {
              try {
                throw Error();
              } catch (l2) {
                d2 = l2;
              }
              a2();
            }
          } catch (l2) {
            if (l2 && d2 && "string" === typeof l2.stack) {
              for (var e2 = l2.stack.split("\n"), f2 = d2.stack.split("\n"), g2 = e2.length - 1, h2 = f2.length - 1; 1 <= g2 && 0 <= h2 && e2[g2] !== f2[h2]; ) h2--;
              for (; 1 <= g2 && 0 <= h2; g2--, h2--) if (e2[g2] !== f2[h2]) {
                if (1 !== g2 || 1 !== h2) {
                  do
                    if (g2--, h2--, 0 > h2 || e2[g2] !== f2[h2]) {
                      var k = "\n" + e2[g2].replace(" at new ", " at ");
                      a2.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a2.displayName));
                      return k;
                    }
                  while (1 <= g2 && 0 <= h2);
                }
                break;
              }
            }
          } finally {
            Na = false, Error.prepareStackTrace = c2;
          }
          return (a2 = a2 ? a2.displayName || a2.name : "") ? Ma(a2) : "";
        }
        function Pa(a2) {
          switch (a2.tag) {
            case 5:
              return Ma(a2.type);
            case 16:
              return Ma("Lazy");
            case 13:
              return Ma("Suspense");
            case 19:
              return Ma("SuspenseList");
            case 0:
            case 2:
            case 15:
              return a2 = Oa(a2.type, false), a2;
            case 11:
              return a2 = Oa(a2.type.render, false), a2;
            case 1:
              return a2 = Oa(a2.type, true), a2;
            default:
              return "";
          }
        }
        function Qa(a2) {
          if (null == a2) return null;
          if ("function" === typeof a2) return a2.displayName || a2.name || null;
          if ("string" === typeof a2) return a2;
          switch (a2) {
            case ya:
              return "Fragment";
            case wa:
              return "Portal";
            case Aa:
              return "Profiler";
            case za:
              return "StrictMode";
            case Ea:
              return "Suspense";
            case Fa:
              return "SuspenseList";
          }
          if ("object" === typeof a2) switch (a2.$$typeof) {
            case Ca:
              return (a2.displayName || "Context") + ".Consumer";
            case Ba:
              return (a2._context.displayName || "Context") + ".Provider";
            case Da:
              var b = a2.render;
              a2 = a2.displayName;
              a2 || (a2 = b.displayName || b.name || "", a2 = "" !== a2 ? "ForwardRef(" + a2 + ")" : "ForwardRef");
              return a2;
            case Ga:
              return b = a2.displayName || null, null !== b ? b : Qa(a2.type) || "Memo";
            case Ha:
              b = a2._payload;
              a2 = a2._init;
              try {
                return Qa(a2(b));
              } catch (c2) {
              }
          }
          return null;
        }
        function Ra(a2) {
          var b = a2.type;
          switch (a2.tag) {
            case 24:
              return "Cache";
            case 9:
              return (b.displayName || "Context") + ".Consumer";
            case 10:
              return (b._context.displayName || "Context") + ".Provider";
            case 18:
              return "DehydratedFragment";
            case 11:
              return a2 = b.render, a2 = a2.displayName || a2.name || "", b.displayName || ("" !== a2 ? "ForwardRef(" + a2 + ")" : "ForwardRef");
            case 7:
              return "Fragment";
            case 5:
              return b;
            case 4:
              return "Portal";
            case 3:
              return "Root";
            case 6:
              return "Text";
            case 16:
              return Qa(b);
            case 8:
              return b === za ? "StrictMode" : "Mode";
            case 22:
              return "Offscreen";
            case 12:
              return "Profiler";
            case 21:
              return "Scope";
            case 13:
              return "Suspense";
            case 19:
              return "SuspenseList";
            case 25:
              return "TracingMarker";
            case 1:
            case 0:
            case 17:
            case 2:
            case 14:
            case 15:
              if ("function" === typeof b) return b.displayName || b.name || null;
              if ("string" === typeof b) return b;
          }
          return null;
        }
        function Sa(a2) {
          switch (typeof a2) {
            case "boolean":
            case "number":
            case "string":
            case "undefined":
              return a2;
            case "object":
              return a2;
            default:
              return "";
          }
        }
        function Ta(a2) {
          var b = a2.type;
          return (a2 = a2.nodeName) && "input" === a2.toLowerCase() && ("checkbox" === b || "radio" === b);
        }
        function Ua(a2) {
          var b = Ta(a2) ? "checked" : "value", c2 = Object.getOwnPropertyDescriptor(a2.constructor.prototype, b), d2 = "" + a2[b];
          if (!a2.hasOwnProperty(b) && "undefined" !== typeof c2 && "function" === typeof c2.get && "function" === typeof c2.set) {
            var e2 = c2.get, f2 = c2.set;
            Object.defineProperty(a2, b, { configurable: true, get: function() {
              return e2.call(this);
            }, set: function(a3) {
              d2 = "" + a3;
              f2.call(this, a3);
            } });
            Object.defineProperty(a2, b, { enumerable: c2.enumerable });
            return { getValue: function() {
              return d2;
            }, setValue: function(a3) {
              d2 = "" + a3;
            }, stopTracking: function() {
              a2._valueTracker = null;
              delete a2[b];
            } };
          }
        }
        function Va(a2) {
          a2._valueTracker || (a2._valueTracker = Ua(a2));
        }
        function Wa(a2) {
          if (!a2) return false;
          var b = a2._valueTracker;
          if (!b) return true;
          var c2 = b.getValue();
          var d2 = "";
          a2 && (d2 = Ta(a2) ? a2.checked ? "true" : "false" : a2.value);
          a2 = d2;
          return a2 !== c2 ? (b.setValue(a2), true) : false;
        }
        function Xa(a2) {
          a2 = a2 || ("undefined" !== typeof document ? document : void 0);
          if ("undefined" === typeof a2) return null;
          try {
            return a2.activeElement || a2.body;
          } catch (b) {
            return a2.body;
          }
        }
        function Ya(a2, b) {
          var c2 = b.checked;
          return A({}, b, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: null != c2 ? c2 : a2._wrapperState.initialChecked });
        }
        function Za(a2, b) {
          var c2 = null == b.defaultValue ? "" : b.defaultValue, d2 = null != b.checked ? b.checked : b.defaultChecked;
          c2 = Sa(null != b.value ? b.value : c2);
          a2._wrapperState = { initialChecked: d2, initialValue: c2, controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value };
        }
        function ab(a2, b) {
          b = b.checked;
          null != b && ta(a2, "checked", b, false);
        }
        function bb(a2, b) {
          ab(a2, b);
          var c2 = Sa(b.value), d2 = b.type;
          if (null != c2) if ("number" === d2) {
            if (0 === c2 && "" === a2.value || a2.value != c2) a2.value = "" + c2;
          } else a2.value !== "" + c2 && (a2.value = "" + c2);
          else if ("submit" === d2 || "reset" === d2) {
            a2.removeAttribute("value");
            return;
          }
          b.hasOwnProperty("value") ? cb(a2, b.type, c2) : b.hasOwnProperty("defaultValue") && cb(a2, b.type, Sa(b.defaultValue));
          null == b.checked && null != b.defaultChecked && (a2.defaultChecked = !!b.defaultChecked);
        }
        function db(a2, b, c2) {
          if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
            var d2 = b.type;
            if (!("submit" !== d2 && "reset" !== d2 || void 0 !== b.value && null !== b.value)) return;
            b = "" + a2._wrapperState.initialValue;
            c2 || b === a2.value || (a2.value = b);
            a2.defaultValue = b;
          }
          c2 = a2.name;
          "" !== c2 && (a2.name = "");
          a2.defaultChecked = !!a2._wrapperState.initialChecked;
          "" !== c2 && (a2.name = c2);
        }
        function cb(a2, b, c2) {
          if ("number" !== b || Xa(a2.ownerDocument) !== a2) null == c2 ? a2.defaultValue = "" + a2._wrapperState.initialValue : a2.defaultValue !== "" + c2 && (a2.defaultValue = "" + c2);
        }
        var eb = Array.isArray;
        function fb(a2, b, c2, d2) {
          a2 = a2.options;
          if (b) {
            b = {};
            for (var e2 = 0; e2 < c2.length; e2++) b["$" + c2[e2]] = true;
            for (c2 = 0; c2 < a2.length; c2++) e2 = b.hasOwnProperty("$" + a2[c2].value), a2[c2].selected !== e2 && (a2[c2].selected = e2), e2 && d2 && (a2[c2].defaultSelected = true);
          } else {
            c2 = "" + Sa(c2);
            b = null;
            for (e2 = 0; e2 < a2.length; e2++) {
              if (a2[e2].value === c2) {
                a2[e2].selected = true;
                d2 && (a2[e2].defaultSelected = true);
                return;
              }
              null !== b || a2[e2].disabled || (b = a2[e2]);
            }
            null !== b && (b.selected = true);
          }
        }
        function gb(a2, b) {
          if (null != b.dangerouslySetInnerHTML) throw Error(p2(91));
          return A({}, b, { value: void 0, defaultValue: void 0, children: "" + a2._wrapperState.initialValue });
        }
        function hb(a2, b) {
          var c2 = b.value;
          if (null == c2) {
            c2 = b.children;
            b = b.defaultValue;
            if (null != c2) {
              if (null != b) throw Error(p2(92));
              if (eb(c2)) {
                if (1 < c2.length) throw Error(p2(93));
                c2 = c2[0];
              }
              b = c2;
            }
            null == b && (b = "");
            c2 = b;
          }
          a2._wrapperState = { initialValue: Sa(c2) };
        }
        function ib(a2, b) {
          var c2 = Sa(b.value), d2 = Sa(b.defaultValue);
          null != c2 && (c2 = "" + c2, c2 !== a2.value && (a2.value = c2), null == b.defaultValue && a2.defaultValue !== c2 && (a2.defaultValue = c2));
          null != d2 && (a2.defaultValue = "" + d2);
        }
        function jb(a2) {
          var b = a2.textContent;
          b === a2._wrapperState.initialValue && "" !== b && null !== b && (a2.value = b);
        }
        function kb(a2) {
          switch (a2) {
            case "svg":
              return "http://www.w3.org/2000/svg";
            case "math":
              return "http://www.w3.org/1998/Math/MathML";
            default:
              return "http://www.w3.org/1999/xhtml";
          }
        }
        function lb(a2, b) {
          return null == a2 || "http://www.w3.org/1999/xhtml" === a2 ? kb(b) : "http://www.w3.org/2000/svg" === a2 && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a2;
        }
        var mb, nb = function(a2) {
          return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c2, d2, e2) {
            MSApp.execUnsafeLocalFunction(function() {
              return a2(b, c2, d2, e2);
            });
          } : a2;
        }(function(a2, b) {
          if ("http://www.w3.org/2000/svg" !== a2.namespaceURI || "innerHTML" in a2) a2.innerHTML = b;
          else {
            mb = mb || document.createElement("div");
            mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
            for (b = mb.firstChild; a2.firstChild; ) a2.removeChild(a2.firstChild);
            for (; b.firstChild; ) a2.appendChild(b.firstChild);
          }
        });
        function ob(a2, b) {
          if (b) {
            var c2 = a2.firstChild;
            if (c2 && c2 === a2.lastChild && 3 === c2.nodeType) {
              c2.nodeValue = b;
              return;
            }
          }
          a2.textContent = b;
        }
        var pb = {
          animationIterationCount: true,
          aspectRatio: true,
          borderImageOutset: true,
          borderImageSlice: true,
          borderImageWidth: true,
          boxFlex: true,
          boxFlexGroup: true,
          boxOrdinalGroup: true,
          columnCount: true,
          columns: true,
          flex: true,
          flexGrow: true,
          flexPositive: true,
          flexShrink: true,
          flexNegative: true,
          flexOrder: true,
          gridArea: true,
          gridRow: true,
          gridRowEnd: true,
          gridRowSpan: true,
          gridRowStart: true,
          gridColumn: true,
          gridColumnEnd: true,
          gridColumnSpan: true,
          gridColumnStart: true,
          fontWeight: true,
          lineClamp: true,
          lineHeight: true,
          opacity: true,
          order: true,
          orphans: true,
          tabSize: true,
          widows: true,
          zIndex: true,
          zoom: true,
          fillOpacity: true,
          floodOpacity: true,
          stopOpacity: true,
          strokeDasharray: true,
          strokeDashoffset: true,
          strokeMiterlimit: true,
          strokeOpacity: true,
          strokeWidth: true
        }, qb = ["Webkit", "ms", "Moz", "O"];
        Object.keys(pb).forEach(function(a2) {
          qb.forEach(function(b) {
            b = b + a2.charAt(0).toUpperCase() + a2.substring(1);
            pb[b] = pb[a2];
          });
        });
        function rb(a2, b, c2) {
          return null == b || "boolean" === typeof b || "" === b ? "" : c2 || "number" !== typeof b || 0 === b || pb.hasOwnProperty(a2) && pb[a2] ? ("" + b).trim() : b + "px";
        }
        function sb(a2, b) {
          a2 = a2.style;
          for (var c2 in b) if (b.hasOwnProperty(c2)) {
            var d2 = 0 === c2.indexOf("--"), e2 = rb(c2, b[c2], d2);
            "float" === c2 && (c2 = "cssFloat");
            d2 ? a2.setProperty(c2, e2) : a2[c2] = e2;
          }
        }
        var tb = A({ menuitem: true }, { area: true, base: true, br: true, col: true, embed: true, hr: true, img: true, input: true, keygen: true, link: true, meta: true, param: true, source: true, track: true, wbr: true });
        function ub(a2, b) {
          if (b) {
            if (tb[a2] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(p2(137, a2));
            if (null != b.dangerouslySetInnerHTML) {
              if (null != b.children) throw Error(p2(60));
              if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error(p2(61));
            }
            if (null != b.style && "object" !== typeof b.style) throw Error(p2(62));
          }
        }
        function vb(a2, b) {
          if (-1 === a2.indexOf("-")) return "string" === typeof b.is;
          switch (a2) {
            case "annotation-xml":
            case "color-profile":
            case "font-face":
            case "font-face-src":
            case "font-face-uri":
            case "font-face-format":
            case "font-face-name":
            case "missing-glyph":
              return false;
            default:
              return true;
          }
        }
        var wb = null;
        function xb(a2) {
          a2 = a2.target || a2.srcElement || window;
          a2.correspondingUseElement && (a2 = a2.correspondingUseElement);
          return 3 === a2.nodeType ? a2.parentNode : a2;
        }
        var yb = null, zb = null, Ab = null;
        function Bb(a2) {
          if (a2 = Cb(a2)) {
            if ("function" !== typeof yb) throw Error(p2(280));
            var b = a2.stateNode;
            b && (b = Db(b), yb(a2.stateNode, a2.type, b));
          }
        }
        function Eb(a2) {
          zb ? Ab ? Ab.push(a2) : Ab = [a2] : zb = a2;
        }
        function Fb() {
          if (zb) {
            var a2 = zb, b = Ab;
            Ab = zb = null;
            Bb(a2);
            if (b) for (a2 = 0; a2 < b.length; a2++) Bb(b[a2]);
          }
        }
        function Gb(a2, b) {
          return a2(b);
        }
        function Hb() {
        }
        var Ib = false;
        function Jb(a2, b, c2) {
          if (Ib) return a2(b, c2);
          Ib = true;
          try {
            return Gb(a2, b, c2);
          } finally {
            if (Ib = false, null !== zb || null !== Ab) Hb(), Fb();
          }
        }
        function Kb(a2, b) {
          var c2 = a2.stateNode;
          if (null === c2) return null;
          var d2 = Db(c2);
          if (null === d2) return null;
          c2 = d2[b];
          a: switch (b) {
            case "onClick":
            case "onClickCapture":
            case "onDoubleClick":
            case "onDoubleClickCapture":
            case "onMouseDown":
            case "onMouseDownCapture":
            case "onMouseMove":
            case "onMouseMoveCapture":
            case "onMouseUp":
            case "onMouseUpCapture":
            case "onMouseEnter":
              (d2 = !d2.disabled) || (a2 = a2.type, d2 = !("button" === a2 || "input" === a2 || "select" === a2 || "textarea" === a2));
              a2 = !d2;
              break a;
            default:
              a2 = false;
          }
          if (a2) return null;
          if (c2 && "function" !== typeof c2) throw Error(p2(231, b, typeof c2));
          return c2;
        }
        var Lb = false;
        if (ia) try {
          var Mb = {};
          Object.defineProperty(Mb, "passive", { get: function() {
            Lb = true;
          } });
          window.addEventListener("test", Mb, Mb);
          window.removeEventListener("test", Mb, Mb);
        } catch (a2) {
          Lb = false;
        }
        function Nb(a2, b, c2, d2, e2, f2, g2, h2, k) {
          var l2 = Array.prototype.slice.call(arguments, 3);
          try {
            b.apply(c2, l2);
          } catch (m2) {
            this.onError(m2);
          }
        }
        var Ob = false, Pb = null, Qb = false, Rb = null, Sb = { onError: function(a2) {
          Ob = true;
          Pb = a2;
        } };
        function Tb(a2, b, c2, d2, e2, f2, g2, h2, k) {
          Ob = false;
          Pb = null;
          Nb.apply(Sb, arguments);
        }
        function Ub(a2, b, c2, d2, e2, f2, g2, h2, k) {
          Tb.apply(this, arguments);
          if (Ob) {
            if (Ob) {
              var l2 = Pb;
              Ob = false;
              Pb = null;
            } else throw Error(p2(198));
            Qb || (Qb = true, Rb = l2);
          }
        }
        function Vb(a2) {
          var b = a2, c2 = a2;
          if (a2.alternate) for (; b.return; ) b = b.return;
          else {
            a2 = b;
            do
              b = a2, 0 !== (b.flags & 4098) && (c2 = b.return), a2 = b.return;
            while (a2);
          }
          return 3 === b.tag ? c2 : null;
        }
        function Wb(a2) {
          if (13 === a2.tag) {
            var b = a2.memoizedState;
            null === b && (a2 = a2.alternate, null !== a2 && (b = a2.memoizedState));
            if (null !== b) return b.dehydrated;
          }
          return null;
        }
        function Xb(a2) {
          if (Vb(a2) !== a2) throw Error(p2(188));
        }
        function Yb(a2) {
          var b = a2.alternate;
          if (!b) {
            b = Vb(a2);
            if (null === b) throw Error(p2(188));
            return b !== a2 ? null : a2;
          }
          for (var c2 = a2, d2 = b; ; ) {
            var e2 = c2.return;
            if (null === e2) break;
            var f2 = e2.alternate;
            if (null === f2) {
              d2 = e2.return;
              if (null !== d2) {
                c2 = d2;
                continue;
              }
              break;
            }
            if (e2.child === f2.child) {
              for (f2 = e2.child; f2; ) {
                if (f2 === c2) return Xb(e2), a2;
                if (f2 === d2) return Xb(e2), b;
                f2 = f2.sibling;
              }
              throw Error(p2(188));
            }
            if (c2.return !== d2.return) c2 = e2, d2 = f2;
            else {
              for (var g2 = false, h2 = e2.child; h2; ) {
                if (h2 === c2) {
                  g2 = true;
                  c2 = e2;
                  d2 = f2;
                  break;
                }
                if (h2 === d2) {
                  g2 = true;
                  d2 = e2;
                  c2 = f2;
                  break;
                }
                h2 = h2.sibling;
              }
              if (!g2) {
                for (h2 = f2.child; h2; ) {
                  if (h2 === c2) {
                    g2 = true;
                    c2 = f2;
                    d2 = e2;
                    break;
                  }
                  if (h2 === d2) {
                    g2 = true;
                    d2 = f2;
                    c2 = e2;
                    break;
                  }
                  h2 = h2.sibling;
                }
                if (!g2) throw Error(p2(189));
              }
            }
            if (c2.alternate !== d2) throw Error(p2(190));
          }
          if (3 !== c2.tag) throw Error(p2(188));
          return c2.stateNode.current === c2 ? a2 : b;
        }
        function Zb(a2) {
          a2 = Yb(a2);
          return null !== a2 ? $b(a2) : null;
        }
        function $b(a2) {
          if (5 === a2.tag || 6 === a2.tag) return a2;
          for (a2 = a2.child; null !== a2; ) {
            var b = $b(a2);
            if (null !== b) return b;
            a2 = a2.sibling;
          }
          return null;
        }
        var ac = ca.unstable_scheduleCallback, bc = ca.unstable_cancelCallback, cc = ca.unstable_shouldYield, dc = ca.unstable_requestPaint, B = ca.unstable_now, ec = ca.unstable_getCurrentPriorityLevel, fc = ca.unstable_ImmediatePriority, gc = ca.unstable_UserBlockingPriority, hc = ca.unstable_NormalPriority, ic = ca.unstable_LowPriority, jc = ca.unstable_IdlePriority, kc = null, lc = null;
        function mc(a2) {
          if (lc && "function" === typeof lc.onCommitFiberRoot) try {
            lc.onCommitFiberRoot(kc, a2, void 0, 128 === (a2.current.flags & 128));
          } catch (b) {
          }
        }
        var oc = Math.clz32 ? Math.clz32 : nc, pc = Math.log, qc = Math.LN2;
        function nc(a2) {
          a2 >>>= 0;
          return 0 === a2 ? 32 : 31 - (pc(a2) / qc | 0) | 0;
        }
        var rc = 64, sc = 4194304;
        function tc(a2) {
          switch (a2 & -a2) {
            case 1:
              return 1;
            case 2:
              return 2;
            case 4:
              return 4;
            case 8:
              return 8;
            case 16:
              return 16;
            case 32:
              return 32;
            case 64:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
              return a2 & 4194240;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
            case 67108864:
              return a2 & 130023424;
            case 134217728:
              return 134217728;
            case 268435456:
              return 268435456;
            case 536870912:
              return 536870912;
            case 1073741824:
              return 1073741824;
            default:
              return a2;
          }
        }
        function uc(a2, b) {
          var c2 = a2.pendingLanes;
          if (0 === c2) return 0;
          var d2 = 0, e2 = a2.suspendedLanes, f2 = a2.pingedLanes, g2 = c2 & 268435455;
          if (0 !== g2) {
            var h2 = g2 & ~e2;
            0 !== h2 ? d2 = tc(h2) : (f2 &= g2, 0 !== f2 && (d2 = tc(f2)));
          } else g2 = c2 & ~e2, 0 !== g2 ? d2 = tc(g2) : 0 !== f2 && (d2 = tc(f2));
          if (0 === d2) return 0;
          if (0 !== b && b !== d2 && 0 === (b & e2) && (e2 = d2 & -d2, f2 = b & -b, e2 >= f2 || 16 === e2 && 0 !== (f2 & 4194240))) return b;
          0 !== (d2 & 4) && (d2 |= c2 & 16);
          b = a2.entangledLanes;
          if (0 !== b) for (a2 = a2.entanglements, b &= d2; 0 < b; ) c2 = 31 - oc(b), e2 = 1 << c2, d2 |= a2[c2], b &= ~e2;
          return d2;
        }
        function vc(a2, b) {
          switch (a2) {
            case 1:
            case 2:
            case 4:
              return b + 250;
            case 8:
            case 16:
            case 32:
            case 64:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
              return b + 5e3;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
            case 67108864:
              return -1;
            case 134217728:
            case 268435456:
            case 536870912:
            case 1073741824:
              return -1;
            default:
              return -1;
          }
        }
        function wc(a2, b) {
          for (var c2 = a2.suspendedLanes, d2 = a2.pingedLanes, e2 = a2.expirationTimes, f2 = a2.pendingLanes; 0 < f2; ) {
            var g2 = 31 - oc(f2), h2 = 1 << g2, k = e2[g2];
            if (-1 === k) {
              if (0 === (h2 & c2) || 0 !== (h2 & d2)) e2[g2] = vc(h2, b);
            } else k <= b && (a2.expiredLanes |= h2);
            f2 &= ~h2;
          }
        }
        function xc(a2) {
          a2 = a2.pendingLanes & -1073741825;
          return 0 !== a2 ? a2 : a2 & 1073741824 ? 1073741824 : 0;
        }
        function yc() {
          var a2 = rc;
          rc <<= 1;
          0 === (rc & 4194240) && (rc = 64);
          return a2;
        }
        function zc(a2) {
          for (var b = [], c2 = 0; 31 > c2; c2++) b.push(a2);
          return b;
        }
        function Ac(a2, b, c2) {
          a2.pendingLanes |= b;
          536870912 !== b && (a2.suspendedLanes = 0, a2.pingedLanes = 0);
          a2 = a2.eventTimes;
          b = 31 - oc(b);
          a2[b] = c2;
        }
        function Bc(a2, b) {
          var c2 = a2.pendingLanes & ~b;
          a2.pendingLanes = b;
          a2.suspendedLanes = 0;
          a2.pingedLanes = 0;
          a2.expiredLanes &= b;
          a2.mutableReadLanes &= b;
          a2.entangledLanes &= b;
          b = a2.entanglements;
          var d2 = a2.eventTimes;
          for (a2 = a2.expirationTimes; 0 < c2; ) {
            var e2 = 31 - oc(c2), f2 = 1 << e2;
            b[e2] = 0;
            d2[e2] = -1;
            a2[e2] = -1;
            c2 &= ~f2;
          }
        }
        function Cc(a2, b) {
          var c2 = a2.entangledLanes |= b;
          for (a2 = a2.entanglements; c2; ) {
            var d2 = 31 - oc(c2), e2 = 1 << d2;
            e2 & b | a2[d2] & b && (a2[d2] |= b);
            c2 &= ~e2;
          }
        }
        var C = 0;
        function Dc(a2) {
          a2 &= -a2;
          return 1 < a2 ? 4 < a2 ? 0 !== (a2 & 268435455) ? 16 : 536870912 : 4 : 1;
        }
        var Ec, Fc, Gc, Hc, Ic, Jc = false, Kc = [], Lc = null, Mc = null, Nc = null, Oc = /* @__PURE__ */ new Map(), Pc = /* @__PURE__ */ new Map(), Qc = [], Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
        function Sc(a2, b) {
          switch (a2) {
            case "focusin":
            case "focusout":
              Lc = null;
              break;
            case "dragenter":
            case "dragleave":
              Mc = null;
              break;
            case "mouseover":
            case "mouseout":
              Nc = null;
              break;
            case "pointerover":
            case "pointerout":
              Oc.delete(b.pointerId);
              break;
            case "gotpointercapture":
            case "lostpointercapture":
              Pc.delete(b.pointerId);
          }
        }
        function Tc(a2, b, c2, d2, e2, f2) {
          if (null === a2 || a2.nativeEvent !== f2) return a2 = { blockedOn: b, domEventName: c2, eventSystemFlags: d2, nativeEvent: f2, targetContainers: [e2] }, null !== b && (b = Cb(b), null !== b && Fc(b)), a2;
          a2.eventSystemFlags |= d2;
          b = a2.targetContainers;
          null !== e2 && -1 === b.indexOf(e2) && b.push(e2);
          return a2;
        }
        function Uc(a2, b, c2, d2, e2) {
          switch (b) {
            case "focusin":
              return Lc = Tc(Lc, a2, b, c2, d2, e2), true;
            case "dragenter":
              return Mc = Tc(Mc, a2, b, c2, d2, e2), true;
            case "mouseover":
              return Nc = Tc(Nc, a2, b, c2, d2, e2), true;
            case "pointerover":
              var f2 = e2.pointerId;
              Oc.set(f2, Tc(Oc.get(f2) || null, a2, b, c2, d2, e2));
              return true;
            case "gotpointercapture":
              return f2 = e2.pointerId, Pc.set(f2, Tc(Pc.get(f2) || null, a2, b, c2, d2, e2)), true;
          }
          return false;
        }
        function Vc(a2) {
          var b = Wc(a2.target);
          if (null !== b) {
            var c2 = Vb(b);
            if (null !== c2) {
              if (b = c2.tag, 13 === b) {
                if (b = Wb(c2), null !== b) {
                  a2.blockedOn = b;
                  Ic(a2.priority, function() {
                    Gc(c2);
                  });
                  return;
                }
              } else if (3 === b && c2.stateNode.current.memoizedState.isDehydrated) {
                a2.blockedOn = 3 === c2.tag ? c2.stateNode.containerInfo : null;
                return;
              }
            }
          }
          a2.blockedOn = null;
        }
        function Xc(a2) {
          if (null !== a2.blockedOn) return false;
          for (var b = a2.targetContainers; 0 < b.length; ) {
            var c2 = Yc(a2.domEventName, a2.eventSystemFlags, b[0], a2.nativeEvent);
            if (null === c2) {
              c2 = a2.nativeEvent;
              var d2 = new c2.constructor(c2.type, c2);
              wb = d2;
              c2.target.dispatchEvent(d2);
              wb = null;
            } else return b = Cb(c2), null !== b && Fc(b), a2.blockedOn = c2, false;
            b.shift();
          }
          return true;
        }
        function Zc(a2, b, c2) {
          Xc(a2) && c2.delete(b);
        }
        function $c() {
          Jc = false;
          null !== Lc && Xc(Lc) && (Lc = null);
          null !== Mc && Xc(Mc) && (Mc = null);
          null !== Nc && Xc(Nc) && (Nc = null);
          Oc.forEach(Zc);
          Pc.forEach(Zc);
        }
        function ad(a2, b) {
          a2.blockedOn === b && (a2.blockedOn = null, Jc || (Jc = true, ca.unstable_scheduleCallback(ca.unstable_NormalPriority, $c)));
        }
        function bd(a2) {
          function b(b2) {
            return ad(b2, a2);
          }
          if (0 < Kc.length) {
            ad(Kc[0], a2);
            for (var c2 = 1; c2 < Kc.length; c2++) {
              var d2 = Kc[c2];
              d2.blockedOn === a2 && (d2.blockedOn = null);
            }
          }
          null !== Lc && ad(Lc, a2);
          null !== Mc && ad(Mc, a2);
          null !== Nc && ad(Nc, a2);
          Oc.forEach(b);
          Pc.forEach(b);
          for (c2 = 0; c2 < Qc.length; c2++) d2 = Qc[c2], d2.blockedOn === a2 && (d2.blockedOn = null);
          for (; 0 < Qc.length && (c2 = Qc[0], null === c2.blockedOn); ) Vc(c2), null === c2.blockedOn && Qc.shift();
        }
        var cd = ua.ReactCurrentBatchConfig, dd = true;
        function ed(a2, b, c2, d2) {
          var e2 = C, f2 = cd.transition;
          cd.transition = null;
          try {
            C = 1, fd(a2, b, c2, d2);
          } finally {
            C = e2, cd.transition = f2;
          }
        }
        function gd(a2, b, c2, d2) {
          var e2 = C, f2 = cd.transition;
          cd.transition = null;
          try {
            C = 4, fd(a2, b, c2, d2);
          } finally {
            C = e2, cd.transition = f2;
          }
        }
        function fd(a2, b, c2, d2) {
          if (dd) {
            var e2 = Yc(a2, b, c2, d2);
            if (null === e2) hd(a2, b, d2, id, c2), Sc(a2, d2);
            else if (Uc(e2, a2, b, c2, d2)) d2.stopPropagation();
            else if (Sc(a2, d2), b & 4 && -1 < Rc.indexOf(a2)) {
              for (; null !== e2; ) {
                var f2 = Cb(e2);
                null !== f2 && Ec(f2);
                f2 = Yc(a2, b, c2, d2);
                null === f2 && hd(a2, b, d2, id, c2);
                if (f2 === e2) break;
                e2 = f2;
              }
              null !== e2 && d2.stopPropagation();
            } else hd(a2, b, d2, null, c2);
          }
        }
        var id = null;
        function Yc(a2, b, c2, d2) {
          id = null;
          a2 = xb(d2);
          a2 = Wc(a2);
          if (null !== a2) if (b = Vb(a2), null === b) a2 = null;
          else if (c2 = b.tag, 13 === c2) {
            a2 = Wb(b);
            if (null !== a2) return a2;
            a2 = null;
          } else if (3 === c2) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a2 = null;
          } else b !== a2 && (a2 = null);
          id = a2;
          return null;
        }
        function jd(a2) {
          switch (a2) {
            case "cancel":
            case "click":
            case "close":
            case "contextmenu":
            case "copy":
            case "cut":
            case "auxclick":
            case "dblclick":
            case "dragend":
            case "dragstart":
            case "drop":
            case "focusin":
            case "focusout":
            case "input":
            case "invalid":
            case "keydown":
            case "keypress":
            case "keyup":
            case "mousedown":
            case "mouseup":
            case "paste":
            case "pause":
            case "play":
            case "pointercancel":
            case "pointerdown":
            case "pointerup":
            case "ratechange":
            case "reset":
            case "resize":
            case "seeked":
            case "submit":
            case "touchcancel":
            case "touchend":
            case "touchstart":
            case "volumechange":
            case "change":
            case "selectionchange":
            case "textInput":
            case "compositionstart":
            case "compositionend":
            case "compositionupdate":
            case "beforeblur":
            case "afterblur":
            case "beforeinput":
            case "blur":
            case "fullscreenchange":
            case "focus":
            case "hashchange":
            case "popstate":
            case "select":
            case "selectstart":
              return 1;
            case "drag":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "mousemove":
            case "mouseout":
            case "mouseover":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "scroll":
            case "toggle":
            case "touchmove":
            case "wheel":
            case "mouseenter":
            case "mouseleave":
            case "pointerenter":
            case "pointerleave":
              return 4;
            case "message":
              switch (ec()) {
                case fc:
                  return 1;
                case gc:
                  return 4;
                case hc:
                case ic:
                  return 16;
                case jc:
                  return 536870912;
                default:
                  return 16;
              }
            default:
              return 16;
          }
        }
        var kd = null, ld = null, md = null;
        function nd() {
          if (md) return md;
          var a2, b = ld, c2 = b.length, d2, e2 = "value" in kd ? kd.value : kd.textContent, f2 = e2.length;
          for (a2 = 0; a2 < c2 && b[a2] === e2[a2]; a2++) ;
          var g2 = c2 - a2;
          for (d2 = 1; d2 <= g2 && b[c2 - d2] === e2[f2 - d2]; d2++) ;
          return md = e2.slice(a2, 1 < d2 ? 1 - d2 : void 0);
        }
        function od(a2) {
          var b = a2.keyCode;
          "charCode" in a2 ? (a2 = a2.charCode, 0 === a2 && 13 === b && (a2 = 13)) : a2 = b;
          10 === a2 && (a2 = 13);
          return 32 <= a2 || 13 === a2 ? a2 : 0;
        }
        function pd() {
          return true;
        }
        function qd() {
          return false;
        }
        function rd(a2) {
          function b(b2, d2, e2, f2, g2) {
            this._reactName = b2;
            this._targetInst = e2;
            this.type = d2;
            this.nativeEvent = f2;
            this.target = g2;
            this.currentTarget = null;
            for (var c2 in a2) a2.hasOwnProperty(c2) && (b2 = a2[c2], this[c2] = b2 ? b2(f2) : f2[c2]);
            this.isDefaultPrevented = (null != f2.defaultPrevented ? f2.defaultPrevented : false === f2.returnValue) ? pd : qd;
            this.isPropagationStopped = qd;
            return this;
          }
          A(b.prototype, { preventDefault: function() {
            this.defaultPrevented = true;
            var a3 = this.nativeEvent;
            a3 && (a3.preventDefault ? a3.preventDefault() : "unknown" !== typeof a3.returnValue && (a3.returnValue = false), this.isDefaultPrevented = pd);
          }, stopPropagation: function() {
            var a3 = this.nativeEvent;
            a3 && (a3.stopPropagation ? a3.stopPropagation() : "unknown" !== typeof a3.cancelBubble && (a3.cancelBubble = true), this.isPropagationStopped = pd);
          }, persist: function() {
          }, isPersistent: pd });
          return b;
        }
        var sd = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(a2) {
          return a2.timeStamp || Date.now();
        }, defaultPrevented: 0, isTrusted: 0 }, td = rd(sd), ud = A({}, sd, { view: 0, detail: 0 }), vd = rd(ud), wd, xd, yd, Ad = A({}, ud, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: zd, button: 0, buttons: 0, relatedTarget: function(a2) {
          return void 0 === a2.relatedTarget ? a2.fromElement === a2.srcElement ? a2.toElement : a2.fromElement : a2.relatedTarget;
        }, movementX: function(a2) {
          if ("movementX" in a2) return a2.movementX;
          a2 !== yd && (yd && "mousemove" === a2.type ? (wd = a2.screenX - yd.screenX, xd = a2.screenY - yd.screenY) : xd = wd = 0, yd = a2);
          return wd;
        }, movementY: function(a2) {
          return "movementY" in a2 ? a2.movementY : xd;
        } }), Bd = rd(Ad), Cd = A({}, Ad, { dataTransfer: 0 }), Dd = rd(Cd), Ed = A({}, ud, { relatedTarget: 0 }), Fd = rd(Ed), Gd = A({}, sd, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }), Hd = rd(Gd), Id = A({}, sd, { clipboardData: function(a2) {
          return "clipboardData" in a2 ? a2.clipboardData : window.clipboardData;
        } }), Jd = rd(Id), Kd = A({}, sd, { data: 0 }), Ld = rd(Kd), Md = {
          Esc: "Escape",
          Spacebar: " ",
          Left: "ArrowLeft",
          Up: "ArrowUp",
          Right: "ArrowRight",
          Down: "ArrowDown",
          Del: "Delete",
          Win: "OS",
          Menu: "ContextMenu",
          Apps: "ContextMenu",
          Scroll: "ScrollLock",
          MozPrintableKey: "Unidentified"
        }, Nd = {
          8: "Backspace",
          9: "Tab",
          12: "Clear",
          13: "Enter",
          16: "Shift",
          17: "Control",
          18: "Alt",
          19: "Pause",
          20: "CapsLock",
          27: "Escape",
          32: " ",
          33: "PageUp",
          34: "PageDown",
          35: "End",
          36: "Home",
          37: "ArrowLeft",
          38: "ArrowUp",
          39: "ArrowRight",
          40: "ArrowDown",
          45: "Insert",
          46: "Delete",
          112: "F1",
          113: "F2",
          114: "F3",
          115: "F4",
          116: "F5",
          117: "F6",
          118: "F7",
          119: "F8",
          120: "F9",
          121: "F10",
          122: "F11",
          123: "F12",
          144: "NumLock",
          145: "ScrollLock",
          224: "Meta"
        }, Od = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
        function Pd(a2) {
          var b = this.nativeEvent;
          return b.getModifierState ? b.getModifierState(a2) : (a2 = Od[a2]) ? !!b[a2] : false;
        }
        function zd() {
          return Pd;
        }
        var Qd = A({}, ud, { key: function(a2) {
          if (a2.key) {
            var b = Md[a2.key] || a2.key;
            if ("Unidentified" !== b) return b;
          }
          return "keypress" === a2.type ? (a2 = od(a2), 13 === a2 ? "Enter" : String.fromCharCode(a2)) : "keydown" === a2.type || "keyup" === a2.type ? Nd[a2.keyCode] || "Unidentified" : "";
        }, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: zd, charCode: function(a2) {
          return "keypress" === a2.type ? od(a2) : 0;
        }, keyCode: function(a2) {
          return "keydown" === a2.type || "keyup" === a2.type ? a2.keyCode : 0;
        }, which: function(a2) {
          return "keypress" === a2.type ? od(a2) : "keydown" === a2.type || "keyup" === a2.type ? a2.keyCode : 0;
        } }), Rd = rd(Qd), Sd = A({}, Ad, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 }), Td = rd(Sd), Ud = A({}, ud, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: zd }), Vd = rd(Ud), Wd = A({}, sd, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }), Xd = rd(Wd), Yd = A({}, Ad, {
          deltaX: function(a2) {
            return "deltaX" in a2 ? a2.deltaX : "wheelDeltaX" in a2 ? -a2.wheelDeltaX : 0;
          },
          deltaY: function(a2) {
            return "deltaY" in a2 ? a2.deltaY : "wheelDeltaY" in a2 ? -a2.wheelDeltaY : "wheelDelta" in a2 ? -a2.wheelDelta : 0;
          },
          deltaZ: 0,
          deltaMode: 0
        }), Zd = rd(Yd), $d = [9, 13, 27, 32], ae = ia && "CompositionEvent" in window, be = null;
        ia && "documentMode" in document && (be = document.documentMode);
        var ce = ia && "TextEvent" in window && !be, de = ia && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = false;
        function ge(a2, b) {
          switch (a2) {
            case "keyup":
              return -1 !== $d.indexOf(b.keyCode);
            case "keydown":
              return 229 !== b.keyCode;
            case "keypress":
            case "mousedown":
            case "focusout":
              return true;
            default:
              return false;
          }
        }
        function he(a2) {
          a2 = a2.detail;
          return "object" === typeof a2 && "data" in a2 ? a2.data : null;
        }
        var ie = false;
        function je(a2, b) {
          switch (a2) {
            case "compositionend":
              return he(b);
            case "keypress":
              if (32 !== b.which) return null;
              fe = true;
              return ee;
            case "textInput":
              return a2 = b.data, a2 === ee && fe ? null : a2;
            default:
              return null;
          }
        }
        function ke(a2, b) {
          if (ie) return "compositionend" === a2 || !ae && ge(a2, b) ? (a2 = nd(), md = ld = kd = null, ie = false, a2) : null;
          switch (a2) {
            case "paste":
              return null;
            case "keypress":
              if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
              }
              return null;
            case "compositionend":
              return de && "ko" !== b.locale ? null : b.data;
            default:
              return null;
          }
        }
        var le = { color: true, date: true, datetime: true, "datetime-local": true, email: true, month: true, number: true, password: true, range: true, search: true, tel: true, text: true, time: true, url: true, week: true };
        function me(a2) {
          var b = a2 && a2.nodeName && a2.nodeName.toLowerCase();
          return "input" === b ? !!le[a2.type] : "textarea" === b ? true : false;
        }
        function ne(a2, b, c2, d2) {
          Eb(d2);
          b = oe(b, "onChange");
          0 < b.length && (c2 = new td("onChange", "change", null, c2, d2), a2.push({ event: c2, listeners: b }));
        }
        var pe = null, qe = null;
        function re(a2) {
          se(a2, 0);
        }
        function te(a2) {
          var b = ue(a2);
          if (Wa(b)) return a2;
        }
        function ve(a2, b) {
          if ("change" === a2) return b;
        }
        var we = false;
        if (ia) {
          var xe;
          if (ia) {
            var ye = "oninput" in document;
            if (!ye) {
              var ze = document.createElement("div");
              ze.setAttribute("oninput", "return;");
              ye = "function" === typeof ze.oninput;
            }
            xe = ye;
          } else xe = false;
          we = xe && (!document.documentMode || 9 < document.documentMode);
        }
        function Ae() {
          pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
        }
        function Be(a2) {
          if ("value" === a2.propertyName && te(qe)) {
            var b = [];
            ne(b, qe, a2, xb(a2));
            Jb(re, b);
          }
        }
        function Ce(a2, b, c2) {
          "focusin" === a2 ? (Ae(), pe = b, qe = c2, pe.attachEvent("onpropertychange", Be)) : "focusout" === a2 && Ae();
        }
        function De(a2) {
          if ("selectionchange" === a2 || "keyup" === a2 || "keydown" === a2) return te(qe);
        }
        function Ee(a2, b) {
          if ("click" === a2) return te(b);
        }
        function Fe(a2, b) {
          if ("input" === a2 || "change" === a2) return te(b);
        }
        function Ge(a2, b) {
          return a2 === b && (0 !== a2 || 1 / a2 === 1 / b) || a2 !== a2 && b !== b;
        }
        var He = "function" === typeof Object.is ? Object.is : Ge;
        function Ie(a2, b) {
          if (He(a2, b)) return true;
          if ("object" !== typeof a2 || null === a2 || "object" !== typeof b || null === b) return false;
          var c2 = Object.keys(a2), d2 = Object.keys(b);
          if (c2.length !== d2.length) return false;
          for (d2 = 0; d2 < c2.length; d2++) {
            var e2 = c2[d2];
            if (!ja.call(b, e2) || !He(a2[e2], b[e2])) return false;
          }
          return true;
        }
        function Je(a2) {
          for (; a2 && a2.firstChild; ) a2 = a2.firstChild;
          return a2;
        }
        function Ke(a2, b) {
          var c2 = Je(a2);
          a2 = 0;
          for (var d2; c2; ) {
            if (3 === c2.nodeType) {
              d2 = a2 + c2.textContent.length;
              if (a2 <= b && d2 >= b) return { node: c2, offset: b - a2 };
              a2 = d2;
            }
            a: {
              for (; c2; ) {
                if (c2.nextSibling) {
                  c2 = c2.nextSibling;
                  break a;
                }
                c2 = c2.parentNode;
              }
              c2 = void 0;
            }
            c2 = Je(c2);
          }
        }
        function Le(a2, b) {
          return a2 && b ? a2 === b ? true : a2 && 3 === a2.nodeType ? false : b && 3 === b.nodeType ? Le(a2, b.parentNode) : "contains" in a2 ? a2.contains(b) : a2.compareDocumentPosition ? !!(a2.compareDocumentPosition(b) & 16) : false : false;
        }
        function Me() {
          for (var a2 = window, b = Xa(); b instanceof a2.HTMLIFrameElement; ) {
            try {
              var c2 = "string" === typeof b.contentWindow.location.href;
            } catch (d2) {
              c2 = false;
            }
            if (c2) a2 = b.contentWindow;
            else break;
            b = Xa(a2.document);
          }
          return b;
        }
        function Ne(a2) {
          var b = a2 && a2.nodeName && a2.nodeName.toLowerCase();
          return b && ("input" === b && ("text" === a2.type || "search" === a2.type || "tel" === a2.type || "url" === a2.type || "password" === a2.type) || "textarea" === b || "true" === a2.contentEditable);
        }
        function Oe(a2) {
          var b = Me(), c2 = a2.focusedElem, d2 = a2.selectionRange;
          if (b !== c2 && c2 && c2.ownerDocument && Le(c2.ownerDocument.documentElement, c2)) {
            if (null !== d2 && Ne(c2)) {
              if (b = d2.start, a2 = d2.end, void 0 === a2 && (a2 = b), "selectionStart" in c2) c2.selectionStart = b, c2.selectionEnd = Math.min(a2, c2.value.length);
              else if (a2 = (b = c2.ownerDocument || document) && b.defaultView || window, a2.getSelection) {
                a2 = a2.getSelection();
                var e2 = c2.textContent.length, f2 = Math.min(d2.start, e2);
                d2 = void 0 === d2.end ? f2 : Math.min(d2.end, e2);
                !a2.extend && f2 > d2 && (e2 = d2, d2 = f2, f2 = e2);
                e2 = Ke(c2, f2);
                var g2 = Ke(
                  c2,
                  d2
                );
                e2 && g2 && (1 !== a2.rangeCount || a2.anchorNode !== e2.node || a2.anchorOffset !== e2.offset || a2.focusNode !== g2.node || a2.focusOffset !== g2.offset) && (b = b.createRange(), b.setStart(e2.node, e2.offset), a2.removeAllRanges(), f2 > d2 ? (a2.addRange(b), a2.extend(g2.node, g2.offset)) : (b.setEnd(g2.node, g2.offset), a2.addRange(b)));
              }
            }
            b = [];
            for (a2 = c2; a2 = a2.parentNode; ) 1 === a2.nodeType && b.push({ element: a2, left: a2.scrollLeft, top: a2.scrollTop });
            "function" === typeof c2.focus && c2.focus();
            for (c2 = 0; c2 < b.length; c2++) a2 = b[c2], a2.element.scrollLeft = a2.left, a2.element.scrollTop = a2.top;
          }
        }
        var Pe = ia && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = false;
        function Ue(a2, b, c2) {
          var d2 = c2.window === c2 ? c2.document : 9 === c2.nodeType ? c2 : c2.ownerDocument;
          Te || null == Qe || Qe !== Xa(d2) || (d2 = Qe, "selectionStart" in d2 && Ne(d2) ? d2 = { start: d2.selectionStart, end: d2.selectionEnd } : (d2 = (d2.ownerDocument && d2.ownerDocument.defaultView || window).getSelection(), d2 = { anchorNode: d2.anchorNode, anchorOffset: d2.anchorOffset, focusNode: d2.focusNode, focusOffset: d2.focusOffset }), Se && Ie(Se, d2) || (Se = d2, d2 = oe(Re, "onSelect"), 0 < d2.length && (b = new td("onSelect", "select", null, b, c2), a2.push({ event: b, listeners: d2 }), b.target = Qe)));
        }
        function Ve(a2, b) {
          var c2 = {};
          c2[a2.toLowerCase()] = b.toLowerCase();
          c2["Webkit" + a2] = "webkit" + b;
          c2["Moz" + a2] = "moz" + b;
          return c2;
        }
        var We = { animationend: Ve("Animation", "AnimationEnd"), animationiteration: Ve("Animation", "AnimationIteration"), animationstart: Ve("Animation", "AnimationStart"), transitionend: Ve("Transition", "TransitionEnd") }, Xe = {}, Ye = {};
        ia && (Ye = document.createElement("div").style, "AnimationEvent" in window || (delete We.animationend.animation, delete We.animationiteration.animation, delete We.animationstart.animation), "TransitionEvent" in window || delete We.transitionend.transition);
        function Ze(a2) {
          if (Xe[a2]) return Xe[a2];
          if (!We[a2]) return a2;
          var b = We[a2], c2;
          for (c2 in b) if (b.hasOwnProperty(c2) && c2 in Ye) return Xe[a2] = b[c2];
          return a2;
        }
        var $e = Ze("animationend"), af = Ze("animationiteration"), bf = Ze("animationstart"), cf = Ze("transitionend"), df = /* @__PURE__ */ new Map(), ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
        function ff(a2, b) {
          df.set(a2, b);
          fa(b, [a2]);
        }
        for (var gf = 0; gf < ef.length; gf++) {
          var hf = ef[gf], jf = hf.toLowerCase(), kf = hf[0].toUpperCase() + hf.slice(1);
          ff(jf, "on" + kf);
        }
        ff($e, "onAnimationEnd");
        ff(af, "onAnimationIteration");
        ff(bf, "onAnimationStart");
        ff("dblclick", "onDoubleClick");
        ff("focusin", "onFocus");
        ff("focusout", "onBlur");
        ff(cf, "onTransitionEnd");
        ha("onMouseEnter", ["mouseout", "mouseover"]);
        ha("onMouseLeave", ["mouseout", "mouseover"]);
        ha("onPointerEnter", ["pointerout", "pointerover"]);
        ha("onPointerLeave", ["pointerout", "pointerover"]);
        fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
        fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
        fa("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]);
        fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
        fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
        fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
        var lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), mf = new Set("cancel close invalid load scroll toggle".split(" ").concat(lf));
        function nf(a2, b, c2) {
          var d2 = a2.type || "unknown-event";
          a2.currentTarget = c2;
          Ub(d2, b, void 0, a2);
          a2.currentTarget = null;
        }
        function se(a2, b) {
          b = 0 !== (b & 4);
          for (var c2 = 0; c2 < a2.length; c2++) {
            var d2 = a2[c2], e2 = d2.event;
            d2 = d2.listeners;
            a: {
              var f2 = void 0;
              if (b) for (var g2 = d2.length - 1; 0 <= g2; g2--) {
                var h2 = d2[g2], k = h2.instance, l2 = h2.currentTarget;
                h2 = h2.listener;
                if (k !== f2 && e2.isPropagationStopped()) break a;
                nf(e2, h2, l2);
                f2 = k;
              }
              else for (g2 = 0; g2 < d2.length; g2++) {
                h2 = d2[g2];
                k = h2.instance;
                l2 = h2.currentTarget;
                h2 = h2.listener;
                if (k !== f2 && e2.isPropagationStopped()) break a;
                nf(e2, h2, l2);
                f2 = k;
              }
            }
          }
          if (Qb) throw a2 = Rb, Qb = false, Rb = null, a2;
        }
        function D(a2, b) {
          var c2 = b[of];
          void 0 === c2 && (c2 = b[of] = /* @__PURE__ */ new Set());
          var d2 = a2 + "__bubble";
          c2.has(d2) || (pf(b, a2, 2, false), c2.add(d2));
        }
        function qf(a2, b, c2) {
          var d2 = 0;
          b && (d2 |= 4);
          pf(c2, a2, d2, b);
        }
        var rf = "_reactListening" + Math.random().toString(36).slice(2);
        function sf(a2) {
          if (!a2[rf]) {
            a2[rf] = true;
            da.forEach(function(b2) {
              "selectionchange" !== b2 && (mf.has(b2) || qf(b2, false, a2), qf(b2, true, a2));
            });
            var b = 9 === a2.nodeType ? a2 : a2.ownerDocument;
            null === b || b[rf] || (b[rf] = true, qf("selectionchange", false, b));
          }
        }
        function pf(a2, b, c2, d2) {
          switch (jd(b)) {
            case 1:
              var e2 = ed;
              break;
            case 4:
              e2 = gd;
              break;
            default:
              e2 = fd;
          }
          c2 = e2.bind(null, b, c2, a2);
          e2 = void 0;
          !Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e2 = true);
          d2 ? void 0 !== e2 ? a2.addEventListener(b, c2, { capture: true, passive: e2 }) : a2.addEventListener(b, c2, true) : void 0 !== e2 ? a2.addEventListener(b, c2, { passive: e2 }) : a2.addEventListener(b, c2, false);
        }
        function hd(a2, b, c2, d2, e2) {
          var f2 = d2;
          if (0 === (b & 1) && 0 === (b & 2) && null !== d2) a: for (; ; ) {
            if (null === d2) return;
            var g2 = d2.tag;
            if (3 === g2 || 4 === g2) {
              var h2 = d2.stateNode.containerInfo;
              if (h2 === e2 || 8 === h2.nodeType && h2.parentNode === e2) break;
              if (4 === g2) for (g2 = d2.return; null !== g2; ) {
                var k = g2.tag;
                if (3 === k || 4 === k) {
                  if (k = g2.stateNode.containerInfo, k === e2 || 8 === k.nodeType && k.parentNode === e2) return;
                }
                g2 = g2.return;
              }
              for (; null !== h2; ) {
                g2 = Wc(h2);
                if (null === g2) return;
                k = g2.tag;
                if (5 === k || 6 === k) {
                  d2 = f2 = g2;
                  continue a;
                }
                h2 = h2.parentNode;
              }
            }
            d2 = d2.return;
          }
          Jb(function() {
            var d3 = f2, e3 = xb(c2), g3 = [];
            a: {
              var h3 = df.get(a2);
              if (void 0 !== h3) {
                var k2 = td, n2 = a2;
                switch (a2) {
                  case "keypress":
                    if (0 === od(c2)) break a;
                  case "keydown":
                  case "keyup":
                    k2 = Rd;
                    break;
                  case "focusin":
                    n2 = "focus";
                    k2 = Fd;
                    break;
                  case "focusout":
                    n2 = "blur";
                    k2 = Fd;
                    break;
                  case "beforeblur":
                  case "afterblur":
                    k2 = Fd;
                    break;
                  case "click":
                    if (2 === c2.button) break a;
                  case "auxclick":
                  case "dblclick":
                  case "mousedown":
                  case "mousemove":
                  case "mouseup":
                  case "mouseout":
                  case "mouseover":
                  case "contextmenu":
                    k2 = Bd;
                    break;
                  case "drag":
                  case "dragend":
                  case "dragenter":
                  case "dragexit":
                  case "dragleave":
                  case "dragover":
                  case "dragstart":
                  case "drop":
                    k2 = Dd;
                    break;
                  case "touchcancel":
                  case "touchend":
                  case "touchmove":
                  case "touchstart":
                    k2 = Vd;
                    break;
                  case $e:
                  case af:
                  case bf:
                    k2 = Hd;
                    break;
                  case cf:
                    k2 = Xd;
                    break;
                  case "scroll":
                    k2 = vd;
                    break;
                  case "wheel":
                    k2 = Zd;
                    break;
                  case "copy":
                  case "cut":
                  case "paste":
                    k2 = Jd;
                    break;
                  case "gotpointercapture":
                  case "lostpointercapture":
                  case "pointercancel":
                  case "pointerdown":
                  case "pointermove":
                  case "pointerout":
                  case "pointerover":
                  case "pointerup":
                    k2 = Td;
                }
                var t2 = 0 !== (b & 4), J = !t2 && "scroll" === a2, x = t2 ? null !== h3 ? h3 + "Capture" : null : h3;
                t2 = [];
                for (var w = d3, u2; null !== w; ) {
                  u2 = w;
                  var F = u2.stateNode;
                  5 === u2.tag && null !== F && (u2 = F, null !== x && (F = Kb(w, x), null != F && t2.push(tf(w, F, u2))));
                  if (J) break;
                  w = w.return;
                }
                0 < t2.length && (h3 = new k2(h3, n2, null, c2, e3), g3.push({ event: h3, listeners: t2 }));
              }
            }
            if (0 === (b & 7)) {
              a: {
                h3 = "mouseover" === a2 || "pointerover" === a2;
                k2 = "mouseout" === a2 || "pointerout" === a2;
                if (h3 && c2 !== wb && (n2 = c2.relatedTarget || c2.fromElement) && (Wc(n2) || n2[uf])) break a;
                if (k2 || h3) {
                  h3 = e3.window === e3 ? e3 : (h3 = e3.ownerDocument) ? h3.defaultView || h3.parentWindow : window;
                  if (k2) {
                    if (n2 = c2.relatedTarget || c2.toElement, k2 = d3, n2 = n2 ? Wc(n2) : null, null !== n2 && (J = Vb(n2), n2 !== J || 5 !== n2.tag && 6 !== n2.tag)) n2 = null;
                  } else k2 = null, n2 = d3;
                  if (k2 !== n2) {
                    t2 = Bd;
                    F = "onMouseLeave";
                    x = "onMouseEnter";
                    w = "mouse";
                    if ("pointerout" === a2 || "pointerover" === a2) t2 = Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                    J = null == k2 ? h3 : ue(k2);
                    u2 = null == n2 ? h3 : ue(n2);
                    h3 = new t2(F, w + "leave", k2, c2, e3);
                    h3.target = J;
                    h3.relatedTarget = u2;
                    F = null;
                    Wc(e3) === d3 && (t2 = new t2(x, w + "enter", n2, c2, e3), t2.target = u2, t2.relatedTarget = J, F = t2);
                    J = F;
                    if (k2 && n2) b: {
                      t2 = k2;
                      x = n2;
                      w = 0;
                      for (u2 = t2; u2; u2 = vf(u2)) w++;
                      u2 = 0;
                      for (F = x; F; F = vf(F)) u2++;
                      for (; 0 < w - u2; ) t2 = vf(t2), w--;
                      for (; 0 < u2 - w; ) x = vf(x), u2--;
                      for (; w--; ) {
                        if (t2 === x || null !== x && t2 === x.alternate) break b;
                        t2 = vf(t2);
                        x = vf(x);
                      }
                      t2 = null;
                    }
                    else t2 = null;
                    null !== k2 && wf(g3, h3, k2, t2, false);
                    null !== n2 && null !== J && wf(g3, J, n2, t2, true);
                  }
                }
              }
              a: {
                h3 = d3 ? ue(d3) : window;
                k2 = h3.nodeName && h3.nodeName.toLowerCase();
                if ("select" === k2 || "input" === k2 && "file" === h3.type) var na = ve;
                else if (me(h3)) if (we) na = Fe;
                else {
                  na = De;
                  var xa = Ce;
                }
                else (k2 = h3.nodeName) && "input" === k2.toLowerCase() && ("checkbox" === h3.type || "radio" === h3.type) && (na = Ee);
                if (na && (na = na(a2, d3))) {
                  ne(g3, na, c2, e3);
                  break a;
                }
                xa && xa(a2, h3, d3);
                "focusout" === a2 && (xa = h3._wrapperState) && xa.controlled && "number" === h3.type && cb(h3, "number", h3.value);
              }
              xa = d3 ? ue(d3) : window;
              switch (a2) {
                case "focusin":
                  if (me(xa) || "true" === xa.contentEditable) Qe = xa, Re = d3, Se = null;
                  break;
                case "focusout":
                  Se = Re = Qe = null;
                  break;
                case "mousedown":
                  Te = true;
                  break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                  Te = false;
                  Ue(g3, c2, e3);
                  break;
                case "selectionchange":
                  if (Pe) break;
                case "keydown":
                case "keyup":
                  Ue(g3, c2, e3);
              }
              var $a;
              if (ae) b: {
                switch (a2) {
                  case "compositionstart":
                    var ba = "onCompositionStart";
                    break b;
                  case "compositionend":
                    ba = "onCompositionEnd";
                    break b;
                  case "compositionupdate":
                    ba = "onCompositionUpdate";
                    break b;
                }
                ba = void 0;
              }
              else ie ? ge(a2, c2) && (ba = "onCompositionEnd") : "keydown" === a2 && 229 === c2.keyCode && (ba = "onCompositionStart");
              ba && (de && "ko" !== c2.locale && (ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && ie && ($a = nd()) : (kd = e3, ld = "value" in kd ? kd.value : kd.textContent, ie = true)), xa = oe(d3, ba), 0 < xa.length && (ba = new Ld(ba, a2, null, c2, e3), g3.push({ event: ba, listeners: xa }), $a ? ba.data = $a : ($a = he(c2), null !== $a && (ba.data = $a))));
              if ($a = ce ? je(a2, c2) : ke(a2, c2)) d3 = oe(d3, "onBeforeInput"), 0 < d3.length && (e3 = new Ld("onBeforeInput", "beforeinput", null, c2, e3), g3.push({ event: e3, listeners: d3 }), e3.data = $a);
            }
            se(g3, b);
          });
        }
        function tf(a2, b, c2) {
          return { instance: a2, listener: b, currentTarget: c2 };
        }
        function oe(a2, b) {
          for (var c2 = b + "Capture", d2 = []; null !== a2; ) {
            var e2 = a2, f2 = e2.stateNode;
            5 === e2.tag && null !== f2 && (e2 = f2, f2 = Kb(a2, c2), null != f2 && d2.unshift(tf(a2, f2, e2)), f2 = Kb(a2, b), null != f2 && d2.push(tf(a2, f2, e2)));
            a2 = a2.return;
          }
          return d2;
        }
        function vf(a2) {
          if (null === a2) return null;
          do
            a2 = a2.return;
          while (a2 && 5 !== a2.tag);
          return a2 ? a2 : null;
        }
        function wf(a2, b, c2, d2, e2) {
          for (var f2 = b._reactName, g2 = []; null !== c2 && c2 !== d2; ) {
            var h2 = c2, k = h2.alternate, l2 = h2.stateNode;
            if (null !== k && k === d2) break;
            5 === h2.tag && null !== l2 && (h2 = l2, e2 ? (k = Kb(c2, f2), null != k && g2.unshift(tf(c2, k, h2))) : e2 || (k = Kb(c2, f2), null != k && g2.push(tf(c2, k, h2))));
            c2 = c2.return;
          }
          0 !== g2.length && a2.push({ event: b, listeners: g2 });
        }
        var xf = /\r\n?/g, yf = /\u0000|\uFFFD/g;
        function zf(a2) {
          return ("string" === typeof a2 ? a2 : "" + a2).replace(xf, "\n").replace(yf, "");
        }
        function Af(a2, b, c2) {
          b = zf(b);
          if (zf(a2) !== b && c2) throw Error(p2(425));
        }
        function Bf() {
        }
        var Cf = null, Df = null;
        function Ef(a2, b) {
          return "textarea" === a2 || "noscript" === a2 || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
        }
        var Ff = "function" === typeof setTimeout ? setTimeout : void 0, Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, Hf = "function" === typeof Promise ? Promise : void 0, Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof Hf ? function(a2) {
          return Hf.resolve(null).then(a2).catch(If);
        } : Ff;
        function If(a2) {
          setTimeout(function() {
            throw a2;
          });
        }
        function Kf(a2, b) {
          var c2 = b, d2 = 0;
          do {
            var e2 = c2.nextSibling;
            a2.removeChild(c2);
            if (e2 && 8 === e2.nodeType) if (c2 = e2.data, "/$" === c2) {
              if (0 === d2) {
                a2.removeChild(e2);
                bd(b);
                return;
              }
              d2--;
            } else "$" !== c2 && "$?" !== c2 && "$!" !== c2 || d2++;
            c2 = e2;
          } while (c2);
          bd(b);
        }
        function Lf(a2) {
          for (; null != a2; a2 = a2.nextSibling) {
            var b = a2.nodeType;
            if (1 === b || 3 === b) break;
            if (8 === b) {
              b = a2.data;
              if ("$" === b || "$!" === b || "$?" === b) break;
              if ("/$" === b) return null;
            }
          }
          return a2;
        }
        function Mf(a2) {
          a2 = a2.previousSibling;
          for (var b = 0; a2; ) {
            if (8 === a2.nodeType) {
              var c2 = a2.data;
              if ("$" === c2 || "$!" === c2 || "$?" === c2) {
                if (0 === b) return a2;
                b--;
              } else "/$" === c2 && b++;
            }
            a2 = a2.previousSibling;
          }
          return null;
        }
        var Nf = Math.random().toString(36).slice(2), Of = "__reactFiber$" + Nf, Pf = "__reactProps$" + Nf, uf = "__reactContainer$" + Nf, of = "__reactEvents$" + Nf, Qf = "__reactListeners$" + Nf, Rf = "__reactHandles$" + Nf;
        function Wc(a2) {
          var b = a2[Of];
          if (b) return b;
          for (var c2 = a2.parentNode; c2; ) {
            if (b = c2[uf] || c2[Of]) {
              c2 = b.alternate;
              if (null !== b.child || null !== c2 && null !== c2.child) for (a2 = Mf(a2); null !== a2; ) {
                if (c2 = a2[Of]) return c2;
                a2 = Mf(a2);
              }
              return b;
            }
            a2 = c2;
            c2 = a2.parentNode;
          }
          return null;
        }
        function Cb(a2) {
          a2 = a2[Of] || a2[uf];
          return !a2 || 5 !== a2.tag && 6 !== a2.tag && 13 !== a2.tag && 3 !== a2.tag ? null : a2;
        }
        function ue(a2) {
          if (5 === a2.tag || 6 === a2.tag) return a2.stateNode;
          throw Error(p2(33));
        }
        function Db(a2) {
          return a2[Pf] || null;
        }
        var Sf = [], Tf = -1;
        function Uf(a2) {
          return { current: a2 };
        }
        function E(a2) {
          0 > Tf || (a2.current = Sf[Tf], Sf[Tf] = null, Tf--);
        }
        function G(a2, b) {
          Tf++;
          Sf[Tf] = a2.current;
          a2.current = b;
        }
        var Vf = {}, H = Uf(Vf), Wf = Uf(false), Xf = Vf;
        function Yf(a2, b) {
          var c2 = a2.type.contextTypes;
          if (!c2) return Vf;
          var d2 = a2.stateNode;
          if (d2 && d2.__reactInternalMemoizedUnmaskedChildContext === b) return d2.__reactInternalMemoizedMaskedChildContext;
          var e2 = {}, f2;
          for (f2 in c2) e2[f2] = b[f2];
          d2 && (a2 = a2.stateNode, a2.__reactInternalMemoizedUnmaskedChildContext = b, a2.__reactInternalMemoizedMaskedChildContext = e2);
          return e2;
        }
        function Zf(a2) {
          a2 = a2.childContextTypes;
          return null !== a2 && void 0 !== a2;
        }
        function $f() {
          E(Wf);
          E(H);
        }
        function ag(a2, b, c2) {
          if (H.current !== Vf) throw Error(p2(168));
          G(H, b);
          G(Wf, c2);
        }
        function bg(a2, b, c2) {
          var d2 = a2.stateNode;
          b = b.childContextTypes;
          if ("function" !== typeof d2.getChildContext) return c2;
          d2 = d2.getChildContext();
          for (var e2 in d2) if (!(e2 in b)) throw Error(p2(108, Ra(a2) || "Unknown", e2));
          return A({}, c2, d2);
        }
        function cg(a2) {
          a2 = (a2 = a2.stateNode) && a2.__reactInternalMemoizedMergedChildContext || Vf;
          Xf = H.current;
          G(H, a2);
          G(Wf, Wf.current);
          return true;
        }
        function dg(a2, b, c2) {
          var d2 = a2.stateNode;
          if (!d2) throw Error(p2(169));
          c2 ? (a2 = bg(a2, b, Xf), d2.__reactInternalMemoizedMergedChildContext = a2, E(Wf), E(H), G(H, a2)) : E(Wf);
          G(Wf, c2);
        }
        var eg = null, fg = false, gg = false;
        function hg(a2) {
          null === eg ? eg = [a2] : eg.push(a2);
        }
        function ig(a2) {
          fg = true;
          hg(a2);
        }
        function jg() {
          if (!gg && null !== eg) {
            gg = true;
            var a2 = 0, b = C;
            try {
              var c2 = eg;
              for (C = 1; a2 < c2.length; a2++) {
                var d2 = c2[a2];
                do
                  d2 = d2(true);
                while (null !== d2);
              }
              eg = null;
              fg = false;
            } catch (e2) {
              throw null !== eg && (eg = eg.slice(a2 + 1)), ac(fc, jg), e2;
            } finally {
              C = b, gg = false;
            }
          }
          return null;
        }
        var kg = [], lg = 0, mg = null, ng = 0, og = [], pg = 0, qg = null, rg = 1, sg = "";
        function tg(a2, b) {
          kg[lg++] = ng;
          kg[lg++] = mg;
          mg = a2;
          ng = b;
        }
        function ug(a2, b, c2) {
          og[pg++] = rg;
          og[pg++] = sg;
          og[pg++] = qg;
          qg = a2;
          var d2 = rg;
          a2 = sg;
          var e2 = 32 - oc(d2) - 1;
          d2 &= ~(1 << e2);
          c2 += 1;
          var f2 = 32 - oc(b) + e2;
          if (30 < f2) {
            var g2 = e2 - e2 % 5;
            f2 = (d2 & (1 << g2) - 1).toString(32);
            d2 >>= g2;
            e2 -= g2;
            rg = 1 << 32 - oc(b) + e2 | c2 << e2 | d2;
            sg = f2 + a2;
          } else rg = 1 << f2 | c2 << e2 | d2, sg = a2;
        }
        function vg(a2) {
          null !== a2.return && (tg(a2, 1), ug(a2, 1, 0));
        }
        function wg(a2) {
          for (; a2 === mg; ) mg = kg[--lg], kg[lg] = null, ng = kg[--lg], kg[lg] = null;
          for (; a2 === qg; ) qg = og[--pg], og[pg] = null, sg = og[--pg], og[pg] = null, rg = og[--pg], og[pg] = null;
        }
        var xg = null, yg = null, I = false, zg = null;
        function Ag(a2, b) {
          var c2 = Bg(5, null, null, 0);
          c2.elementType = "DELETED";
          c2.stateNode = b;
          c2.return = a2;
          b = a2.deletions;
          null === b ? (a2.deletions = [c2], a2.flags |= 16) : b.push(c2);
        }
        function Cg(a2, b) {
          switch (a2.tag) {
            case 5:
              var c2 = a2.type;
              b = 1 !== b.nodeType || c2.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
              return null !== b ? (a2.stateNode = b, xg = a2, yg = Lf(b.firstChild), true) : false;
            case 6:
              return b = "" === a2.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a2.stateNode = b, xg = a2, yg = null, true) : false;
            case 13:
              return b = 8 !== b.nodeType ? null : b, null !== b ? (c2 = null !== qg ? { id: rg, overflow: sg } : null, a2.memoizedState = { dehydrated: b, treeContext: c2, retryLane: 1073741824 }, c2 = Bg(18, null, null, 0), c2.stateNode = b, c2.return = a2, a2.child = c2, xg = a2, yg = null, true) : false;
            default:
              return false;
          }
        }
        function Dg(a2) {
          return 0 !== (a2.mode & 1) && 0 === (a2.flags & 128);
        }
        function Eg(a2) {
          if (I) {
            var b = yg;
            if (b) {
              var c2 = b;
              if (!Cg(a2, b)) {
                if (Dg(a2)) throw Error(p2(418));
                b = Lf(c2.nextSibling);
                var d2 = xg;
                b && Cg(a2, b) ? Ag(d2, c2) : (a2.flags = a2.flags & -4097 | 2, I = false, xg = a2);
              }
            } else {
              if (Dg(a2)) throw Error(p2(418));
              a2.flags = a2.flags & -4097 | 2;
              I = false;
              xg = a2;
            }
          }
        }
        function Fg(a2) {
          for (a2 = a2.return; null !== a2 && 5 !== a2.tag && 3 !== a2.tag && 13 !== a2.tag; ) a2 = a2.return;
          xg = a2;
        }
        function Gg(a2) {
          if (a2 !== xg) return false;
          if (!I) return Fg(a2), I = true, false;
          var b;
          (b = 3 !== a2.tag) && !(b = 5 !== a2.tag) && (b = a2.type, b = "head" !== b && "body" !== b && !Ef(a2.type, a2.memoizedProps));
          if (b && (b = yg)) {
            if (Dg(a2)) throw Hg(), Error(p2(418));
            for (; b; ) Ag(a2, b), b = Lf(b.nextSibling);
          }
          Fg(a2);
          if (13 === a2.tag) {
            a2 = a2.memoizedState;
            a2 = null !== a2 ? a2.dehydrated : null;
            if (!a2) throw Error(p2(317));
            a: {
              a2 = a2.nextSibling;
              for (b = 0; a2; ) {
                if (8 === a2.nodeType) {
                  var c2 = a2.data;
                  if ("/$" === c2) {
                    if (0 === b) {
                      yg = Lf(a2.nextSibling);
                      break a;
                    }
                    b--;
                  } else "$" !== c2 && "$!" !== c2 && "$?" !== c2 || b++;
                }
                a2 = a2.nextSibling;
              }
              yg = null;
            }
          } else yg = xg ? Lf(a2.stateNode.nextSibling) : null;
          return true;
        }
        function Hg() {
          for (var a2 = yg; a2; ) a2 = Lf(a2.nextSibling);
        }
        function Ig() {
          yg = xg = null;
          I = false;
        }
        function Jg(a2) {
          null === zg ? zg = [a2] : zg.push(a2);
        }
        var Kg = ua.ReactCurrentBatchConfig;
        function Lg(a2, b, c2) {
          a2 = c2.ref;
          if (null !== a2 && "function" !== typeof a2 && "object" !== typeof a2) {
            if (c2._owner) {
              c2 = c2._owner;
              if (c2) {
                if (1 !== c2.tag) throw Error(p2(309));
                var d2 = c2.stateNode;
              }
              if (!d2) throw Error(p2(147, a2));
              var e2 = d2, f2 = "" + a2;
              if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f2) return b.ref;
              b = function(a3) {
                var b2 = e2.refs;
                null === a3 ? delete b2[f2] : b2[f2] = a3;
              };
              b._stringRef = f2;
              return b;
            }
            if ("string" !== typeof a2) throw Error(p2(284));
            if (!c2._owner) throw Error(p2(290, a2));
          }
          return a2;
        }
        function Mg(a2, b) {
          a2 = Object.prototype.toString.call(b);
          throw Error(p2(31, "[object Object]" === a2 ? "object with keys {" + Object.keys(b).join(", ") + "}" : a2));
        }
        function Ng(a2) {
          var b = a2._init;
          return b(a2._payload);
        }
        function Og(a2) {
          function b(b2, c3) {
            if (a2) {
              var d3 = b2.deletions;
              null === d3 ? (b2.deletions = [c3], b2.flags |= 16) : d3.push(c3);
            }
          }
          function c2(c3, d3) {
            if (!a2) return null;
            for (; null !== d3; ) b(c3, d3), d3 = d3.sibling;
            return null;
          }
          function d2(a3, b2) {
            for (a3 = /* @__PURE__ */ new Map(); null !== b2; ) null !== b2.key ? a3.set(b2.key, b2) : a3.set(b2.index, b2), b2 = b2.sibling;
            return a3;
          }
          function e2(a3, b2) {
            a3 = Pg(a3, b2);
            a3.index = 0;
            a3.sibling = null;
            return a3;
          }
          function f2(b2, c3, d3) {
            b2.index = d3;
            if (!a2) return b2.flags |= 1048576, c3;
            d3 = b2.alternate;
            if (null !== d3) return d3 = d3.index, d3 < c3 ? (b2.flags |= 2, c3) : d3;
            b2.flags |= 2;
            return c3;
          }
          function g2(b2) {
            a2 && null === b2.alternate && (b2.flags |= 2);
            return b2;
          }
          function h2(a3, b2, c3, d3) {
            if (null === b2 || 6 !== b2.tag) return b2 = Qg(c3, a3.mode, d3), b2.return = a3, b2;
            b2 = e2(b2, c3);
            b2.return = a3;
            return b2;
          }
          function k(a3, b2, c3, d3) {
            var f3 = c3.type;
            if (f3 === ya) return m2(a3, b2, c3.props.children, d3, c3.key);
            if (null !== b2 && (b2.elementType === f3 || "object" === typeof f3 && null !== f3 && f3.$$typeof === Ha && Ng(f3) === b2.type)) return d3 = e2(b2, c3.props), d3.ref = Lg(a3, b2, c3), d3.return = a3, d3;
            d3 = Rg(c3.type, c3.key, c3.props, null, a3.mode, d3);
            d3.ref = Lg(a3, b2, c3);
            d3.return = a3;
            return d3;
          }
          function l2(a3, b2, c3, d3) {
            if (null === b2 || 4 !== b2.tag || b2.stateNode.containerInfo !== c3.containerInfo || b2.stateNode.implementation !== c3.implementation) return b2 = Sg(c3, a3.mode, d3), b2.return = a3, b2;
            b2 = e2(b2, c3.children || []);
            b2.return = a3;
            return b2;
          }
          function m2(a3, b2, c3, d3, f3) {
            if (null === b2 || 7 !== b2.tag) return b2 = Tg(c3, a3.mode, d3, f3), b2.return = a3, b2;
            b2 = e2(b2, c3);
            b2.return = a3;
            return b2;
          }
          function q(a3, b2, c3) {
            if ("string" === typeof b2 && "" !== b2 || "number" === typeof b2) return b2 = Qg("" + b2, a3.mode, c3), b2.return = a3, b2;
            if ("object" === typeof b2 && null !== b2) {
              switch (b2.$$typeof) {
                case va:
                  return c3 = Rg(b2.type, b2.key, b2.props, null, a3.mode, c3), c3.ref = Lg(a3, null, b2), c3.return = a3, c3;
                case wa:
                  return b2 = Sg(b2, a3.mode, c3), b2.return = a3, b2;
                case Ha:
                  var d3 = b2._init;
                  return q(a3, d3(b2._payload), c3);
              }
              if (eb(b2) || Ka(b2)) return b2 = Tg(b2, a3.mode, c3, null), b2.return = a3, b2;
              Mg(a3, b2);
            }
            return null;
          }
          function r(a3, b2, c3, d3) {
            var e3 = null !== b2 ? b2.key : null;
            if ("string" === typeof c3 && "" !== c3 || "number" === typeof c3) return null !== e3 ? null : h2(a3, b2, "" + c3, d3);
            if ("object" === typeof c3 && null !== c3) {
              switch (c3.$$typeof) {
                case va:
                  return c3.key === e3 ? k(a3, b2, c3, d3) : null;
                case wa:
                  return c3.key === e3 ? l2(a3, b2, c3, d3) : null;
                case Ha:
                  return e3 = c3._init, r(
                    a3,
                    b2,
                    e3(c3._payload),
                    d3
                  );
              }
              if (eb(c3) || Ka(c3)) return null !== e3 ? null : m2(a3, b2, c3, d3, null);
              Mg(a3, c3);
            }
            return null;
          }
          function y(a3, b2, c3, d3, e3) {
            if ("string" === typeof d3 && "" !== d3 || "number" === typeof d3) return a3 = a3.get(c3) || null, h2(b2, a3, "" + d3, e3);
            if ("object" === typeof d3 && null !== d3) {
              switch (d3.$$typeof) {
                case va:
                  return a3 = a3.get(null === d3.key ? c3 : d3.key) || null, k(b2, a3, d3, e3);
                case wa:
                  return a3 = a3.get(null === d3.key ? c3 : d3.key) || null, l2(b2, a3, d3, e3);
                case Ha:
                  var f3 = d3._init;
                  return y(a3, b2, c3, f3(d3._payload), e3);
              }
              if (eb(d3) || Ka(d3)) return a3 = a3.get(c3) || null, m2(b2, a3, d3, e3, null);
              Mg(b2, d3);
            }
            return null;
          }
          function n2(e3, g3, h3, k2) {
            for (var l3 = null, m3 = null, u2 = g3, w = g3 = 0, x = null; null !== u2 && w < h3.length; w++) {
              u2.index > w ? (x = u2, u2 = null) : x = u2.sibling;
              var n3 = r(e3, u2, h3[w], k2);
              if (null === n3) {
                null === u2 && (u2 = x);
                break;
              }
              a2 && u2 && null === n3.alternate && b(e3, u2);
              g3 = f2(n3, g3, w);
              null === m3 ? l3 = n3 : m3.sibling = n3;
              m3 = n3;
              u2 = x;
            }
            if (w === h3.length) return c2(e3, u2), I && tg(e3, w), l3;
            if (null === u2) {
              for (; w < h3.length; w++) u2 = q(e3, h3[w], k2), null !== u2 && (g3 = f2(u2, g3, w), null === m3 ? l3 = u2 : m3.sibling = u2, m3 = u2);
              I && tg(e3, w);
              return l3;
            }
            for (u2 = d2(e3, u2); w < h3.length; w++) x = y(u2, e3, w, h3[w], k2), null !== x && (a2 && null !== x.alternate && u2.delete(null === x.key ? w : x.key), g3 = f2(x, g3, w), null === m3 ? l3 = x : m3.sibling = x, m3 = x);
            a2 && u2.forEach(function(a3) {
              return b(e3, a3);
            });
            I && tg(e3, w);
            return l3;
          }
          function t2(e3, g3, h3, k2) {
            var l3 = Ka(h3);
            if ("function" !== typeof l3) throw Error(p2(150));
            h3 = l3.call(h3);
            if (null == h3) throw Error(p2(151));
            for (var u2 = l3 = null, m3 = g3, w = g3 = 0, x = null, n3 = h3.next(); null !== m3 && !n3.done; w++, n3 = h3.next()) {
              m3.index > w ? (x = m3, m3 = null) : x = m3.sibling;
              var t3 = r(e3, m3, n3.value, k2);
              if (null === t3) {
                null === m3 && (m3 = x);
                break;
              }
              a2 && m3 && null === t3.alternate && b(e3, m3);
              g3 = f2(t3, g3, w);
              null === u2 ? l3 = t3 : u2.sibling = t3;
              u2 = t3;
              m3 = x;
            }
            if (n3.done) return c2(
              e3,
              m3
            ), I && tg(e3, w), l3;
            if (null === m3) {
              for (; !n3.done; w++, n3 = h3.next()) n3 = q(e3, n3.value, k2), null !== n3 && (g3 = f2(n3, g3, w), null === u2 ? l3 = n3 : u2.sibling = n3, u2 = n3);
              I && tg(e3, w);
              return l3;
            }
            for (m3 = d2(e3, m3); !n3.done; w++, n3 = h3.next()) n3 = y(m3, e3, w, n3.value, k2), null !== n3 && (a2 && null !== n3.alternate && m3.delete(null === n3.key ? w : n3.key), g3 = f2(n3, g3, w), null === u2 ? l3 = n3 : u2.sibling = n3, u2 = n3);
            a2 && m3.forEach(function(a3) {
              return b(e3, a3);
            });
            I && tg(e3, w);
            return l3;
          }
          function J(a3, d3, f3, h3) {
            "object" === typeof f3 && null !== f3 && f3.type === ya && null === f3.key && (f3 = f3.props.children);
            if ("object" === typeof f3 && null !== f3) {
              switch (f3.$$typeof) {
                case va:
                  a: {
                    for (var k2 = f3.key, l3 = d3; null !== l3; ) {
                      if (l3.key === k2) {
                        k2 = f3.type;
                        if (k2 === ya) {
                          if (7 === l3.tag) {
                            c2(a3, l3.sibling);
                            d3 = e2(l3, f3.props.children);
                            d3.return = a3;
                            a3 = d3;
                            break a;
                          }
                        } else if (l3.elementType === k2 || "object" === typeof k2 && null !== k2 && k2.$$typeof === Ha && Ng(k2) === l3.type) {
                          c2(a3, l3.sibling);
                          d3 = e2(l3, f3.props);
                          d3.ref = Lg(a3, l3, f3);
                          d3.return = a3;
                          a3 = d3;
                          break a;
                        }
                        c2(a3, l3);
                        break;
                      } else b(a3, l3);
                      l3 = l3.sibling;
                    }
                    f3.type === ya ? (d3 = Tg(f3.props.children, a3.mode, h3, f3.key), d3.return = a3, a3 = d3) : (h3 = Rg(f3.type, f3.key, f3.props, null, a3.mode, h3), h3.ref = Lg(a3, d3, f3), h3.return = a3, a3 = h3);
                  }
                  return g2(a3);
                case wa:
                  a: {
                    for (l3 = f3.key; null !== d3; ) {
                      if (d3.key === l3) if (4 === d3.tag && d3.stateNode.containerInfo === f3.containerInfo && d3.stateNode.implementation === f3.implementation) {
                        c2(a3, d3.sibling);
                        d3 = e2(d3, f3.children || []);
                        d3.return = a3;
                        a3 = d3;
                        break a;
                      } else {
                        c2(a3, d3);
                        break;
                      }
                      else b(a3, d3);
                      d3 = d3.sibling;
                    }
                    d3 = Sg(f3, a3.mode, h3);
                    d3.return = a3;
                    a3 = d3;
                  }
                  return g2(a3);
                case Ha:
                  return l3 = f3._init, J(a3, d3, l3(f3._payload), h3);
              }
              if (eb(f3)) return n2(a3, d3, f3, h3);
              if (Ka(f3)) return t2(a3, d3, f3, h3);
              Mg(a3, f3);
            }
            return "string" === typeof f3 && "" !== f3 || "number" === typeof f3 ? (f3 = "" + f3, null !== d3 && 6 === d3.tag ? (c2(a3, d3.sibling), d3 = e2(d3, f3), d3.return = a3, a3 = d3) : (c2(a3, d3), d3 = Qg(f3, a3.mode, h3), d3.return = a3, a3 = d3), g2(a3)) : c2(a3, d3);
          }
          return J;
        }
        var Ug = Og(true), Vg = Og(false), Wg = Uf(null), Xg = null, Yg = null, Zg = null;
        function $g() {
          Zg = Yg = Xg = null;
        }
        function ah(a2) {
          var b = Wg.current;
          E(Wg);
          a2._currentValue = b;
        }
        function bh(a2, b, c2) {
          for (; null !== a2; ) {
            var d2 = a2.alternate;
            (a2.childLanes & b) !== b ? (a2.childLanes |= b, null !== d2 && (d2.childLanes |= b)) : null !== d2 && (d2.childLanes & b) !== b && (d2.childLanes |= b);
            if (a2 === c2) break;
            a2 = a2.return;
          }
        }
        function ch(a2, b) {
          Xg = a2;
          Zg = Yg = null;
          a2 = a2.dependencies;
          null !== a2 && null !== a2.firstContext && (0 !== (a2.lanes & b) && (dh = true), a2.firstContext = null);
        }
        function eh(a2) {
          var b = a2._currentValue;
          if (Zg !== a2) if (a2 = { context: a2, memoizedValue: b, next: null }, null === Yg) {
            if (null === Xg) throw Error(p2(308));
            Yg = a2;
            Xg.dependencies = { lanes: 0, firstContext: a2 };
          } else Yg = Yg.next = a2;
          return b;
        }
        var fh = null;
        function gh(a2) {
          null === fh ? fh = [a2] : fh.push(a2);
        }
        function hh(a2, b, c2, d2) {
          var e2 = b.interleaved;
          null === e2 ? (c2.next = c2, gh(b)) : (c2.next = e2.next, e2.next = c2);
          b.interleaved = c2;
          return ih(a2, d2);
        }
        function ih(a2, b) {
          a2.lanes |= b;
          var c2 = a2.alternate;
          null !== c2 && (c2.lanes |= b);
          c2 = a2;
          for (a2 = a2.return; null !== a2; ) a2.childLanes |= b, c2 = a2.alternate, null !== c2 && (c2.childLanes |= b), c2 = a2, a2 = a2.return;
          return 3 === c2.tag ? c2.stateNode : null;
        }
        var jh = false;
        function kh(a2) {
          a2.updateQueue = { baseState: a2.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, interleaved: null, lanes: 0 }, effects: null };
        }
        function lh(a2, b) {
          a2 = a2.updateQueue;
          b.updateQueue === a2 && (b.updateQueue = { baseState: a2.baseState, firstBaseUpdate: a2.firstBaseUpdate, lastBaseUpdate: a2.lastBaseUpdate, shared: a2.shared, effects: a2.effects });
        }
        function mh(a2, b) {
          return { eventTime: a2, lane: b, tag: 0, payload: null, callback: null, next: null };
        }
        function nh(a2, b, c2) {
          var d2 = a2.updateQueue;
          if (null === d2) return null;
          d2 = d2.shared;
          if (0 !== (K & 2)) {
            var e2 = d2.pending;
            null === e2 ? b.next = b : (b.next = e2.next, e2.next = b);
            d2.pending = b;
            return ih(a2, c2);
          }
          e2 = d2.interleaved;
          null === e2 ? (b.next = b, gh(d2)) : (b.next = e2.next, e2.next = b);
          d2.interleaved = b;
          return ih(a2, c2);
        }
        function oh(a2, b, c2) {
          b = b.updateQueue;
          if (null !== b && (b = b.shared, 0 !== (c2 & 4194240))) {
            var d2 = b.lanes;
            d2 &= a2.pendingLanes;
            c2 |= d2;
            b.lanes = c2;
            Cc(a2, c2);
          }
        }
        function ph(a2, b) {
          var c2 = a2.updateQueue, d2 = a2.alternate;
          if (null !== d2 && (d2 = d2.updateQueue, c2 === d2)) {
            var e2 = null, f2 = null;
            c2 = c2.firstBaseUpdate;
            if (null !== c2) {
              do {
                var g2 = { eventTime: c2.eventTime, lane: c2.lane, tag: c2.tag, payload: c2.payload, callback: c2.callback, next: null };
                null === f2 ? e2 = f2 = g2 : f2 = f2.next = g2;
                c2 = c2.next;
              } while (null !== c2);
              null === f2 ? e2 = f2 = b : f2 = f2.next = b;
            } else e2 = f2 = b;
            c2 = { baseState: d2.baseState, firstBaseUpdate: e2, lastBaseUpdate: f2, shared: d2.shared, effects: d2.effects };
            a2.updateQueue = c2;
            return;
          }
          a2 = c2.lastBaseUpdate;
          null === a2 ? c2.firstBaseUpdate = b : a2.next = b;
          c2.lastBaseUpdate = b;
        }
        function qh(a2, b, c2, d2) {
          var e2 = a2.updateQueue;
          jh = false;
          var f2 = e2.firstBaseUpdate, g2 = e2.lastBaseUpdate, h2 = e2.shared.pending;
          if (null !== h2) {
            e2.shared.pending = null;
            var k = h2, l2 = k.next;
            k.next = null;
            null === g2 ? f2 = l2 : g2.next = l2;
            g2 = k;
            var m2 = a2.alternate;
            null !== m2 && (m2 = m2.updateQueue, h2 = m2.lastBaseUpdate, h2 !== g2 && (null === h2 ? m2.firstBaseUpdate = l2 : h2.next = l2, m2.lastBaseUpdate = k));
          }
          if (null !== f2) {
            var q = e2.baseState;
            g2 = 0;
            m2 = l2 = k = null;
            h2 = f2;
            do {
              var r = h2.lane, y = h2.eventTime;
              if ((d2 & r) === r) {
                null !== m2 && (m2 = m2.next = {
                  eventTime: y,
                  lane: 0,
                  tag: h2.tag,
                  payload: h2.payload,
                  callback: h2.callback,
                  next: null
                });
                a: {
                  var n2 = a2, t2 = h2;
                  r = b;
                  y = c2;
                  switch (t2.tag) {
                    case 1:
                      n2 = t2.payload;
                      if ("function" === typeof n2) {
                        q = n2.call(y, q, r);
                        break a;
                      }
                      q = n2;
                      break a;
                    case 3:
                      n2.flags = n2.flags & -65537 | 128;
                    case 0:
                      n2 = t2.payload;
                      r = "function" === typeof n2 ? n2.call(y, q, r) : n2;
                      if (null === r || void 0 === r) break a;
                      q = A({}, q, r);
                      break a;
                    case 2:
                      jh = true;
                  }
                }
                null !== h2.callback && 0 !== h2.lane && (a2.flags |= 64, r = e2.effects, null === r ? e2.effects = [h2] : r.push(h2));
              } else y = { eventTime: y, lane: r, tag: h2.tag, payload: h2.payload, callback: h2.callback, next: null }, null === m2 ? (l2 = m2 = y, k = q) : m2 = m2.next = y, g2 |= r;
              h2 = h2.next;
              if (null === h2) if (h2 = e2.shared.pending, null === h2) break;
              else r = h2, h2 = r.next, r.next = null, e2.lastBaseUpdate = r, e2.shared.pending = null;
            } while (1);
            null === m2 && (k = q);
            e2.baseState = k;
            e2.firstBaseUpdate = l2;
            e2.lastBaseUpdate = m2;
            b = e2.shared.interleaved;
            if (null !== b) {
              e2 = b;
              do
                g2 |= e2.lane, e2 = e2.next;
              while (e2 !== b);
            } else null === f2 && (e2.shared.lanes = 0);
            rh |= g2;
            a2.lanes = g2;
            a2.memoizedState = q;
          }
        }
        function sh(a2, b, c2) {
          a2 = b.effects;
          b.effects = null;
          if (null !== a2) for (b = 0; b < a2.length; b++) {
            var d2 = a2[b], e2 = d2.callback;
            if (null !== e2) {
              d2.callback = null;
              d2 = c2;
              if ("function" !== typeof e2) throw Error(p2(191, e2));
              e2.call(d2);
            }
          }
        }
        var th = {}, uh = Uf(th), vh = Uf(th), wh = Uf(th);
        function xh(a2) {
          if (a2 === th) throw Error(p2(174));
          return a2;
        }
        function yh(a2, b) {
          G(wh, b);
          G(vh, a2);
          G(uh, th);
          a2 = b.nodeType;
          switch (a2) {
            case 9:
            case 11:
              b = (b = b.documentElement) ? b.namespaceURI : lb(null, "");
              break;
            default:
              a2 = 8 === a2 ? b.parentNode : b, b = a2.namespaceURI || null, a2 = a2.tagName, b = lb(b, a2);
          }
          E(uh);
          G(uh, b);
        }
        function zh() {
          E(uh);
          E(vh);
          E(wh);
        }
        function Ah(a2) {
          xh(wh.current);
          var b = xh(uh.current);
          var c2 = lb(b, a2.type);
          b !== c2 && (G(vh, a2), G(uh, c2));
        }
        function Bh(a2) {
          vh.current === a2 && (E(uh), E(vh));
        }
        var L = Uf(0);
        function Ch(a2) {
          for (var b = a2; null !== b; ) {
            if (13 === b.tag) {
              var c2 = b.memoizedState;
              if (null !== c2 && (c2 = c2.dehydrated, null === c2 || "$?" === c2.data || "$!" === c2.data)) return b;
            } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
              if (0 !== (b.flags & 128)) return b;
            } else if (null !== b.child) {
              b.child.return = b;
              b = b.child;
              continue;
            }
            if (b === a2) break;
            for (; null === b.sibling; ) {
              if (null === b.return || b.return === a2) return null;
              b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
          }
          return null;
        }
        var Dh = [];
        function Eh() {
          for (var a2 = 0; a2 < Dh.length; a2++) Dh[a2]._workInProgressVersionPrimary = null;
          Dh.length = 0;
        }
        var Fh = ua.ReactCurrentDispatcher, Gh = ua.ReactCurrentBatchConfig, Hh = 0, M = null, N = null, O = null, Ih = false, Jh = false, Kh = 0, Lh = 0;
        function P() {
          throw Error(p2(321));
        }
        function Mh(a2, b) {
          if (null === b) return false;
          for (var c2 = 0; c2 < b.length && c2 < a2.length; c2++) if (!He(a2[c2], b[c2])) return false;
          return true;
        }
        function Nh(a2, b, c2, d2, e2, f2) {
          Hh = f2;
          M = b;
          b.memoizedState = null;
          b.updateQueue = null;
          b.lanes = 0;
          Fh.current = null === a2 || null === a2.memoizedState ? Oh : Ph;
          a2 = c2(d2, e2);
          if (Jh) {
            f2 = 0;
            do {
              Jh = false;
              Kh = 0;
              if (25 <= f2) throw Error(p2(301));
              f2 += 1;
              O = N = null;
              b.updateQueue = null;
              Fh.current = Qh;
              a2 = c2(d2, e2);
            } while (Jh);
          }
          Fh.current = Rh;
          b = null !== N && null !== N.next;
          Hh = 0;
          O = N = M = null;
          Ih = false;
          if (b) throw Error(p2(300));
          return a2;
        }
        function Sh() {
          var a2 = 0 !== Kh;
          Kh = 0;
          return a2;
        }
        function Th() {
          var a2 = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
          null === O ? M.memoizedState = O = a2 : O = O.next = a2;
          return O;
        }
        function Uh() {
          if (null === N) {
            var a2 = M.alternate;
            a2 = null !== a2 ? a2.memoizedState : null;
          } else a2 = N.next;
          var b = null === O ? M.memoizedState : O.next;
          if (null !== b) O = b, N = a2;
          else {
            if (null === a2) throw Error(p2(310));
            N = a2;
            a2 = { memoizedState: N.memoizedState, baseState: N.baseState, baseQueue: N.baseQueue, queue: N.queue, next: null };
            null === O ? M.memoizedState = O = a2 : O = O.next = a2;
          }
          return O;
        }
        function Vh(a2, b) {
          return "function" === typeof b ? b(a2) : b;
        }
        function Wh(a2) {
          var b = Uh(), c2 = b.queue;
          if (null === c2) throw Error(p2(311));
          c2.lastRenderedReducer = a2;
          var d2 = N, e2 = d2.baseQueue, f2 = c2.pending;
          if (null !== f2) {
            if (null !== e2) {
              var g2 = e2.next;
              e2.next = f2.next;
              f2.next = g2;
            }
            d2.baseQueue = e2 = f2;
            c2.pending = null;
          }
          if (null !== e2) {
            f2 = e2.next;
            d2 = d2.baseState;
            var h2 = g2 = null, k = null, l2 = f2;
            do {
              var m2 = l2.lane;
              if ((Hh & m2) === m2) null !== k && (k = k.next = { lane: 0, action: l2.action, hasEagerState: l2.hasEagerState, eagerState: l2.eagerState, next: null }), d2 = l2.hasEagerState ? l2.eagerState : a2(d2, l2.action);
              else {
                var q = {
                  lane: m2,
                  action: l2.action,
                  hasEagerState: l2.hasEagerState,
                  eagerState: l2.eagerState,
                  next: null
                };
                null === k ? (h2 = k = q, g2 = d2) : k = k.next = q;
                M.lanes |= m2;
                rh |= m2;
              }
              l2 = l2.next;
            } while (null !== l2 && l2 !== f2);
            null === k ? g2 = d2 : k.next = h2;
            He(d2, b.memoizedState) || (dh = true);
            b.memoizedState = d2;
            b.baseState = g2;
            b.baseQueue = k;
            c2.lastRenderedState = d2;
          }
          a2 = c2.interleaved;
          if (null !== a2) {
            e2 = a2;
            do
              f2 = e2.lane, M.lanes |= f2, rh |= f2, e2 = e2.next;
            while (e2 !== a2);
          } else null === e2 && (c2.lanes = 0);
          return [b.memoizedState, c2.dispatch];
        }
        function Xh(a2) {
          var b = Uh(), c2 = b.queue;
          if (null === c2) throw Error(p2(311));
          c2.lastRenderedReducer = a2;
          var d2 = c2.dispatch, e2 = c2.pending, f2 = b.memoizedState;
          if (null !== e2) {
            c2.pending = null;
            var g2 = e2 = e2.next;
            do
              f2 = a2(f2, g2.action), g2 = g2.next;
            while (g2 !== e2);
            He(f2, b.memoizedState) || (dh = true);
            b.memoizedState = f2;
            null === b.baseQueue && (b.baseState = f2);
            c2.lastRenderedState = f2;
          }
          return [f2, d2];
        }
        function Yh() {
        }
        function Zh(a2, b) {
          var c2 = M, d2 = Uh(), e2 = b(), f2 = !He(d2.memoizedState, e2);
          f2 && (d2.memoizedState = e2, dh = true);
          d2 = d2.queue;
          $h(ai.bind(null, c2, d2, a2), [a2]);
          if (d2.getSnapshot !== b || f2 || null !== O && O.memoizedState.tag & 1) {
            c2.flags |= 2048;
            bi(9, ci.bind(null, c2, d2, e2, b), void 0, null);
            if (null === Q) throw Error(p2(349));
            0 !== (Hh & 30) || di(c2, b, e2);
          }
          return e2;
        }
        function di(a2, b, c2) {
          a2.flags |= 16384;
          a2 = { getSnapshot: b, value: c2 };
          b = M.updateQueue;
          null === b ? (b = { lastEffect: null, stores: null }, M.updateQueue = b, b.stores = [a2]) : (c2 = b.stores, null === c2 ? b.stores = [a2] : c2.push(a2));
        }
        function ci(a2, b, c2, d2) {
          b.value = c2;
          b.getSnapshot = d2;
          ei(b) && fi(a2);
        }
        function ai(a2, b, c2) {
          return c2(function() {
            ei(b) && fi(a2);
          });
        }
        function ei(a2) {
          var b = a2.getSnapshot;
          a2 = a2.value;
          try {
            var c2 = b();
            return !He(a2, c2);
          } catch (d2) {
            return true;
          }
        }
        function fi(a2) {
          var b = ih(a2, 1);
          null !== b && gi(b, a2, 1, -1);
        }
        function hi(a2) {
          var b = Th();
          "function" === typeof a2 && (a2 = a2());
          b.memoizedState = b.baseState = a2;
          a2 = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: Vh, lastRenderedState: a2 };
          b.queue = a2;
          a2 = a2.dispatch = ii.bind(null, M, a2);
          return [b.memoizedState, a2];
        }
        function bi(a2, b, c2, d2) {
          a2 = { tag: a2, create: b, destroy: c2, deps: d2, next: null };
          b = M.updateQueue;
          null === b ? (b = { lastEffect: null, stores: null }, M.updateQueue = b, b.lastEffect = a2.next = a2) : (c2 = b.lastEffect, null === c2 ? b.lastEffect = a2.next = a2 : (d2 = c2.next, c2.next = a2, a2.next = d2, b.lastEffect = a2));
          return a2;
        }
        function ji() {
          return Uh().memoizedState;
        }
        function ki(a2, b, c2, d2) {
          var e2 = Th();
          M.flags |= a2;
          e2.memoizedState = bi(1 | b, c2, void 0, void 0 === d2 ? null : d2);
        }
        function li(a2, b, c2, d2) {
          var e2 = Uh();
          d2 = void 0 === d2 ? null : d2;
          var f2 = void 0;
          if (null !== N) {
            var g2 = N.memoizedState;
            f2 = g2.destroy;
            if (null !== d2 && Mh(d2, g2.deps)) {
              e2.memoizedState = bi(b, c2, f2, d2);
              return;
            }
          }
          M.flags |= a2;
          e2.memoizedState = bi(1 | b, c2, f2, d2);
        }
        function mi(a2, b) {
          return ki(8390656, 8, a2, b);
        }
        function $h(a2, b) {
          return li(2048, 8, a2, b);
        }
        function ni(a2, b) {
          return li(4, 2, a2, b);
        }
        function oi(a2, b) {
          return li(4, 4, a2, b);
        }
        function pi(a2, b) {
          if ("function" === typeof b) return a2 = a2(), b(a2), function() {
            b(null);
          };
          if (null !== b && void 0 !== b) return a2 = a2(), b.current = a2, function() {
            b.current = null;
          };
        }
        function qi(a2, b, c2) {
          c2 = null !== c2 && void 0 !== c2 ? c2.concat([a2]) : null;
          return li(4, 4, pi.bind(null, b, a2), c2);
        }
        function ri() {
        }
        function si(a2, b) {
          var c2 = Uh();
          b = void 0 === b ? null : b;
          var d2 = c2.memoizedState;
          if (null !== d2 && null !== b && Mh(b, d2[1])) return d2[0];
          c2.memoizedState = [a2, b];
          return a2;
        }
        function ti(a2, b) {
          var c2 = Uh();
          b = void 0 === b ? null : b;
          var d2 = c2.memoizedState;
          if (null !== d2 && null !== b && Mh(b, d2[1])) return d2[0];
          a2 = a2();
          c2.memoizedState = [a2, b];
          return a2;
        }
        function ui(a2, b, c2) {
          if (0 === (Hh & 21)) return a2.baseState && (a2.baseState = false, dh = true), a2.memoizedState = c2;
          He(c2, b) || (c2 = yc(), M.lanes |= c2, rh |= c2, a2.baseState = true);
          return b;
        }
        function vi(a2, b) {
          var c2 = C;
          C = 0 !== c2 && 4 > c2 ? c2 : 4;
          a2(true);
          var d2 = Gh.transition;
          Gh.transition = {};
          try {
            a2(false), b();
          } finally {
            C = c2, Gh.transition = d2;
          }
        }
        function wi() {
          return Uh().memoizedState;
        }
        function xi(a2, b, c2) {
          var d2 = yi(a2);
          c2 = { lane: d2, action: c2, hasEagerState: false, eagerState: null, next: null };
          if (zi(a2)) Ai(b, c2);
          else if (c2 = hh(a2, b, c2, d2), null !== c2) {
            var e2 = R();
            gi(c2, a2, d2, e2);
            Bi(c2, b, d2);
          }
        }
        function ii(a2, b, c2) {
          var d2 = yi(a2), e2 = { lane: d2, action: c2, hasEagerState: false, eagerState: null, next: null };
          if (zi(a2)) Ai(b, e2);
          else {
            var f2 = a2.alternate;
            if (0 === a2.lanes && (null === f2 || 0 === f2.lanes) && (f2 = b.lastRenderedReducer, null !== f2)) try {
              var g2 = b.lastRenderedState, h2 = f2(g2, c2);
              e2.hasEagerState = true;
              e2.eagerState = h2;
              if (He(h2, g2)) {
                var k = b.interleaved;
                null === k ? (e2.next = e2, gh(b)) : (e2.next = k.next, k.next = e2);
                b.interleaved = e2;
                return;
              }
            } catch (l2) {
            } finally {
            }
            c2 = hh(a2, b, e2, d2);
            null !== c2 && (e2 = R(), gi(c2, a2, d2, e2), Bi(c2, b, d2));
          }
        }
        function zi(a2) {
          var b = a2.alternate;
          return a2 === M || null !== b && b === M;
        }
        function Ai(a2, b) {
          Jh = Ih = true;
          var c2 = a2.pending;
          null === c2 ? b.next = b : (b.next = c2.next, c2.next = b);
          a2.pending = b;
        }
        function Bi(a2, b, c2) {
          if (0 !== (c2 & 4194240)) {
            var d2 = b.lanes;
            d2 &= a2.pendingLanes;
            c2 |= d2;
            b.lanes = c2;
            Cc(a2, c2);
          }
        }
        var Rh = { readContext: eh, useCallback: P, useContext: P, useEffect: P, useImperativeHandle: P, useInsertionEffect: P, useLayoutEffect: P, useMemo: P, useReducer: P, useRef: P, useState: P, useDebugValue: P, useDeferredValue: P, useTransition: P, useMutableSource: P, useSyncExternalStore: P, useId: P, unstable_isNewReconciler: false }, Oh = { readContext: eh, useCallback: function(a2, b) {
          Th().memoizedState = [a2, void 0 === b ? null : b];
          return a2;
        }, useContext: eh, useEffect: mi, useImperativeHandle: function(a2, b, c2) {
          c2 = null !== c2 && void 0 !== c2 ? c2.concat([a2]) : null;
          return ki(
            4194308,
            4,
            pi.bind(null, b, a2),
            c2
          );
        }, useLayoutEffect: function(a2, b) {
          return ki(4194308, 4, a2, b);
        }, useInsertionEffect: function(a2, b) {
          return ki(4, 2, a2, b);
        }, useMemo: function(a2, b) {
          var c2 = Th();
          b = void 0 === b ? null : b;
          a2 = a2();
          c2.memoizedState = [a2, b];
          return a2;
        }, useReducer: function(a2, b, c2) {
          var d2 = Th();
          b = void 0 !== c2 ? c2(b) : b;
          d2.memoizedState = d2.baseState = b;
          a2 = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: a2, lastRenderedState: b };
          d2.queue = a2;
          a2 = a2.dispatch = xi.bind(null, M, a2);
          return [d2.memoizedState, a2];
        }, useRef: function(a2) {
          var b = Th();
          a2 = { current: a2 };
          return b.memoizedState = a2;
        }, useState: hi, useDebugValue: ri, useDeferredValue: function(a2) {
          return Th().memoizedState = a2;
        }, useTransition: function() {
          var a2 = hi(false), b = a2[0];
          a2 = vi.bind(null, a2[1]);
          Th().memoizedState = a2;
          return [b, a2];
        }, useMutableSource: function() {
        }, useSyncExternalStore: function(a2, b, c2) {
          var d2 = M, e2 = Th();
          if (I) {
            if (void 0 === c2) throw Error(p2(407));
            c2 = c2();
          } else {
            c2 = b();
            if (null === Q) throw Error(p2(349));
            0 !== (Hh & 30) || di(d2, b, c2);
          }
          e2.memoizedState = c2;
          var f2 = { value: c2, getSnapshot: b };
          e2.queue = f2;
          mi(ai.bind(
            null,
            d2,
            f2,
            a2
          ), [a2]);
          d2.flags |= 2048;
          bi(9, ci.bind(null, d2, f2, c2, b), void 0, null);
          return c2;
        }, useId: function() {
          var a2 = Th(), b = Q.identifierPrefix;
          if (I) {
            var c2 = sg;
            var d2 = rg;
            c2 = (d2 & ~(1 << 32 - oc(d2) - 1)).toString(32) + c2;
            b = ":" + b + "R" + c2;
            c2 = Kh++;
            0 < c2 && (b += "H" + c2.toString(32));
            b += ":";
          } else c2 = Lh++, b = ":" + b + "r" + c2.toString(32) + ":";
          return a2.memoizedState = b;
        }, unstable_isNewReconciler: false }, Ph = {
          readContext: eh,
          useCallback: si,
          useContext: eh,
          useEffect: $h,
          useImperativeHandle: qi,
          useInsertionEffect: ni,
          useLayoutEffect: oi,
          useMemo: ti,
          useReducer: Wh,
          useRef: ji,
          useState: function() {
            return Wh(Vh);
          },
          useDebugValue: ri,
          useDeferredValue: function(a2) {
            var b = Uh();
            return ui(b, N.memoizedState, a2);
          },
          useTransition: function() {
            var a2 = Wh(Vh)[0], b = Uh().memoizedState;
            return [a2, b];
          },
          useMutableSource: Yh,
          useSyncExternalStore: Zh,
          useId: wi,
          unstable_isNewReconciler: false
        }, Qh = { readContext: eh, useCallback: si, useContext: eh, useEffect: $h, useImperativeHandle: qi, useInsertionEffect: ni, useLayoutEffect: oi, useMemo: ti, useReducer: Xh, useRef: ji, useState: function() {
          return Xh(Vh);
        }, useDebugValue: ri, useDeferredValue: function(a2) {
          var b = Uh();
          return null === N ? b.memoizedState = a2 : ui(b, N.memoizedState, a2);
        }, useTransition: function() {
          var a2 = Xh(Vh)[0], b = Uh().memoizedState;
          return [a2, b];
        }, useMutableSource: Yh, useSyncExternalStore: Zh, useId: wi, unstable_isNewReconciler: false };
        function Ci(a2, b) {
          if (a2 && a2.defaultProps) {
            b = A({}, b);
            a2 = a2.defaultProps;
            for (var c2 in a2) void 0 === b[c2] && (b[c2] = a2[c2]);
            return b;
          }
          return b;
        }
        function Di(a2, b, c2, d2) {
          b = a2.memoizedState;
          c2 = c2(d2, b);
          c2 = null === c2 || void 0 === c2 ? b : A({}, b, c2);
          a2.memoizedState = c2;
          0 === a2.lanes && (a2.updateQueue.baseState = c2);
        }
        var Ei = { isMounted: function(a2) {
          return (a2 = a2._reactInternals) ? Vb(a2) === a2 : false;
        }, enqueueSetState: function(a2, b, c2) {
          a2 = a2._reactInternals;
          var d2 = R(), e2 = yi(a2), f2 = mh(d2, e2);
          f2.payload = b;
          void 0 !== c2 && null !== c2 && (f2.callback = c2);
          b = nh(a2, f2, e2);
          null !== b && (gi(b, a2, e2, d2), oh(b, a2, e2));
        }, enqueueReplaceState: function(a2, b, c2) {
          a2 = a2._reactInternals;
          var d2 = R(), e2 = yi(a2), f2 = mh(d2, e2);
          f2.tag = 1;
          f2.payload = b;
          void 0 !== c2 && null !== c2 && (f2.callback = c2);
          b = nh(a2, f2, e2);
          null !== b && (gi(b, a2, e2, d2), oh(b, a2, e2));
        }, enqueueForceUpdate: function(a2, b) {
          a2 = a2._reactInternals;
          var c2 = R(), d2 = yi(a2), e2 = mh(c2, d2);
          e2.tag = 2;
          void 0 !== b && null !== b && (e2.callback = b);
          b = nh(a2, e2, d2);
          null !== b && (gi(b, a2, d2, c2), oh(b, a2, d2));
        } };
        function Fi(a2, b, c2, d2, e2, f2, g2) {
          a2 = a2.stateNode;
          return "function" === typeof a2.shouldComponentUpdate ? a2.shouldComponentUpdate(d2, f2, g2) : b.prototype && b.prototype.isPureReactComponent ? !Ie(c2, d2) || !Ie(e2, f2) : true;
        }
        function Gi(a2, b, c2) {
          var d2 = false, e2 = Vf;
          var f2 = b.contextType;
          "object" === typeof f2 && null !== f2 ? f2 = eh(f2) : (e2 = Zf(b) ? Xf : H.current, d2 = b.contextTypes, f2 = (d2 = null !== d2 && void 0 !== d2) ? Yf(a2, e2) : Vf);
          b = new b(c2, f2);
          a2.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
          b.updater = Ei;
          a2.stateNode = b;
          b._reactInternals = a2;
          d2 && (a2 = a2.stateNode, a2.__reactInternalMemoizedUnmaskedChildContext = e2, a2.__reactInternalMemoizedMaskedChildContext = f2);
          return b;
        }
        function Hi(a2, b, c2, d2) {
          a2 = b.state;
          "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c2, d2);
          "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c2, d2);
          b.state !== a2 && Ei.enqueueReplaceState(b, b.state, null);
        }
        function Ii(a2, b, c2, d2) {
          var e2 = a2.stateNode;
          e2.props = c2;
          e2.state = a2.memoizedState;
          e2.refs = {};
          kh(a2);
          var f2 = b.contextType;
          "object" === typeof f2 && null !== f2 ? e2.context = eh(f2) : (f2 = Zf(b) ? Xf : H.current, e2.context = Yf(a2, f2));
          e2.state = a2.memoizedState;
          f2 = b.getDerivedStateFromProps;
          "function" === typeof f2 && (Di(a2, b, f2, c2), e2.state = a2.memoizedState);
          "function" === typeof b.getDerivedStateFromProps || "function" === typeof e2.getSnapshotBeforeUpdate || "function" !== typeof e2.UNSAFE_componentWillMount && "function" !== typeof e2.componentWillMount || (b = e2.state, "function" === typeof e2.componentWillMount && e2.componentWillMount(), "function" === typeof e2.UNSAFE_componentWillMount && e2.UNSAFE_componentWillMount(), b !== e2.state && Ei.enqueueReplaceState(e2, e2.state, null), qh(a2, c2, e2, d2), e2.state = a2.memoizedState);
          "function" === typeof e2.componentDidMount && (a2.flags |= 4194308);
        }
        function Ji(a2, b) {
          try {
            var c2 = "", d2 = b;
            do
              c2 += Pa(d2), d2 = d2.return;
            while (d2);
            var e2 = c2;
          } catch (f2) {
            e2 = "\nError generating stack: " + f2.message + "\n" + f2.stack;
          }
          return { value: a2, source: b, stack: e2, digest: null };
        }
        function Ki(a2, b, c2) {
          return { value: a2, source: null, stack: null != c2 ? c2 : null, digest: null != b ? b : null };
        }
        function Li(a2, b) {
          try {
            console.error(b.value);
          } catch (c2) {
            setTimeout(function() {
              throw c2;
            });
          }
        }
        var Mi = "function" === typeof WeakMap ? WeakMap : Map;
        function Ni(a2, b, c2) {
          c2 = mh(-1, c2);
          c2.tag = 3;
          c2.payload = { element: null };
          var d2 = b.value;
          c2.callback = function() {
            Oi || (Oi = true, Pi = d2);
            Li(a2, b);
          };
          return c2;
        }
        function Qi(a2, b, c2) {
          c2 = mh(-1, c2);
          c2.tag = 3;
          var d2 = a2.type.getDerivedStateFromError;
          if ("function" === typeof d2) {
            var e2 = b.value;
            c2.payload = function() {
              return d2(e2);
            };
            c2.callback = function() {
              Li(a2, b);
            };
          }
          var f2 = a2.stateNode;
          null !== f2 && "function" === typeof f2.componentDidCatch && (c2.callback = function() {
            Li(a2, b);
            "function" !== typeof d2 && (null === Ri ? Ri = /* @__PURE__ */ new Set([this]) : Ri.add(this));
            var c3 = b.stack;
            this.componentDidCatch(b.value, { componentStack: null !== c3 ? c3 : "" });
          });
          return c2;
        }
        function Si(a2, b, c2) {
          var d2 = a2.pingCache;
          if (null === d2) {
            d2 = a2.pingCache = new Mi();
            var e2 = /* @__PURE__ */ new Set();
            d2.set(b, e2);
          } else e2 = d2.get(b), void 0 === e2 && (e2 = /* @__PURE__ */ new Set(), d2.set(b, e2));
          e2.has(c2) || (e2.add(c2), a2 = Ti.bind(null, a2, b, c2), b.then(a2, a2));
        }
        function Ui(a2) {
          do {
            var b;
            if (b = 13 === a2.tag) b = a2.memoizedState, b = null !== b ? null !== b.dehydrated ? true : false : true;
            if (b) return a2;
            a2 = a2.return;
          } while (null !== a2);
          return null;
        }
        function Vi(a2, b, c2, d2, e2) {
          if (0 === (a2.mode & 1)) return a2 === b ? a2.flags |= 65536 : (a2.flags |= 128, c2.flags |= 131072, c2.flags &= -52805, 1 === c2.tag && (null === c2.alternate ? c2.tag = 17 : (b = mh(-1, 1), b.tag = 2, nh(c2, b, 1))), c2.lanes |= 1), a2;
          a2.flags |= 65536;
          a2.lanes = e2;
          return a2;
        }
        var Wi = ua.ReactCurrentOwner, dh = false;
        function Xi(a2, b, c2, d2) {
          b.child = null === a2 ? Vg(b, null, c2, d2) : Ug(b, a2.child, c2, d2);
        }
        function Yi(a2, b, c2, d2, e2) {
          c2 = c2.render;
          var f2 = b.ref;
          ch(b, e2);
          d2 = Nh(a2, b, c2, d2, f2, e2);
          c2 = Sh();
          if (null !== a2 && !dh) return b.updateQueue = a2.updateQueue, b.flags &= -2053, a2.lanes &= ~e2, Zi(a2, b, e2);
          I && c2 && vg(b);
          b.flags |= 1;
          Xi(a2, b, d2, e2);
          return b.child;
        }
        function $i(a2, b, c2, d2, e2) {
          if (null === a2) {
            var f2 = c2.type;
            if ("function" === typeof f2 && !aj(f2) && void 0 === f2.defaultProps && null === c2.compare && void 0 === c2.defaultProps) return b.tag = 15, b.type = f2, bj(a2, b, f2, d2, e2);
            a2 = Rg(c2.type, null, d2, b, b.mode, e2);
            a2.ref = b.ref;
            a2.return = b;
            return b.child = a2;
          }
          f2 = a2.child;
          if (0 === (a2.lanes & e2)) {
            var g2 = f2.memoizedProps;
            c2 = c2.compare;
            c2 = null !== c2 ? c2 : Ie;
            if (c2(g2, d2) && a2.ref === b.ref) return Zi(a2, b, e2);
          }
          b.flags |= 1;
          a2 = Pg(f2, d2);
          a2.ref = b.ref;
          a2.return = b;
          return b.child = a2;
        }
        function bj(a2, b, c2, d2, e2) {
          if (null !== a2) {
            var f2 = a2.memoizedProps;
            if (Ie(f2, d2) && a2.ref === b.ref) if (dh = false, b.pendingProps = d2 = f2, 0 !== (a2.lanes & e2)) 0 !== (a2.flags & 131072) && (dh = true);
            else return b.lanes = a2.lanes, Zi(a2, b, e2);
          }
          return cj(a2, b, c2, d2, e2);
        }
        function dj(a2, b, c2) {
          var d2 = b.pendingProps, e2 = d2.children, f2 = null !== a2 ? a2.memoizedState : null;
          if ("hidden" === d2.mode) if (0 === (b.mode & 1)) b.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, G(ej, fj), fj |= c2;
          else {
            if (0 === (c2 & 1073741824)) return a2 = null !== f2 ? f2.baseLanes | c2 : c2, b.lanes = b.childLanes = 1073741824, b.memoizedState = { baseLanes: a2, cachePool: null, transitions: null }, b.updateQueue = null, G(ej, fj), fj |= a2, null;
            b.memoizedState = { baseLanes: 0, cachePool: null, transitions: null };
            d2 = null !== f2 ? f2.baseLanes : c2;
            G(ej, fj);
            fj |= d2;
          }
          else null !== f2 ? (d2 = f2.baseLanes | c2, b.memoizedState = null) : d2 = c2, G(ej, fj), fj |= d2;
          Xi(a2, b, e2, c2);
          return b.child;
        }
        function gj(a2, b) {
          var c2 = b.ref;
          if (null === a2 && null !== c2 || null !== a2 && a2.ref !== c2) b.flags |= 512, b.flags |= 2097152;
        }
        function cj(a2, b, c2, d2, e2) {
          var f2 = Zf(c2) ? Xf : H.current;
          f2 = Yf(b, f2);
          ch(b, e2);
          c2 = Nh(a2, b, c2, d2, f2, e2);
          d2 = Sh();
          if (null !== a2 && !dh) return b.updateQueue = a2.updateQueue, b.flags &= -2053, a2.lanes &= ~e2, Zi(a2, b, e2);
          I && d2 && vg(b);
          b.flags |= 1;
          Xi(a2, b, c2, e2);
          return b.child;
        }
        function hj(a2, b, c2, d2, e2) {
          if (Zf(c2)) {
            var f2 = true;
            cg(b);
          } else f2 = false;
          ch(b, e2);
          if (null === b.stateNode) ij(a2, b), Gi(b, c2, d2), Ii(b, c2, d2, e2), d2 = true;
          else if (null === a2) {
            var g2 = b.stateNode, h2 = b.memoizedProps;
            g2.props = h2;
            var k = g2.context, l2 = c2.contextType;
            "object" === typeof l2 && null !== l2 ? l2 = eh(l2) : (l2 = Zf(c2) ? Xf : H.current, l2 = Yf(b, l2));
            var m2 = c2.getDerivedStateFromProps, q = "function" === typeof m2 || "function" === typeof g2.getSnapshotBeforeUpdate;
            q || "function" !== typeof g2.UNSAFE_componentWillReceiveProps && "function" !== typeof g2.componentWillReceiveProps || (h2 !== d2 || k !== l2) && Hi(b, g2, d2, l2);
            jh = false;
            var r = b.memoizedState;
            g2.state = r;
            qh(b, d2, g2, e2);
            k = b.memoizedState;
            h2 !== d2 || r !== k || Wf.current || jh ? ("function" === typeof m2 && (Di(b, c2, m2, d2), k = b.memoizedState), (h2 = jh || Fi(b, c2, h2, d2, r, k, l2)) ? (q || "function" !== typeof g2.UNSAFE_componentWillMount && "function" !== typeof g2.componentWillMount || ("function" === typeof g2.componentWillMount && g2.componentWillMount(), "function" === typeof g2.UNSAFE_componentWillMount && g2.UNSAFE_componentWillMount()), "function" === typeof g2.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g2.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d2, b.memoizedState = k), g2.props = d2, g2.state = k, g2.context = l2, d2 = h2) : ("function" === typeof g2.componentDidMount && (b.flags |= 4194308), d2 = false);
          } else {
            g2 = b.stateNode;
            lh(a2, b);
            h2 = b.memoizedProps;
            l2 = b.type === b.elementType ? h2 : Ci(b.type, h2);
            g2.props = l2;
            q = b.pendingProps;
            r = g2.context;
            k = c2.contextType;
            "object" === typeof k && null !== k ? k = eh(k) : (k = Zf(c2) ? Xf : H.current, k = Yf(b, k));
            var y = c2.getDerivedStateFromProps;
            (m2 = "function" === typeof y || "function" === typeof g2.getSnapshotBeforeUpdate) || "function" !== typeof g2.UNSAFE_componentWillReceiveProps && "function" !== typeof g2.componentWillReceiveProps || (h2 !== q || r !== k) && Hi(b, g2, d2, k);
            jh = false;
            r = b.memoizedState;
            g2.state = r;
            qh(b, d2, g2, e2);
            var n2 = b.memoizedState;
            h2 !== q || r !== n2 || Wf.current || jh ? ("function" === typeof y && (Di(b, c2, y, d2), n2 = b.memoizedState), (l2 = jh || Fi(b, c2, l2, d2, r, n2, k) || false) ? (m2 || "function" !== typeof g2.UNSAFE_componentWillUpdate && "function" !== typeof g2.componentWillUpdate || ("function" === typeof g2.componentWillUpdate && g2.componentWillUpdate(d2, n2, k), "function" === typeof g2.UNSAFE_componentWillUpdate && g2.UNSAFE_componentWillUpdate(d2, n2, k)), "function" === typeof g2.componentDidUpdate && (b.flags |= 4), "function" === typeof g2.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g2.componentDidUpdate || h2 === a2.memoizedProps && r === a2.memoizedState || (b.flags |= 4), "function" !== typeof g2.getSnapshotBeforeUpdate || h2 === a2.memoizedProps && r === a2.memoizedState || (b.flags |= 1024), b.memoizedProps = d2, b.memoizedState = n2), g2.props = d2, g2.state = n2, g2.context = k, d2 = l2) : ("function" !== typeof g2.componentDidUpdate || h2 === a2.memoizedProps && r === a2.memoizedState || (b.flags |= 4), "function" !== typeof g2.getSnapshotBeforeUpdate || h2 === a2.memoizedProps && r === a2.memoizedState || (b.flags |= 1024), d2 = false);
          }
          return jj(a2, b, c2, d2, f2, e2);
        }
        function jj(a2, b, c2, d2, e2, f2) {
          gj(a2, b);
          var g2 = 0 !== (b.flags & 128);
          if (!d2 && !g2) return e2 && dg(b, c2, false), Zi(a2, b, f2);
          d2 = b.stateNode;
          Wi.current = b;
          var h2 = g2 && "function" !== typeof c2.getDerivedStateFromError ? null : d2.render();
          b.flags |= 1;
          null !== a2 && g2 ? (b.child = Ug(b, a2.child, null, f2), b.child = Ug(b, null, h2, f2)) : Xi(a2, b, h2, f2);
          b.memoizedState = d2.state;
          e2 && dg(b, c2, true);
          return b.child;
        }
        function kj(a2) {
          var b = a2.stateNode;
          b.pendingContext ? ag(a2, b.pendingContext, b.pendingContext !== b.context) : b.context && ag(a2, b.context, false);
          yh(a2, b.containerInfo);
        }
        function lj(a2, b, c2, d2, e2) {
          Ig();
          Jg(e2);
          b.flags |= 256;
          Xi(a2, b, c2, d2);
          return b.child;
        }
        var mj = { dehydrated: null, treeContext: null, retryLane: 0 };
        function nj(a2) {
          return { baseLanes: a2, cachePool: null, transitions: null };
        }
        function oj(a2, b, c2) {
          var d2 = b.pendingProps, e2 = L.current, f2 = false, g2 = 0 !== (b.flags & 128), h2;
          (h2 = g2) || (h2 = null !== a2 && null === a2.memoizedState ? false : 0 !== (e2 & 2));
          if (h2) f2 = true, b.flags &= -129;
          else if (null === a2 || null !== a2.memoizedState) e2 |= 1;
          G(L, e2 & 1);
          if (null === a2) {
            Eg(b);
            a2 = b.memoizedState;
            if (null !== a2 && (a2 = a2.dehydrated, null !== a2)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a2.data ? b.lanes = 8 : b.lanes = 1073741824, null;
            g2 = d2.children;
            a2 = d2.fallback;
            return f2 ? (d2 = b.mode, f2 = b.child, g2 = { mode: "hidden", children: g2 }, 0 === (d2 & 1) && null !== f2 ? (f2.childLanes = 0, f2.pendingProps = g2) : f2 = pj(g2, d2, 0, null), a2 = Tg(a2, d2, c2, null), f2.return = b, a2.return = b, f2.sibling = a2, b.child = f2, b.child.memoizedState = nj(c2), b.memoizedState = mj, a2) : qj(b, g2);
          }
          e2 = a2.memoizedState;
          if (null !== e2 && (h2 = e2.dehydrated, null !== h2)) return rj(a2, b, g2, d2, h2, e2, c2);
          if (f2) {
            f2 = d2.fallback;
            g2 = b.mode;
            e2 = a2.child;
            h2 = e2.sibling;
            var k = { mode: "hidden", children: d2.children };
            0 === (g2 & 1) && b.child !== e2 ? (d2 = b.child, d2.childLanes = 0, d2.pendingProps = k, b.deletions = null) : (d2 = Pg(e2, k), d2.subtreeFlags = e2.subtreeFlags & 14680064);
            null !== h2 ? f2 = Pg(h2, f2) : (f2 = Tg(f2, g2, c2, null), f2.flags |= 2);
            f2.return = b;
            d2.return = b;
            d2.sibling = f2;
            b.child = d2;
            d2 = f2;
            f2 = b.child;
            g2 = a2.child.memoizedState;
            g2 = null === g2 ? nj(c2) : { baseLanes: g2.baseLanes | c2, cachePool: null, transitions: g2.transitions };
            f2.memoizedState = g2;
            f2.childLanes = a2.childLanes & ~c2;
            b.memoizedState = mj;
            return d2;
          }
          f2 = a2.child;
          a2 = f2.sibling;
          d2 = Pg(f2, { mode: "visible", children: d2.children });
          0 === (b.mode & 1) && (d2.lanes = c2);
          d2.return = b;
          d2.sibling = null;
          null !== a2 && (c2 = b.deletions, null === c2 ? (b.deletions = [a2], b.flags |= 16) : c2.push(a2));
          b.child = d2;
          b.memoizedState = null;
          return d2;
        }
        function qj(a2, b) {
          b = pj({ mode: "visible", children: b }, a2.mode, 0, null);
          b.return = a2;
          return a2.child = b;
        }
        function sj(a2, b, c2, d2) {
          null !== d2 && Jg(d2);
          Ug(b, a2.child, null, c2);
          a2 = qj(b, b.pendingProps.children);
          a2.flags |= 2;
          b.memoizedState = null;
          return a2;
        }
        function rj(a2, b, c2, d2, e2, f2, g2) {
          if (c2) {
            if (b.flags & 256) return b.flags &= -257, d2 = Ki(Error(p2(422))), sj(a2, b, g2, d2);
            if (null !== b.memoizedState) return b.child = a2.child, b.flags |= 128, null;
            f2 = d2.fallback;
            e2 = b.mode;
            d2 = pj({ mode: "visible", children: d2.children }, e2, 0, null);
            f2 = Tg(f2, e2, g2, null);
            f2.flags |= 2;
            d2.return = b;
            f2.return = b;
            d2.sibling = f2;
            b.child = d2;
            0 !== (b.mode & 1) && Ug(b, a2.child, null, g2);
            b.child.memoizedState = nj(g2);
            b.memoizedState = mj;
            return f2;
          }
          if (0 === (b.mode & 1)) return sj(a2, b, g2, null);
          if ("$!" === e2.data) {
            d2 = e2.nextSibling && e2.nextSibling.dataset;
            if (d2) var h2 = d2.dgst;
            d2 = h2;
            f2 = Error(p2(419));
            d2 = Ki(f2, d2, void 0);
            return sj(a2, b, g2, d2);
          }
          h2 = 0 !== (g2 & a2.childLanes);
          if (dh || h2) {
            d2 = Q;
            if (null !== d2) {
              switch (g2 & -g2) {
                case 4:
                  e2 = 2;
                  break;
                case 16:
                  e2 = 8;
                  break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                  e2 = 32;
                  break;
                case 536870912:
                  e2 = 268435456;
                  break;
                default:
                  e2 = 0;
              }
              e2 = 0 !== (e2 & (d2.suspendedLanes | g2)) ? 0 : e2;
              0 !== e2 && e2 !== f2.retryLane && (f2.retryLane = e2, ih(a2, e2), gi(d2, a2, e2, -1));
            }
            tj();
            d2 = Ki(Error(p2(421)));
            return sj(a2, b, g2, d2);
          }
          if ("$?" === e2.data) return b.flags |= 128, b.child = a2.child, b = uj.bind(null, a2), e2._reactRetry = b, null;
          a2 = f2.treeContext;
          yg = Lf(e2.nextSibling);
          xg = b;
          I = true;
          zg = null;
          null !== a2 && (og[pg++] = rg, og[pg++] = sg, og[pg++] = qg, rg = a2.id, sg = a2.overflow, qg = b);
          b = qj(b, d2.children);
          b.flags |= 4096;
          return b;
        }
        function vj(a2, b, c2) {
          a2.lanes |= b;
          var d2 = a2.alternate;
          null !== d2 && (d2.lanes |= b);
          bh(a2.return, b, c2);
        }
        function wj(a2, b, c2, d2, e2) {
          var f2 = a2.memoizedState;
          null === f2 ? a2.memoizedState = { isBackwards: b, rendering: null, renderingStartTime: 0, last: d2, tail: c2, tailMode: e2 } : (f2.isBackwards = b, f2.rendering = null, f2.renderingStartTime = 0, f2.last = d2, f2.tail = c2, f2.tailMode = e2);
        }
        function xj(a2, b, c2) {
          var d2 = b.pendingProps, e2 = d2.revealOrder, f2 = d2.tail;
          Xi(a2, b, d2.children, c2);
          d2 = L.current;
          if (0 !== (d2 & 2)) d2 = d2 & 1 | 2, b.flags |= 128;
          else {
            if (null !== a2 && 0 !== (a2.flags & 128)) a: for (a2 = b.child; null !== a2; ) {
              if (13 === a2.tag) null !== a2.memoizedState && vj(a2, c2, b);
              else if (19 === a2.tag) vj(a2, c2, b);
              else if (null !== a2.child) {
                a2.child.return = a2;
                a2 = a2.child;
                continue;
              }
              if (a2 === b) break a;
              for (; null === a2.sibling; ) {
                if (null === a2.return || a2.return === b) break a;
                a2 = a2.return;
              }
              a2.sibling.return = a2.return;
              a2 = a2.sibling;
            }
            d2 &= 1;
          }
          G(L, d2);
          if (0 === (b.mode & 1)) b.memoizedState = null;
          else switch (e2) {
            case "forwards":
              c2 = b.child;
              for (e2 = null; null !== c2; ) a2 = c2.alternate, null !== a2 && null === Ch(a2) && (e2 = c2), c2 = c2.sibling;
              c2 = e2;
              null === c2 ? (e2 = b.child, b.child = null) : (e2 = c2.sibling, c2.sibling = null);
              wj(b, false, e2, c2, f2);
              break;
            case "backwards":
              c2 = null;
              e2 = b.child;
              for (b.child = null; null !== e2; ) {
                a2 = e2.alternate;
                if (null !== a2 && null === Ch(a2)) {
                  b.child = e2;
                  break;
                }
                a2 = e2.sibling;
                e2.sibling = c2;
                c2 = e2;
                e2 = a2;
              }
              wj(b, true, c2, null, f2);
              break;
            case "together":
              wj(b, false, null, null, void 0);
              break;
            default:
              b.memoizedState = null;
          }
          return b.child;
        }
        function ij(a2, b) {
          0 === (b.mode & 1) && null !== a2 && (a2.alternate = null, b.alternate = null, b.flags |= 2);
        }
        function Zi(a2, b, c2) {
          null !== a2 && (b.dependencies = a2.dependencies);
          rh |= b.lanes;
          if (0 === (c2 & b.childLanes)) return null;
          if (null !== a2 && b.child !== a2.child) throw Error(p2(153));
          if (null !== b.child) {
            a2 = b.child;
            c2 = Pg(a2, a2.pendingProps);
            b.child = c2;
            for (c2.return = b; null !== a2.sibling; ) a2 = a2.sibling, c2 = c2.sibling = Pg(a2, a2.pendingProps), c2.return = b;
            c2.sibling = null;
          }
          return b.child;
        }
        function yj(a2, b, c2) {
          switch (b.tag) {
            case 3:
              kj(b);
              Ig();
              break;
            case 5:
              Ah(b);
              break;
            case 1:
              Zf(b.type) && cg(b);
              break;
            case 4:
              yh(b, b.stateNode.containerInfo);
              break;
            case 10:
              var d2 = b.type._context, e2 = b.memoizedProps.value;
              G(Wg, d2._currentValue);
              d2._currentValue = e2;
              break;
            case 13:
              d2 = b.memoizedState;
              if (null !== d2) {
                if (null !== d2.dehydrated) return G(L, L.current & 1), b.flags |= 128, null;
                if (0 !== (c2 & b.child.childLanes)) return oj(a2, b, c2);
                G(L, L.current & 1);
                a2 = Zi(a2, b, c2);
                return null !== a2 ? a2.sibling : null;
              }
              G(L, L.current & 1);
              break;
            case 19:
              d2 = 0 !== (c2 & b.childLanes);
              if (0 !== (a2.flags & 128)) {
                if (d2) return xj(a2, b, c2);
                b.flags |= 128;
              }
              e2 = b.memoizedState;
              null !== e2 && (e2.rendering = null, e2.tail = null, e2.lastEffect = null);
              G(L, L.current);
              if (d2) break;
              else return null;
            case 22:
            case 23:
              return b.lanes = 0, dj(a2, b, c2);
          }
          return Zi(a2, b, c2);
        }
        var zj, Aj, Bj, Cj;
        zj = function(a2, b) {
          for (var c2 = b.child; null !== c2; ) {
            if (5 === c2.tag || 6 === c2.tag) a2.appendChild(c2.stateNode);
            else if (4 !== c2.tag && null !== c2.child) {
              c2.child.return = c2;
              c2 = c2.child;
              continue;
            }
            if (c2 === b) break;
            for (; null === c2.sibling; ) {
              if (null === c2.return || c2.return === b) return;
              c2 = c2.return;
            }
            c2.sibling.return = c2.return;
            c2 = c2.sibling;
          }
        };
        Aj = function() {
        };
        Bj = function(a2, b, c2, d2) {
          var e2 = a2.memoizedProps;
          if (e2 !== d2) {
            a2 = b.stateNode;
            xh(uh.current);
            var f2 = null;
            switch (c2) {
              case "input":
                e2 = Ya(a2, e2);
                d2 = Ya(a2, d2);
                f2 = [];
                break;
              case "select":
                e2 = A({}, e2, { value: void 0 });
                d2 = A({}, d2, { value: void 0 });
                f2 = [];
                break;
              case "textarea":
                e2 = gb(a2, e2);
                d2 = gb(a2, d2);
                f2 = [];
                break;
              default:
                "function" !== typeof e2.onClick && "function" === typeof d2.onClick && (a2.onclick = Bf);
            }
            ub(c2, d2);
            var g2;
            c2 = null;
            for (l2 in e2) if (!d2.hasOwnProperty(l2) && e2.hasOwnProperty(l2) && null != e2[l2]) if ("style" === l2) {
              var h2 = e2[l2];
              for (g2 in h2) h2.hasOwnProperty(g2) && (c2 || (c2 = {}), c2[g2] = "");
            } else "dangerouslySetInnerHTML" !== l2 && "children" !== l2 && "suppressContentEditableWarning" !== l2 && "suppressHydrationWarning" !== l2 && "autoFocus" !== l2 && (ea.hasOwnProperty(l2) ? f2 || (f2 = []) : (f2 = f2 || []).push(l2, null));
            for (l2 in d2) {
              var k = d2[l2];
              h2 = null != e2 ? e2[l2] : void 0;
              if (d2.hasOwnProperty(l2) && k !== h2 && (null != k || null != h2)) if ("style" === l2) if (h2) {
                for (g2 in h2) !h2.hasOwnProperty(g2) || k && k.hasOwnProperty(g2) || (c2 || (c2 = {}), c2[g2] = "");
                for (g2 in k) k.hasOwnProperty(g2) && h2[g2] !== k[g2] && (c2 || (c2 = {}), c2[g2] = k[g2]);
              } else c2 || (f2 || (f2 = []), f2.push(
                l2,
                c2
              )), c2 = k;
              else "dangerouslySetInnerHTML" === l2 ? (k = k ? k.__html : void 0, h2 = h2 ? h2.__html : void 0, null != k && h2 !== k && (f2 = f2 || []).push(l2, k)) : "children" === l2 ? "string" !== typeof k && "number" !== typeof k || (f2 = f2 || []).push(l2, "" + k) : "suppressContentEditableWarning" !== l2 && "suppressHydrationWarning" !== l2 && (ea.hasOwnProperty(l2) ? (null != k && "onScroll" === l2 && D("scroll", a2), f2 || h2 === k || (f2 = [])) : (f2 = f2 || []).push(l2, k));
            }
            c2 && (f2 = f2 || []).push("style", c2);
            var l2 = f2;
            if (b.updateQueue = l2) b.flags |= 4;
          }
        };
        Cj = function(a2, b, c2, d2) {
          c2 !== d2 && (b.flags |= 4);
        };
        function Dj(a2, b) {
          if (!I) switch (a2.tailMode) {
            case "hidden":
              b = a2.tail;
              for (var c2 = null; null !== b; ) null !== b.alternate && (c2 = b), b = b.sibling;
              null === c2 ? a2.tail = null : c2.sibling = null;
              break;
            case "collapsed":
              c2 = a2.tail;
              for (var d2 = null; null !== c2; ) null !== c2.alternate && (d2 = c2), c2 = c2.sibling;
              null === d2 ? b || null === a2.tail ? a2.tail = null : a2.tail.sibling = null : d2.sibling = null;
          }
        }
        function S(a2) {
          var b = null !== a2.alternate && a2.alternate.child === a2.child, c2 = 0, d2 = 0;
          if (b) for (var e2 = a2.child; null !== e2; ) c2 |= e2.lanes | e2.childLanes, d2 |= e2.subtreeFlags & 14680064, d2 |= e2.flags & 14680064, e2.return = a2, e2 = e2.sibling;
          else for (e2 = a2.child; null !== e2; ) c2 |= e2.lanes | e2.childLanes, d2 |= e2.subtreeFlags, d2 |= e2.flags, e2.return = a2, e2 = e2.sibling;
          a2.subtreeFlags |= d2;
          a2.childLanes = c2;
          return b;
        }
        function Ej(a2, b, c2) {
          var d2 = b.pendingProps;
          wg(b);
          switch (b.tag) {
            case 2:
            case 16:
            case 15:
            case 0:
            case 11:
            case 7:
            case 8:
            case 12:
            case 9:
            case 14:
              return S(b), null;
            case 1:
              return Zf(b.type) && $f(), S(b), null;
            case 3:
              d2 = b.stateNode;
              zh();
              E(Wf);
              E(H);
              Eh();
              d2.pendingContext && (d2.context = d2.pendingContext, d2.pendingContext = null);
              if (null === a2 || null === a2.child) Gg(b) ? b.flags |= 4 : null === a2 || a2.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== zg && (Fj(zg), zg = null));
              Aj(a2, b);
              S(b);
              return null;
            case 5:
              Bh(b);
              var e2 = xh(wh.current);
              c2 = b.type;
              if (null !== a2 && null != b.stateNode) Bj(a2, b, c2, d2, e2), a2.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
              else {
                if (!d2) {
                  if (null === b.stateNode) throw Error(p2(166));
                  S(b);
                  return null;
                }
                a2 = xh(uh.current);
                if (Gg(b)) {
                  d2 = b.stateNode;
                  c2 = b.type;
                  var f2 = b.memoizedProps;
                  d2[Of] = b;
                  d2[Pf] = f2;
                  a2 = 0 !== (b.mode & 1);
                  switch (c2) {
                    case "dialog":
                      D("cancel", d2);
                      D("close", d2);
                      break;
                    case "iframe":
                    case "object":
                    case "embed":
                      D("load", d2);
                      break;
                    case "video":
                    case "audio":
                      for (e2 = 0; e2 < lf.length; e2++) D(lf[e2], d2);
                      break;
                    case "source":
                      D("error", d2);
                      break;
                    case "img":
                    case "image":
                    case "link":
                      D(
                        "error",
                        d2
                      );
                      D("load", d2);
                      break;
                    case "details":
                      D("toggle", d2);
                      break;
                    case "input":
                      Za(d2, f2);
                      D("invalid", d2);
                      break;
                    case "select":
                      d2._wrapperState = { wasMultiple: !!f2.multiple };
                      D("invalid", d2);
                      break;
                    case "textarea":
                      hb(d2, f2), D("invalid", d2);
                  }
                  ub(c2, f2);
                  e2 = null;
                  for (var g2 in f2) if (f2.hasOwnProperty(g2)) {
                    var h2 = f2[g2];
                    "children" === g2 ? "string" === typeof h2 ? d2.textContent !== h2 && (true !== f2.suppressHydrationWarning && Af(d2.textContent, h2, a2), e2 = ["children", h2]) : "number" === typeof h2 && d2.textContent !== "" + h2 && (true !== f2.suppressHydrationWarning && Af(
                      d2.textContent,
                      h2,
                      a2
                    ), e2 = ["children", "" + h2]) : ea.hasOwnProperty(g2) && null != h2 && "onScroll" === g2 && D("scroll", d2);
                  }
                  switch (c2) {
                    case "input":
                      Va(d2);
                      db(d2, f2, true);
                      break;
                    case "textarea":
                      Va(d2);
                      jb(d2);
                      break;
                    case "select":
                    case "option":
                      break;
                    default:
                      "function" === typeof f2.onClick && (d2.onclick = Bf);
                  }
                  d2 = e2;
                  b.updateQueue = d2;
                  null !== d2 && (b.flags |= 4);
                } else {
                  g2 = 9 === e2.nodeType ? e2 : e2.ownerDocument;
                  "http://www.w3.org/1999/xhtml" === a2 && (a2 = kb(c2));
                  "http://www.w3.org/1999/xhtml" === a2 ? "script" === c2 ? (a2 = g2.createElement("div"), a2.innerHTML = "<script><\/script>", a2 = a2.removeChild(a2.firstChild)) : "string" === typeof d2.is ? a2 = g2.createElement(c2, { is: d2.is }) : (a2 = g2.createElement(c2), "select" === c2 && (g2 = a2, d2.multiple ? g2.multiple = true : d2.size && (g2.size = d2.size))) : a2 = g2.createElementNS(a2, c2);
                  a2[Of] = b;
                  a2[Pf] = d2;
                  zj(a2, b, false, false);
                  b.stateNode = a2;
                  a: {
                    g2 = vb(c2, d2);
                    switch (c2) {
                      case "dialog":
                        D("cancel", a2);
                        D("close", a2);
                        e2 = d2;
                        break;
                      case "iframe":
                      case "object":
                      case "embed":
                        D("load", a2);
                        e2 = d2;
                        break;
                      case "video":
                      case "audio":
                        for (e2 = 0; e2 < lf.length; e2++) D(lf[e2], a2);
                        e2 = d2;
                        break;
                      case "source":
                        D("error", a2);
                        e2 = d2;
                        break;
                      case "img":
                      case "image":
                      case "link":
                        D(
                          "error",
                          a2
                        );
                        D("load", a2);
                        e2 = d2;
                        break;
                      case "details":
                        D("toggle", a2);
                        e2 = d2;
                        break;
                      case "input":
                        Za(a2, d2);
                        e2 = Ya(a2, d2);
                        D("invalid", a2);
                        break;
                      case "option":
                        e2 = d2;
                        break;
                      case "select":
                        a2._wrapperState = { wasMultiple: !!d2.multiple };
                        e2 = A({}, d2, { value: void 0 });
                        D("invalid", a2);
                        break;
                      case "textarea":
                        hb(a2, d2);
                        e2 = gb(a2, d2);
                        D("invalid", a2);
                        break;
                      default:
                        e2 = d2;
                    }
                    ub(c2, e2);
                    h2 = e2;
                    for (f2 in h2) if (h2.hasOwnProperty(f2)) {
                      var k = h2[f2];
                      "style" === f2 ? sb(a2, k) : "dangerouslySetInnerHTML" === f2 ? (k = k ? k.__html : void 0, null != k && nb(a2, k)) : "children" === f2 ? "string" === typeof k ? ("textarea" !== c2 || "" !== k) && ob(a2, k) : "number" === typeof k && ob(a2, "" + k) : "suppressContentEditableWarning" !== f2 && "suppressHydrationWarning" !== f2 && "autoFocus" !== f2 && (ea.hasOwnProperty(f2) ? null != k && "onScroll" === f2 && D("scroll", a2) : null != k && ta(a2, f2, k, g2));
                    }
                    switch (c2) {
                      case "input":
                        Va(a2);
                        db(a2, d2, false);
                        break;
                      case "textarea":
                        Va(a2);
                        jb(a2);
                        break;
                      case "option":
                        null != d2.value && a2.setAttribute("value", "" + Sa(d2.value));
                        break;
                      case "select":
                        a2.multiple = !!d2.multiple;
                        f2 = d2.value;
                        null != f2 ? fb(a2, !!d2.multiple, f2, false) : null != d2.defaultValue && fb(
                          a2,
                          !!d2.multiple,
                          d2.defaultValue,
                          true
                        );
                        break;
                      default:
                        "function" === typeof e2.onClick && (a2.onclick = Bf);
                    }
                    switch (c2) {
                      case "button":
                      case "input":
                      case "select":
                      case "textarea":
                        d2 = !!d2.autoFocus;
                        break a;
                      case "img":
                        d2 = true;
                        break a;
                      default:
                        d2 = false;
                    }
                  }
                  d2 && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
              }
              S(b);
              return null;
            case 6:
              if (a2 && null != b.stateNode) Cj(a2, b, a2.memoizedProps, d2);
              else {
                if ("string" !== typeof d2 && null === b.stateNode) throw Error(p2(166));
                c2 = xh(wh.current);
                xh(uh.current);
                if (Gg(b)) {
                  d2 = b.stateNode;
                  c2 = b.memoizedProps;
                  d2[Of] = b;
                  if (f2 = d2.nodeValue !== c2) {
                    if (a2 = xg, null !== a2) switch (a2.tag) {
                      case 3:
                        Af(d2.nodeValue, c2, 0 !== (a2.mode & 1));
                        break;
                      case 5:
                        true !== a2.memoizedProps.suppressHydrationWarning && Af(d2.nodeValue, c2, 0 !== (a2.mode & 1));
                    }
                  }
                  f2 && (b.flags |= 4);
                } else d2 = (9 === c2.nodeType ? c2 : c2.ownerDocument).createTextNode(d2), d2[Of] = b, b.stateNode = d2;
              }
              S(b);
              return null;
            case 13:
              E(L);
              d2 = b.memoizedState;
              if (null === a2 || null !== a2.memoizedState && null !== a2.memoizedState.dehydrated) {
                if (I && null !== yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) Hg(), Ig(), b.flags |= 98560, f2 = false;
                else if (f2 = Gg(b), null !== d2 && null !== d2.dehydrated) {
                  if (null === a2) {
                    if (!f2) throw Error(p2(318));
                    f2 = b.memoizedState;
                    f2 = null !== f2 ? f2.dehydrated : null;
                    if (!f2) throw Error(p2(317));
                    f2[Of] = b;
                  } else Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                  S(b);
                  f2 = false;
                } else null !== zg && (Fj(zg), zg = null), f2 = true;
                if (!f2) return b.flags & 65536 ? b : null;
              }
              if (0 !== (b.flags & 128)) return b.lanes = c2, b;
              d2 = null !== d2;
              d2 !== (null !== a2 && null !== a2.memoizedState) && d2 && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a2 || 0 !== (L.current & 1) ? 0 === T && (T = 3) : tj()));
              null !== b.updateQueue && (b.flags |= 4);
              S(b);
              return null;
            case 4:
              return zh(), Aj(a2, b), null === a2 && sf(b.stateNode.containerInfo), S(b), null;
            case 10:
              return ah(b.type._context), S(b), null;
            case 17:
              return Zf(b.type) && $f(), S(b), null;
            case 19:
              E(L);
              f2 = b.memoizedState;
              if (null === f2) return S(b), null;
              d2 = 0 !== (b.flags & 128);
              g2 = f2.rendering;
              if (null === g2) if (d2) Dj(f2, false);
              else {
                if (0 !== T || null !== a2 && 0 !== (a2.flags & 128)) for (a2 = b.child; null !== a2; ) {
                  g2 = Ch(a2);
                  if (null !== g2) {
                    b.flags |= 128;
                    Dj(f2, false);
                    d2 = g2.updateQueue;
                    null !== d2 && (b.updateQueue = d2, b.flags |= 4);
                    b.subtreeFlags = 0;
                    d2 = c2;
                    for (c2 = b.child; null !== c2; ) f2 = c2, a2 = d2, f2.flags &= 14680066, g2 = f2.alternate, null === g2 ? (f2.childLanes = 0, f2.lanes = a2, f2.child = null, f2.subtreeFlags = 0, f2.memoizedProps = null, f2.memoizedState = null, f2.updateQueue = null, f2.dependencies = null, f2.stateNode = null) : (f2.childLanes = g2.childLanes, f2.lanes = g2.lanes, f2.child = g2.child, f2.subtreeFlags = 0, f2.deletions = null, f2.memoizedProps = g2.memoizedProps, f2.memoizedState = g2.memoizedState, f2.updateQueue = g2.updateQueue, f2.type = g2.type, a2 = g2.dependencies, f2.dependencies = null === a2 ? null : { lanes: a2.lanes, firstContext: a2.firstContext }), c2 = c2.sibling;
                    G(L, L.current & 1 | 2);
                    return b.child;
                  }
                  a2 = a2.sibling;
                }
                null !== f2.tail && B() > Gj && (b.flags |= 128, d2 = true, Dj(f2, false), b.lanes = 4194304);
              }
              else {
                if (!d2) if (a2 = Ch(g2), null !== a2) {
                  if (b.flags |= 128, d2 = true, c2 = a2.updateQueue, null !== c2 && (b.updateQueue = c2, b.flags |= 4), Dj(f2, true), null === f2.tail && "hidden" === f2.tailMode && !g2.alternate && !I) return S(b), null;
                } else 2 * B() - f2.renderingStartTime > Gj && 1073741824 !== c2 && (b.flags |= 128, d2 = true, Dj(f2, false), b.lanes = 4194304);
                f2.isBackwards ? (g2.sibling = b.child, b.child = g2) : (c2 = f2.last, null !== c2 ? c2.sibling = g2 : b.child = g2, f2.last = g2);
              }
              if (null !== f2.tail) return b = f2.tail, f2.rendering = b, f2.tail = b.sibling, f2.renderingStartTime = B(), b.sibling = null, c2 = L.current, G(L, d2 ? c2 & 1 | 2 : c2 & 1), b;
              S(b);
              return null;
            case 22:
            case 23:
              return Hj(), d2 = null !== b.memoizedState, null !== a2 && null !== a2.memoizedState !== d2 && (b.flags |= 8192), d2 && 0 !== (b.mode & 1) ? 0 !== (fj & 1073741824) && (S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : S(b), null;
            case 24:
              return null;
            case 25:
              return null;
          }
          throw Error(p2(156, b.tag));
        }
        function Ij(a2, b) {
          wg(b);
          switch (b.tag) {
            case 1:
              return Zf(b.type) && $f(), a2 = b.flags, a2 & 65536 ? (b.flags = a2 & -65537 | 128, b) : null;
            case 3:
              return zh(), E(Wf), E(H), Eh(), a2 = b.flags, 0 !== (a2 & 65536) && 0 === (a2 & 128) ? (b.flags = a2 & -65537 | 128, b) : null;
            case 5:
              return Bh(b), null;
            case 13:
              E(L);
              a2 = b.memoizedState;
              if (null !== a2 && null !== a2.dehydrated) {
                if (null === b.alternate) throw Error(p2(340));
                Ig();
              }
              a2 = b.flags;
              return a2 & 65536 ? (b.flags = a2 & -65537 | 128, b) : null;
            case 19:
              return E(L), null;
            case 4:
              return zh(), null;
            case 10:
              return ah(b.type._context), null;
            case 22:
            case 23:
              return Hj(), null;
            case 24:
              return null;
            default:
              return null;
          }
        }
        var Jj = false, U = false, Kj = "function" === typeof WeakSet ? WeakSet : Set, V = null;
        function Lj(a2, b) {
          var c2 = a2.ref;
          if (null !== c2) if ("function" === typeof c2) try {
            c2(null);
          } catch (d2) {
            W(a2, b, d2);
          }
          else c2.current = null;
        }
        function Mj(a2, b, c2) {
          try {
            c2();
          } catch (d2) {
            W(a2, b, d2);
          }
        }
        var Nj = false;
        function Oj(a2, b) {
          Cf = dd;
          a2 = Me();
          if (Ne(a2)) {
            if ("selectionStart" in a2) var c2 = { start: a2.selectionStart, end: a2.selectionEnd };
            else a: {
              c2 = (c2 = a2.ownerDocument) && c2.defaultView || window;
              var d2 = c2.getSelection && c2.getSelection();
              if (d2 && 0 !== d2.rangeCount) {
                c2 = d2.anchorNode;
                var e2 = d2.anchorOffset, f2 = d2.focusNode;
                d2 = d2.focusOffset;
                try {
                  c2.nodeType, f2.nodeType;
                } catch (F) {
                  c2 = null;
                  break a;
                }
                var g2 = 0, h2 = -1, k = -1, l2 = 0, m2 = 0, q = a2, r = null;
                b: for (; ; ) {
                  for (var y; ; ) {
                    q !== c2 || 0 !== e2 && 3 !== q.nodeType || (h2 = g2 + e2);
                    q !== f2 || 0 !== d2 && 3 !== q.nodeType || (k = g2 + d2);
                    3 === q.nodeType && (g2 += q.nodeValue.length);
                    if (null === (y = q.firstChild)) break;
                    r = q;
                    q = y;
                  }
                  for (; ; ) {
                    if (q === a2) break b;
                    r === c2 && ++l2 === e2 && (h2 = g2);
                    r === f2 && ++m2 === d2 && (k = g2);
                    if (null !== (y = q.nextSibling)) break;
                    q = r;
                    r = q.parentNode;
                  }
                  q = y;
                }
                c2 = -1 === h2 || -1 === k ? null : { start: h2, end: k };
              } else c2 = null;
            }
            c2 = c2 || { start: 0, end: 0 };
          } else c2 = null;
          Df = { focusedElem: a2, selectionRange: c2 };
          dd = false;
          for (V = b; null !== V; ) if (b = V, a2 = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a2) a2.return = b, V = a2;
          else for (; null !== V; ) {
            b = V;
            try {
              var n2 = b.alternate;
              if (0 !== (b.flags & 1024)) switch (b.tag) {
                case 0:
                case 11:
                case 15:
                  break;
                case 1:
                  if (null !== n2) {
                    var t2 = n2.memoizedProps, J = n2.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t2 : Ci(b.type, t2), J);
                    x.__reactInternalSnapshotBeforeUpdate = w;
                  }
                  break;
                case 3:
                  var u2 = b.stateNode.containerInfo;
                  1 === u2.nodeType ? u2.textContent = "" : 9 === u2.nodeType && u2.documentElement && u2.removeChild(u2.documentElement);
                  break;
                case 5:
                case 6:
                case 4:
                case 17:
                  break;
                default:
                  throw Error(p2(163));
              }
            } catch (F) {
              W(b, b.return, F);
            }
            a2 = b.sibling;
            if (null !== a2) {
              a2.return = b.return;
              V = a2;
              break;
            }
            V = b.return;
          }
          n2 = Nj;
          Nj = false;
          return n2;
        }
        function Pj(a2, b, c2) {
          var d2 = b.updateQueue;
          d2 = null !== d2 ? d2.lastEffect : null;
          if (null !== d2) {
            var e2 = d2 = d2.next;
            do {
              if ((e2.tag & a2) === a2) {
                var f2 = e2.destroy;
                e2.destroy = void 0;
                void 0 !== f2 && Mj(b, c2, f2);
              }
              e2 = e2.next;
            } while (e2 !== d2);
          }
        }
        function Qj(a2, b) {
          b = b.updateQueue;
          b = null !== b ? b.lastEffect : null;
          if (null !== b) {
            var c2 = b = b.next;
            do {
              if ((c2.tag & a2) === a2) {
                var d2 = c2.create;
                c2.destroy = d2();
              }
              c2 = c2.next;
            } while (c2 !== b);
          }
        }
        function Rj(a2) {
          var b = a2.ref;
          if (null !== b) {
            var c2 = a2.stateNode;
            switch (a2.tag) {
              case 5:
                a2 = c2;
                break;
              default:
                a2 = c2;
            }
            "function" === typeof b ? b(a2) : b.current = a2;
          }
        }
        function Sj(a2) {
          var b = a2.alternate;
          null !== b && (a2.alternate = null, Sj(b));
          a2.child = null;
          a2.deletions = null;
          a2.sibling = null;
          5 === a2.tag && (b = a2.stateNode, null !== b && (delete b[Of], delete b[Pf], delete b[of], delete b[Qf], delete b[Rf]));
          a2.stateNode = null;
          a2.return = null;
          a2.dependencies = null;
          a2.memoizedProps = null;
          a2.memoizedState = null;
          a2.pendingProps = null;
          a2.stateNode = null;
          a2.updateQueue = null;
        }
        function Tj(a2) {
          return 5 === a2.tag || 3 === a2.tag || 4 === a2.tag;
        }
        function Uj(a2) {
          a: for (; ; ) {
            for (; null === a2.sibling; ) {
              if (null === a2.return || Tj(a2.return)) return null;
              a2 = a2.return;
            }
            a2.sibling.return = a2.return;
            for (a2 = a2.sibling; 5 !== a2.tag && 6 !== a2.tag && 18 !== a2.tag; ) {
              if (a2.flags & 2) continue a;
              if (null === a2.child || 4 === a2.tag) continue a;
              else a2.child.return = a2, a2 = a2.child;
            }
            if (!(a2.flags & 2)) return a2.stateNode;
          }
        }
        function Vj(a2, b, c2) {
          var d2 = a2.tag;
          if (5 === d2 || 6 === d2) a2 = a2.stateNode, b ? 8 === c2.nodeType ? c2.parentNode.insertBefore(a2, b) : c2.insertBefore(a2, b) : (8 === c2.nodeType ? (b = c2.parentNode, b.insertBefore(a2, c2)) : (b = c2, b.appendChild(a2)), c2 = c2._reactRootContainer, null !== c2 && void 0 !== c2 || null !== b.onclick || (b.onclick = Bf));
          else if (4 !== d2 && (a2 = a2.child, null !== a2)) for (Vj(a2, b, c2), a2 = a2.sibling; null !== a2; ) Vj(a2, b, c2), a2 = a2.sibling;
        }
        function Wj(a2, b, c2) {
          var d2 = a2.tag;
          if (5 === d2 || 6 === d2) a2 = a2.stateNode, b ? c2.insertBefore(a2, b) : c2.appendChild(a2);
          else if (4 !== d2 && (a2 = a2.child, null !== a2)) for (Wj(a2, b, c2), a2 = a2.sibling; null !== a2; ) Wj(a2, b, c2), a2 = a2.sibling;
        }
        var X = null, Xj = false;
        function Yj(a2, b, c2) {
          for (c2 = c2.child; null !== c2; ) Zj(a2, b, c2), c2 = c2.sibling;
        }
        function Zj(a2, b, c2) {
          if (lc && "function" === typeof lc.onCommitFiberUnmount) try {
            lc.onCommitFiberUnmount(kc, c2);
          } catch (h2) {
          }
          switch (c2.tag) {
            case 5:
              U || Lj(c2, b);
            case 6:
              var d2 = X, e2 = Xj;
              X = null;
              Yj(a2, b, c2);
              X = d2;
              Xj = e2;
              null !== X && (Xj ? (a2 = X, c2 = c2.stateNode, 8 === a2.nodeType ? a2.parentNode.removeChild(c2) : a2.removeChild(c2)) : X.removeChild(c2.stateNode));
              break;
            case 18:
              null !== X && (Xj ? (a2 = X, c2 = c2.stateNode, 8 === a2.nodeType ? Kf(a2.parentNode, c2) : 1 === a2.nodeType && Kf(a2, c2), bd(a2)) : Kf(X, c2.stateNode));
              break;
            case 4:
              d2 = X;
              e2 = Xj;
              X = c2.stateNode.containerInfo;
              Xj = true;
              Yj(a2, b, c2);
              X = d2;
              Xj = e2;
              break;
            case 0:
            case 11:
            case 14:
            case 15:
              if (!U && (d2 = c2.updateQueue, null !== d2 && (d2 = d2.lastEffect, null !== d2))) {
                e2 = d2 = d2.next;
                do {
                  var f2 = e2, g2 = f2.destroy;
                  f2 = f2.tag;
                  void 0 !== g2 && (0 !== (f2 & 2) ? Mj(c2, b, g2) : 0 !== (f2 & 4) && Mj(c2, b, g2));
                  e2 = e2.next;
                } while (e2 !== d2);
              }
              Yj(a2, b, c2);
              break;
            case 1:
              if (!U && (Lj(c2, b), d2 = c2.stateNode, "function" === typeof d2.componentWillUnmount)) try {
                d2.props = c2.memoizedProps, d2.state = c2.memoizedState, d2.componentWillUnmount();
              } catch (h2) {
                W(c2, b, h2);
              }
              Yj(a2, b, c2);
              break;
            case 21:
              Yj(a2, b, c2);
              break;
            case 22:
              c2.mode & 1 ? (U = (d2 = U) || null !== c2.memoizedState, Yj(a2, b, c2), U = d2) : Yj(a2, b, c2);
              break;
            default:
              Yj(a2, b, c2);
          }
        }
        function ak(a2) {
          var b = a2.updateQueue;
          if (null !== b) {
            a2.updateQueue = null;
            var c2 = a2.stateNode;
            null === c2 && (c2 = a2.stateNode = new Kj());
            b.forEach(function(b2) {
              var d2 = bk.bind(null, a2, b2);
              c2.has(b2) || (c2.add(b2), b2.then(d2, d2));
            });
          }
        }
        function ck(a2, b) {
          var c2 = b.deletions;
          if (null !== c2) for (var d2 = 0; d2 < c2.length; d2++) {
            var e2 = c2[d2];
            try {
              var f2 = a2, g2 = b, h2 = g2;
              a: for (; null !== h2; ) {
                switch (h2.tag) {
                  case 5:
                    X = h2.stateNode;
                    Xj = false;
                    break a;
                  case 3:
                    X = h2.stateNode.containerInfo;
                    Xj = true;
                    break a;
                  case 4:
                    X = h2.stateNode.containerInfo;
                    Xj = true;
                    break a;
                }
                h2 = h2.return;
              }
              if (null === X) throw Error(p2(160));
              Zj(f2, g2, e2);
              X = null;
              Xj = false;
              var k = e2.alternate;
              null !== k && (k.return = null);
              e2.return = null;
            } catch (l2) {
              W(e2, b, l2);
            }
          }
          if (b.subtreeFlags & 12854) for (b = b.child; null !== b; ) dk(b, a2), b = b.sibling;
        }
        function dk(a2, b) {
          var c2 = a2.alternate, d2 = a2.flags;
          switch (a2.tag) {
            case 0:
            case 11:
            case 14:
            case 15:
              ck(b, a2);
              ek(a2);
              if (d2 & 4) {
                try {
                  Pj(3, a2, a2.return), Qj(3, a2);
                } catch (t2) {
                  W(a2, a2.return, t2);
                }
                try {
                  Pj(5, a2, a2.return);
                } catch (t2) {
                  W(a2, a2.return, t2);
                }
              }
              break;
            case 1:
              ck(b, a2);
              ek(a2);
              d2 & 512 && null !== c2 && Lj(c2, c2.return);
              break;
            case 5:
              ck(b, a2);
              ek(a2);
              d2 & 512 && null !== c2 && Lj(c2, c2.return);
              if (a2.flags & 32) {
                var e2 = a2.stateNode;
                try {
                  ob(e2, "");
                } catch (t2) {
                  W(a2, a2.return, t2);
                }
              }
              if (d2 & 4 && (e2 = a2.stateNode, null != e2)) {
                var f2 = a2.memoizedProps, g2 = null !== c2 ? c2.memoizedProps : f2, h2 = a2.type, k = a2.updateQueue;
                a2.updateQueue = null;
                if (null !== k) try {
                  "input" === h2 && "radio" === f2.type && null != f2.name && ab(e2, f2);
                  vb(h2, g2);
                  var l2 = vb(h2, f2);
                  for (g2 = 0; g2 < k.length; g2 += 2) {
                    var m2 = k[g2], q = k[g2 + 1];
                    "style" === m2 ? sb(e2, q) : "dangerouslySetInnerHTML" === m2 ? nb(e2, q) : "children" === m2 ? ob(e2, q) : ta(e2, m2, q, l2);
                  }
                  switch (h2) {
                    case "input":
                      bb(e2, f2);
                      break;
                    case "textarea":
                      ib(e2, f2);
                      break;
                    case "select":
                      var r = e2._wrapperState.wasMultiple;
                      e2._wrapperState.wasMultiple = !!f2.multiple;
                      var y = f2.value;
                      null != y ? fb(e2, !!f2.multiple, y, false) : r !== !!f2.multiple && (null != f2.defaultValue ? fb(
                        e2,
                        !!f2.multiple,
                        f2.defaultValue,
                        true
                      ) : fb(e2, !!f2.multiple, f2.multiple ? [] : "", false));
                  }
                  e2[Pf] = f2;
                } catch (t2) {
                  W(a2, a2.return, t2);
                }
              }
              break;
            case 6:
              ck(b, a2);
              ek(a2);
              if (d2 & 4) {
                if (null === a2.stateNode) throw Error(p2(162));
                e2 = a2.stateNode;
                f2 = a2.memoizedProps;
                try {
                  e2.nodeValue = f2;
                } catch (t2) {
                  W(a2, a2.return, t2);
                }
              }
              break;
            case 3:
              ck(b, a2);
              ek(a2);
              if (d2 & 4 && null !== c2 && c2.memoizedState.isDehydrated) try {
                bd(b.containerInfo);
              } catch (t2) {
                W(a2, a2.return, t2);
              }
              break;
            case 4:
              ck(b, a2);
              ek(a2);
              break;
            case 13:
              ck(b, a2);
              ek(a2);
              e2 = a2.child;
              e2.flags & 8192 && (f2 = null !== e2.memoizedState, e2.stateNode.isHidden = f2, !f2 || null !== e2.alternate && null !== e2.alternate.memoizedState || (fk = B()));
              d2 & 4 && ak(a2);
              break;
            case 22:
              m2 = null !== c2 && null !== c2.memoizedState;
              a2.mode & 1 ? (U = (l2 = U) || m2, ck(b, a2), U = l2) : ck(b, a2);
              ek(a2);
              if (d2 & 8192) {
                l2 = null !== a2.memoizedState;
                if ((a2.stateNode.isHidden = l2) && !m2 && 0 !== (a2.mode & 1)) for (V = a2, m2 = a2.child; null !== m2; ) {
                  for (q = V = m2; null !== V; ) {
                    r = V;
                    y = r.child;
                    switch (r.tag) {
                      case 0:
                      case 11:
                      case 14:
                      case 15:
                        Pj(4, r, r.return);
                        break;
                      case 1:
                        Lj(r, r.return);
                        var n2 = r.stateNode;
                        if ("function" === typeof n2.componentWillUnmount) {
                          d2 = r;
                          c2 = r.return;
                          try {
                            b = d2, n2.props = b.memoizedProps, n2.state = b.memoizedState, n2.componentWillUnmount();
                          } catch (t2) {
                            W(d2, c2, t2);
                          }
                        }
                        break;
                      case 5:
                        Lj(r, r.return);
                        break;
                      case 22:
                        if (null !== r.memoizedState) {
                          gk(q);
                          continue;
                        }
                    }
                    null !== y ? (y.return = r, V = y) : gk(q);
                  }
                  m2 = m2.sibling;
                }
                a: for (m2 = null, q = a2; ; ) {
                  if (5 === q.tag) {
                    if (null === m2) {
                      m2 = q;
                      try {
                        e2 = q.stateNode, l2 ? (f2 = e2.style, "function" === typeof f2.setProperty ? f2.setProperty("display", "none", "important") : f2.display = "none") : (h2 = q.stateNode, k = q.memoizedProps.style, g2 = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h2.style.display = rb("display", g2));
                      } catch (t2) {
                        W(a2, a2.return, t2);
                      }
                    }
                  } else if (6 === q.tag) {
                    if (null === m2) try {
                      q.stateNode.nodeValue = l2 ? "" : q.memoizedProps;
                    } catch (t2) {
                      W(a2, a2.return, t2);
                    }
                  } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a2) && null !== q.child) {
                    q.child.return = q;
                    q = q.child;
                    continue;
                  }
                  if (q === a2) break a;
                  for (; null === q.sibling; ) {
                    if (null === q.return || q.return === a2) break a;
                    m2 === q && (m2 = null);
                    q = q.return;
                  }
                  m2 === q && (m2 = null);
                  q.sibling.return = q.return;
                  q = q.sibling;
                }
              }
              break;
            case 19:
              ck(b, a2);
              ek(a2);
              d2 & 4 && ak(a2);
              break;
            case 21:
              break;
            default:
              ck(
                b,
                a2
              ), ek(a2);
          }
        }
        function ek(a2) {
          var b = a2.flags;
          if (b & 2) {
            try {
              a: {
                for (var c2 = a2.return; null !== c2; ) {
                  if (Tj(c2)) {
                    var d2 = c2;
                    break a;
                  }
                  c2 = c2.return;
                }
                throw Error(p2(160));
              }
              switch (d2.tag) {
                case 5:
                  var e2 = d2.stateNode;
                  d2.flags & 32 && (ob(e2, ""), d2.flags &= -33);
                  var f2 = Uj(a2);
                  Wj(a2, f2, e2);
                  break;
                case 3:
                case 4:
                  var g2 = d2.stateNode.containerInfo, h2 = Uj(a2);
                  Vj(a2, h2, g2);
                  break;
                default:
                  throw Error(p2(161));
              }
            } catch (k) {
              W(a2, a2.return, k);
            }
            a2.flags &= -3;
          }
          b & 4096 && (a2.flags &= -4097);
        }
        function hk(a2, b, c2) {
          V = a2;
          ik(a2);
        }
        function ik(a2, b, c2) {
          for (var d2 = 0 !== (a2.mode & 1); null !== V; ) {
            var e2 = V, f2 = e2.child;
            if (22 === e2.tag && d2) {
              var g2 = null !== e2.memoizedState || Jj;
              if (!g2) {
                var h2 = e2.alternate, k = null !== h2 && null !== h2.memoizedState || U;
                h2 = Jj;
                var l2 = U;
                Jj = g2;
                if ((U = k) && !l2) for (V = e2; null !== V; ) g2 = V, k = g2.child, 22 === g2.tag && null !== g2.memoizedState ? jk(e2) : null !== k ? (k.return = g2, V = k) : jk(e2);
                for (; null !== f2; ) V = f2, ik(f2), f2 = f2.sibling;
                V = e2;
                Jj = h2;
                U = l2;
              }
              kk(a2);
            } else 0 !== (e2.subtreeFlags & 8772) && null !== f2 ? (f2.return = e2, V = f2) : kk(a2);
          }
        }
        function kk(a2) {
          for (; null !== V; ) {
            var b = V;
            if (0 !== (b.flags & 8772)) {
              var c2 = b.alternate;
              try {
                if (0 !== (b.flags & 8772)) switch (b.tag) {
                  case 0:
                  case 11:
                  case 15:
                    U || Qj(5, b);
                    break;
                  case 1:
                    var d2 = b.stateNode;
                    if (b.flags & 4 && !U) if (null === c2) d2.componentDidMount();
                    else {
                      var e2 = b.elementType === b.type ? c2.memoizedProps : Ci(b.type, c2.memoizedProps);
                      d2.componentDidUpdate(e2, c2.memoizedState, d2.__reactInternalSnapshotBeforeUpdate);
                    }
                    var f2 = b.updateQueue;
                    null !== f2 && sh(b, f2, d2);
                    break;
                  case 3:
                    var g2 = b.updateQueue;
                    if (null !== g2) {
                      c2 = null;
                      if (null !== b.child) switch (b.child.tag) {
                        case 5:
                          c2 = b.child.stateNode;
                          break;
                        case 1:
                          c2 = b.child.stateNode;
                      }
                      sh(b, g2, c2);
                    }
                    break;
                  case 5:
                    var h2 = b.stateNode;
                    if (null === c2 && b.flags & 4) {
                      c2 = h2;
                      var k = b.memoizedProps;
                      switch (b.type) {
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                          k.autoFocus && c2.focus();
                          break;
                        case "img":
                          k.src && (c2.src = k.src);
                      }
                    }
                    break;
                  case 6:
                    break;
                  case 4:
                    break;
                  case 12:
                    break;
                  case 13:
                    if (null === b.memoizedState) {
                      var l2 = b.alternate;
                      if (null !== l2) {
                        var m2 = l2.memoizedState;
                        if (null !== m2) {
                          var q = m2.dehydrated;
                          null !== q && bd(q);
                        }
                      }
                    }
                    break;
                  case 19:
                  case 17:
                  case 21:
                  case 22:
                  case 23:
                  case 25:
                    break;
                  default:
                    throw Error(p2(163));
                }
                U || b.flags & 512 && Rj(b);
              } catch (r) {
                W(b, b.return, r);
              }
            }
            if (b === a2) {
              V = null;
              break;
            }
            c2 = b.sibling;
            if (null !== c2) {
              c2.return = b.return;
              V = c2;
              break;
            }
            V = b.return;
          }
        }
        function gk(a2) {
          for (; null !== V; ) {
            var b = V;
            if (b === a2) {
              V = null;
              break;
            }
            var c2 = b.sibling;
            if (null !== c2) {
              c2.return = b.return;
              V = c2;
              break;
            }
            V = b.return;
          }
        }
        function jk(a2) {
          for (; null !== V; ) {
            var b = V;
            try {
              switch (b.tag) {
                case 0:
                case 11:
                case 15:
                  var c2 = b.return;
                  try {
                    Qj(4, b);
                  } catch (k) {
                    W(b, c2, k);
                  }
                  break;
                case 1:
                  var d2 = b.stateNode;
                  if ("function" === typeof d2.componentDidMount) {
                    var e2 = b.return;
                    try {
                      d2.componentDidMount();
                    } catch (k) {
                      W(b, e2, k);
                    }
                  }
                  var f2 = b.return;
                  try {
                    Rj(b);
                  } catch (k) {
                    W(b, f2, k);
                  }
                  break;
                case 5:
                  var g2 = b.return;
                  try {
                    Rj(b);
                  } catch (k) {
                    W(b, g2, k);
                  }
              }
            } catch (k) {
              W(b, b.return, k);
            }
            if (b === a2) {
              V = null;
              break;
            }
            var h2 = b.sibling;
            if (null !== h2) {
              h2.return = b.return;
              V = h2;
              break;
            }
            V = b.return;
          }
        }
        var lk = Math.ceil, mk = ua.ReactCurrentDispatcher, nk = ua.ReactCurrentOwner, ok = ua.ReactCurrentBatchConfig, K = 0, Q = null, Y = null, Z = 0, fj = 0, ej = Uf(0), T = 0, pk = null, rh = 0, qk = 0, rk = 0, sk = null, tk = null, fk = 0, Gj = Infinity, uk = null, Oi = false, Pi = null, Ri = null, vk = false, wk = null, xk = 0, yk = 0, zk = null, Ak = -1, Bk = 0;
        function R() {
          return 0 !== (K & 6) ? B() : -1 !== Ak ? Ak : Ak = B();
        }
        function yi(a2) {
          if (0 === (a2.mode & 1)) return 1;
          if (0 !== (K & 2) && 0 !== Z) return Z & -Z;
          if (null !== Kg.transition) return 0 === Bk && (Bk = yc()), Bk;
          a2 = C;
          if (0 !== a2) return a2;
          a2 = window.event;
          a2 = void 0 === a2 ? 16 : jd(a2.type);
          return a2;
        }
        function gi(a2, b, c2, d2) {
          if (50 < yk) throw yk = 0, zk = null, Error(p2(185));
          Ac(a2, c2, d2);
          if (0 === (K & 2) || a2 !== Q) a2 === Q && (0 === (K & 2) && (qk |= c2), 4 === T && Ck(a2, Z)), Dk(a2, d2), 1 === c2 && 0 === K && 0 === (b.mode & 1) && (Gj = B() + 500, fg && jg());
        }
        function Dk(a2, b) {
          var c2 = a2.callbackNode;
          wc(a2, b);
          var d2 = uc(a2, a2 === Q ? Z : 0);
          if (0 === d2) null !== c2 && bc(c2), a2.callbackNode = null, a2.callbackPriority = 0;
          else if (b = d2 & -d2, a2.callbackPriority !== b) {
            null != c2 && bc(c2);
            if (1 === b) 0 === a2.tag ? ig(Ek.bind(null, a2)) : hg(Ek.bind(null, a2)), Jf(function() {
              0 === (K & 6) && jg();
            }), c2 = null;
            else {
              switch (Dc(d2)) {
                case 1:
                  c2 = fc;
                  break;
                case 4:
                  c2 = gc;
                  break;
                case 16:
                  c2 = hc;
                  break;
                case 536870912:
                  c2 = jc;
                  break;
                default:
                  c2 = hc;
              }
              c2 = Fk(c2, Gk.bind(null, a2));
            }
            a2.callbackPriority = b;
            a2.callbackNode = c2;
          }
        }
        function Gk(a2, b) {
          Ak = -1;
          Bk = 0;
          if (0 !== (K & 6)) throw Error(p2(327));
          var c2 = a2.callbackNode;
          if (Hk() && a2.callbackNode !== c2) return null;
          var d2 = uc(a2, a2 === Q ? Z : 0);
          if (0 === d2) return null;
          if (0 !== (d2 & 30) || 0 !== (d2 & a2.expiredLanes) || b) b = Ik(a2, d2);
          else {
            b = d2;
            var e2 = K;
            K |= 2;
            var f2 = Jk();
            if (Q !== a2 || Z !== b) uk = null, Gj = B() + 500, Kk(a2, b);
            do
              try {
                Lk();
                break;
              } catch (h2) {
                Mk(a2, h2);
              }
            while (1);
            $g();
            mk.current = f2;
            K = e2;
            null !== Y ? b = 0 : (Q = null, Z = 0, b = T);
          }
          if (0 !== b) {
            2 === b && (e2 = xc(a2), 0 !== e2 && (d2 = e2, b = Nk(a2, e2)));
            if (1 === b) throw c2 = pk, Kk(a2, 0), Ck(a2, d2), Dk(a2, B()), c2;
            if (6 === b) Ck(a2, d2);
            else {
              e2 = a2.current.alternate;
              if (0 === (d2 & 30) && !Ok(e2) && (b = Ik(a2, d2), 2 === b && (f2 = xc(a2), 0 !== f2 && (d2 = f2, b = Nk(a2, f2))), 1 === b)) throw c2 = pk, Kk(a2, 0), Ck(a2, d2), Dk(a2, B()), c2;
              a2.finishedWork = e2;
              a2.finishedLanes = d2;
              switch (b) {
                case 0:
                case 1:
                  throw Error(p2(345));
                case 2:
                  Pk(a2, tk, uk);
                  break;
                case 3:
                  Ck(a2, d2);
                  if ((d2 & 130023424) === d2 && (b = fk + 500 - B(), 10 < b)) {
                    if (0 !== uc(a2, 0)) break;
                    e2 = a2.suspendedLanes;
                    if ((e2 & d2) !== d2) {
                      R();
                      a2.pingedLanes |= a2.suspendedLanes & e2;
                      break;
                    }
                    a2.timeoutHandle = Ff(Pk.bind(null, a2, tk, uk), b);
                    break;
                  }
                  Pk(a2, tk, uk);
                  break;
                case 4:
                  Ck(a2, d2);
                  if ((d2 & 4194240) === d2) break;
                  b = a2.eventTimes;
                  for (e2 = -1; 0 < d2; ) {
                    var g2 = 31 - oc(d2);
                    f2 = 1 << g2;
                    g2 = b[g2];
                    g2 > e2 && (e2 = g2);
                    d2 &= ~f2;
                  }
                  d2 = e2;
                  d2 = B() - d2;
                  d2 = (120 > d2 ? 120 : 480 > d2 ? 480 : 1080 > d2 ? 1080 : 1920 > d2 ? 1920 : 3e3 > d2 ? 3e3 : 4320 > d2 ? 4320 : 1960 * lk(d2 / 1960)) - d2;
                  if (10 < d2) {
                    a2.timeoutHandle = Ff(Pk.bind(null, a2, tk, uk), d2);
                    break;
                  }
                  Pk(a2, tk, uk);
                  break;
                case 5:
                  Pk(a2, tk, uk);
                  break;
                default:
                  throw Error(p2(329));
              }
            }
          }
          Dk(a2, B());
          return a2.callbackNode === c2 ? Gk.bind(null, a2) : null;
        }
        function Nk(a2, b) {
          var c2 = sk;
          a2.current.memoizedState.isDehydrated && (Kk(a2, b).flags |= 256);
          a2 = Ik(a2, b);
          2 !== a2 && (b = tk, tk = c2, null !== b && Fj(b));
          return a2;
        }
        function Fj(a2) {
          null === tk ? tk = a2 : tk.push.apply(tk, a2);
        }
        function Ok(a2) {
          for (var b = a2; ; ) {
            if (b.flags & 16384) {
              var c2 = b.updateQueue;
              if (null !== c2 && (c2 = c2.stores, null !== c2)) for (var d2 = 0; d2 < c2.length; d2++) {
                var e2 = c2[d2], f2 = e2.getSnapshot;
                e2 = e2.value;
                try {
                  if (!He(f2(), e2)) return false;
                } catch (g2) {
                  return false;
                }
              }
            }
            c2 = b.child;
            if (b.subtreeFlags & 16384 && null !== c2) c2.return = b, b = c2;
            else {
              if (b === a2) break;
              for (; null === b.sibling; ) {
                if (null === b.return || b.return === a2) return true;
                b = b.return;
              }
              b.sibling.return = b.return;
              b = b.sibling;
            }
          }
          return true;
        }
        function Ck(a2, b) {
          b &= ~rk;
          b &= ~qk;
          a2.suspendedLanes |= b;
          a2.pingedLanes &= ~b;
          for (a2 = a2.expirationTimes; 0 < b; ) {
            var c2 = 31 - oc(b), d2 = 1 << c2;
            a2[c2] = -1;
            b &= ~d2;
          }
        }
        function Ek(a2) {
          if (0 !== (K & 6)) throw Error(p2(327));
          Hk();
          var b = uc(a2, 0);
          if (0 === (b & 1)) return Dk(a2, B()), null;
          var c2 = Ik(a2, b);
          if (0 !== a2.tag && 2 === c2) {
            var d2 = xc(a2);
            0 !== d2 && (b = d2, c2 = Nk(a2, d2));
          }
          if (1 === c2) throw c2 = pk, Kk(a2, 0), Ck(a2, b), Dk(a2, B()), c2;
          if (6 === c2) throw Error(p2(345));
          a2.finishedWork = a2.current.alternate;
          a2.finishedLanes = b;
          Pk(a2, tk, uk);
          Dk(a2, B());
          return null;
        }
        function Qk(a2, b) {
          var c2 = K;
          K |= 1;
          try {
            return a2(b);
          } finally {
            K = c2, 0 === K && (Gj = B() + 500, fg && jg());
          }
        }
        function Rk(a2) {
          null !== wk && 0 === wk.tag && 0 === (K & 6) && Hk();
          var b = K;
          K |= 1;
          var c2 = ok.transition, d2 = C;
          try {
            if (ok.transition = null, C = 1, a2) return a2();
          } finally {
            C = d2, ok.transition = c2, K = b, 0 === (K & 6) && jg();
          }
        }
        function Hj() {
          fj = ej.current;
          E(ej);
        }
        function Kk(a2, b) {
          a2.finishedWork = null;
          a2.finishedLanes = 0;
          var c2 = a2.timeoutHandle;
          -1 !== c2 && (a2.timeoutHandle = -1, Gf(c2));
          if (null !== Y) for (c2 = Y.return; null !== c2; ) {
            var d2 = c2;
            wg(d2);
            switch (d2.tag) {
              case 1:
                d2 = d2.type.childContextTypes;
                null !== d2 && void 0 !== d2 && $f();
                break;
              case 3:
                zh();
                E(Wf);
                E(H);
                Eh();
                break;
              case 5:
                Bh(d2);
                break;
              case 4:
                zh();
                break;
              case 13:
                E(L);
                break;
              case 19:
                E(L);
                break;
              case 10:
                ah(d2.type._context);
                break;
              case 22:
              case 23:
                Hj();
            }
            c2 = c2.return;
          }
          Q = a2;
          Y = a2 = Pg(a2.current, null);
          Z = fj = b;
          T = 0;
          pk = null;
          rk = qk = rh = 0;
          tk = sk = null;
          if (null !== fh) {
            for (b = 0; b < fh.length; b++) if (c2 = fh[b], d2 = c2.interleaved, null !== d2) {
              c2.interleaved = null;
              var e2 = d2.next, f2 = c2.pending;
              if (null !== f2) {
                var g2 = f2.next;
                f2.next = e2;
                d2.next = g2;
              }
              c2.pending = d2;
            }
            fh = null;
          }
          return a2;
        }
        function Mk(a2, b) {
          do {
            var c2 = Y;
            try {
              $g();
              Fh.current = Rh;
              if (Ih) {
                for (var d2 = M.memoizedState; null !== d2; ) {
                  var e2 = d2.queue;
                  null !== e2 && (e2.pending = null);
                  d2 = d2.next;
                }
                Ih = false;
              }
              Hh = 0;
              O = N = M = null;
              Jh = false;
              Kh = 0;
              nk.current = null;
              if (null === c2 || null === c2.return) {
                T = 1;
                pk = b;
                Y = null;
                break;
              }
              a: {
                var f2 = a2, g2 = c2.return, h2 = c2, k = b;
                b = Z;
                h2.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                  var l2 = k, m2 = h2, q = m2.tag;
                  if (0 === (m2.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                    var r = m2.alternate;
                    r ? (m2.updateQueue = r.updateQueue, m2.memoizedState = r.memoizedState, m2.lanes = r.lanes) : (m2.updateQueue = null, m2.memoizedState = null);
                  }
                  var y = Ui(g2);
                  if (null !== y) {
                    y.flags &= -257;
                    Vi(y, g2, h2, f2, b);
                    y.mode & 1 && Si(f2, l2, b);
                    b = y;
                    k = l2;
                    var n2 = b.updateQueue;
                    if (null === n2) {
                      var t2 = /* @__PURE__ */ new Set();
                      t2.add(k);
                      b.updateQueue = t2;
                    } else n2.add(k);
                    break a;
                  } else {
                    if (0 === (b & 1)) {
                      Si(f2, l2, b);
                      tj();
                      break a;
                    }
                    k = Error(p2(426));
                  }
                } else if (I && h2.mode & 1) {
                  var J = Ui(g2);
                  if (null !== J) {
                    0 === (J.flags & 65536) && (J.flags |= 256);
                    Vi(J, g2, h2, f2, b);
                    Jg(Ji(k, h2));
                    break a;
                  }
                }
                f2 = k = Ji(k, h2);
                4 !== T && (T = 2);
                null === sk ? sk = [f2] : sk.push(f2);
                f2 = g2;
                do {
                  switch (f2.tag) {
                    case 3:
                      f2.flags |= 65536;
                      b &= -b;
                      f2.lanes |= b;
                      var x = Ni(f2, k, b);
                      ph(f2, x);
                      break a;
                    case 1:
                      h2 = k;
                      var w = f2.type, u2 = f2.stateNode;
                      if (0 === (f2.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u2 && "function" === typeof u2.componentDidCatch && (null === Ri || !Ri.has(u2)))) {
                        f2.flags |= 65536;
                        b &= -b;
                        f2.lanes |= b;
                        var F = Qi(f2, h2, b);
                        ph(f2, F);
                        break a;
                      }
                  }
                  f2 = f2.return;
                } while (null !== f2);
              }
              Sk(c2);
            } catch (na) {
              b = na;
              Y === c2 && null !== c2 && (Y = c2 = c2.return);
              continue;
            }
            break;
          } while (1);
        }
        function Jk() {
          var a2 = mk.current;
          mk.current = Rh;
          return null === a2 ? Rh : a2;
        }
        function tj() {
          if (0 === T || 3 === T || 2 === T) T = 4;
          null === Q || 0 === (rh & 268435455) && 0 === (qk & 268435455) || Ck(Q, Z);
        }
        function Ik(a2, b) {
          var c2 = K;
          K |= 2;
          var d2 = Jk();
          if (Q !== a2 || Z !== b) uk = null, Kk(a2, b);
          do
            try {
              Tk();
              break;
            } catch (e2) {
              Mk(a2, e2);
            }
          while (1);
          $g();
          K = c2;
          mk.current = d2;
          if (null !== Y) throw Error(p2(261));
          Q = null;
          Z = 0;
          return T;
        }
        function Tk() {
          for (; null !== Y; ) Uk(Y);
        }
        function Lk() {
          for (; null !== Y && !cc(); ) Uk(Y);
        }
        function Uk(a2) {
          var b = Vk(a2.alternate, a2, fj);
          a2.memoizedProps = a2.pendingProps;
          null === b ? Sk(a2) : Y = b;
          nk.current = null;
        }
        function Sk(a2) {
          var b = a2;
          do {
            var c2 = b.alternate;
            a2 = b.return;
            if (0 === (b.flags & 32768)) {
              if (c2 = Ej(c2, b, fj), null !== c2) {
                Y = c2;
                return;
              }
            } else {
              c2 = Ij(c2, b);
              if (null !== c2) {
                c2.flags &= 32767;
                Y = c2;
                return;
              }
              if (null !== a2) a2.flags |= 32768, a2.subtreeFlags = 0, a2.deletions = null;
              else {
                T = 6;
                Y = null;
                return;
              }
            }
            b = b.sibling;
            if (null !== b) {
              Y = b;
              return;
            }
            Y = b = a2;
          } while (null !== b);
          0 === T && (T = 5);
        }
        function Pk(a2, b, c2) {
          var d2 = C, e2 = ok.transition;
          try {
            ok.transition = null, C = 1, Wk(a2, b, c2, d2);
          } finally {
            ok.transition = e2, C = d2;
          }
          return null;
        }
        function Wk(a2, b, c2, d2) {
          do
            Hk();
          while (null !== wk);
          if (0 !== (K & 6)) throw Error(p2(327));
          c2 = a2.finishedWork;
          var e2 = a2.finishedLanes;
          if (null === c2) return null;
          a2.finishedWork = null;
          a2.finishedLanes = 0;
          if (c2 === a2.current) throw Error(p2(177));
          a2.callbackNode = null;
          a2.callbackPriority = 0;
          var f2 = c2.lanes | c2.childLanes;
          Bc(a2, f2);
          a2 === Q && (Y = Q = null, Z = 0);
          0 === (c2.subtreeFlags & 2064) && 0 === (c2.flags & 2064) || vk || (vk = true, Fk(hc, function() {
            Hk();
            return null;
          }));
          f2 = 0 !== (c2.flags & 15990);
          if (0 !== (c2.subtreeFlags & 15990) || f2) {
            f2 = ok.transition;
            ok.transition = null;
            var g2 = C;
            C = 1;
            var h2 = K;
            K |= 4;
            nk.current = null;
            Oj(a2, c2);
            dk(c2, a2);
            Oe(Df);
            dd = !!Cf;
            Df = Cf = null;
            a2.current = c2;
            hk(c2);
            dc();
            K = h2;
            C = g2;
            ok.transition = f2;
          } else a2.current = c2;
          vk && (vk = false, wk = a2, xk = e2);
          f2 = a2.pendingLanes;
          0 === f2 && (Ri = null);
          mc(c2.stateNode);
          Dk(a2, B());
          if (null !== b) for (d2 = a2.onRecoverableError, c2 = 0; c2 < b.length; c2++) e2 = b[c2], d2(e2.value, { componentStack: e2.stack, digest: e2.digest });
          if (Oi) throw Oi = false, a2 = Pi, Pi = null, a2;
          0 !== (xk & 1) && 0 !== a2.tag && Hk();
          f2 = a2.pendingLanes;
          0 !== (f2 & 1) ? a2 === zk ? yk++ : (yk = 0, zk = a2) : yk = 0;
          jg();
          return null;
        }
        function Hk() {
          if (null !== wk) {
            var a2 = Dc(xk), b = ok.transition, c2 = C;
            try {
              ok.transition = null;
              C = 16 > a2 ? 16 : a2;
              if (null === wk) var d2 = false;
              else {
                a2 = wk;
                wk = null;
                xk = 0;
                if (0 !== (K & 6)) throw Error(p2(331));
                var e2 = K;
                K |= 4;
                for (V = a2.current; null !== V; ) {
                  var f2 = V, g2 = f2.child;
                  if (0 !== (V.flags & 16)) {
                    var h2 = f2.deletions;
                    if (null !== h2) {
                      for (var k = 0; k < h2.length; k++) {
                        var l2 = h2[k];
                        for (V = l2; null !== V; ) {
                          var m2 = V;
                          switch (m2.tag) {
                            case 0:
                            case 11:
                            case 15:
                              Pj(8, m2, f2);
                          }
                          var q = m2.child;
                          if (null !== q) q.return = m2, V = q;
                          else for (; null !== V; ) {
                            m2 = V;
                            var r = m2.sibling, y = m2.return;
                            Sj(m2);
                            if (m2 === l2) {
                              V = null;
                              break;
                            }
                            if (null !== r) {
                              r.return = y;
                              V = r;
                              break;
                            }
                            V = y;
                          }
                        }
                      }
                      var n2 = f2.alternate;
                      if (null !== n2) {
                        var t2 = n2.child;
                        if (null !== t2) {
                          n2.child = null;
                          do {
                            var J = t2.sibling;
                            t2.sibling = null;
                            t2 = J;
                          } while (null !== t2);
                        }
                      }
                      V = f2;
                    }
                  }
                  if (0 !== (f2.subtreeFlags & 2064) && null !== g2) g2.return = f2, V = g2;
                  else b: for (; null !== V; ) {
                    f2 = V;
                    if (0 !== (f2.flags & 2048)) switch (f2.tag) {
                      case 0:
                      case 11:
                      case 15:
                        Pj(9, f2, f2.return);
                    }
                    var x = f2.sibling;
                    if (null !== x) {
                      x.return = f2.return;
                      V = x;
                      break b;
                    }
                    V = f2.return;
                  }
                }
                var w = a2.current;
                for (V = w; null !== V; ) {
                  g2 = V;
                  var u2 = g2.child;
                  if (0 !== (g2.subtreeFlags & 2064) && null !== u2) u2.return = g2, V = u2;
                  else b: for (g2 = w; null !== V; ) {
                    h2 = V;
                    if (0 !== (h2.flags & 2048)) try {
                      switch (h2.tag) {
                        case 0:
                        case 11:
                        case 15:
                          Qj(9, h2);
                      }
                    } catch (na) {
                      W(h2, h2.return, na);
                    }
                    if (h2 === g2) {
                      V = null;
                      break b;
                    }
                    var F = h2.sibling;
                    if (null !== F) {
                      F.return = h2.return;
                      V = F;
                      break b;
                    }
                    V = h2.return;
                  }
                }
                K = e2;
                jg();
                if (lc && "function" === typeof lc.onPostCommitFiberRoot) try {
                  lc.onPostCommitFiberRoot(kc, a2);
                } catch (na) {
                }
                d2 = true;
              }
              return d2;
            } finally {
              C = c2, ok.transition = b;
            }
          }
          return false;
        }
        function Xk(a2, b, c2) {
          b = Ji(c2, b);
          b = Ni(a2, b, 1);
          a2 = nh(a2, b, 1);
          b = R();
          null !== a2 && (Ac(a2, 1, b), Dk(a2, b));
        }
        function W(a2, b, c2) {
          if (3 === a2.tag) Xk(a2, a2, c2);
          else for (; null !== b; ) {
            if (3 === b.tag) {
              Xk(b, a2, c2);
              break;
            } else if (1 === b.tag) {
              var d2 = b.stateNode;
              if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d2.componentDidCatch && (null === Ri || !Ri.has(d2))) {
                a2 = Ji(c2, a2);
                a2 = Qi(b, a2, 1);
                b = nh(b, a2, 1);
                a2 = R();
                null !== b && (Ac(b, 1, a2), Dk(b, a2));
                break;
              }
            }
            b = b.return;
          }
        }
        function Ti(a2, b, c2) {
          var d2 = a2.pingCache;
          null !== d2 && d2.delete(b);
          b = R();
          a2.pingedLanes |= a2.suspendedLanes & c2;
          Q === a2 && (Z & c2) === c2 && (4 === T || 3 === T && (Z & 130023424) === Z && 500 > B() - fk ? Kk(a2, 0) : rk |= c2);
          Dk(a2, b);
        }
        function Yk(a2, b) {
          0 === b && (0 === (a2.mode & 1) ? b = 1 : (b = sc, sc <<= 1, 0 === (sc & 130023424) && (sc = 4194304)));
          var c2 = R();
          a2 = ih(a2, b);
          null !== a2 && (Ac(a2, b, c2), Dk(a2, c2));
        }
        function uj(a2) {
          var b = a2.memoizedState, c2 = 0;
          null !== b && (c2 = b.retryLane);
          Yk(a2, c2);
        }
        function bk(a2, b) {
          var c2 = 0;
          switch (a2.tag) {
            case 13:
              var d2 = a2.stateNode;
              var e2 = a2.memoizedState;
              null !== e2 && (c2 = e2.retryLane);
              break;
            case 19:
              d2 = a2.stateNode;
              break;
            default:
              throw Error(p2(314));
          }
          null !== d2 && d2.delete(b);
          Yk(a2, c2);
        }
        var Vk;
        Vk = function(a2, b, c2) {
          if (null !== a2) if (a2.memoizedProps !== b.pendingProps || Wf.current) dh = true;
          else {
            if (0 === (a2.lanes & c2) && 0 === (b.flags & 128)) return dh = false, yj(a2, b, c2);
            dh = 0 !== (a2.flags & 131072) ? true : false;
          }
          else dh = false, I && 0 !== (b.flags & 1048576) && ug(b, ng, b.index);
          b.lanes = 0;
          switch (b.tag) {
            case 2:
              var d2 = b.type;
              ij(a2, b);
              a2 = b.pendingProps;
              var e2 = Yf(b, H.current);
              ch(b, c2);
              e2 = Nh(null, b, d2, a2, e2, c2);
              var f2 = Sh();
              b.flags |= 1;
              "object" === typeof e2 && null !== e2 && "function" === typeof e2.render && void 0 === e2.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, Zf(d2) ? (f2 = true, cg(b)) : f2 = false, b.memoizedState = null !== e2.state && void 0 !== e2.state ? e2.state : null, kh(b), e2.updater = Ei, b.stateNode = e2, e2._reactInternals = b, Ii(b, d2, a2, c2), b = jj(null, b, d2, true, f2, c2)) : (b.tag = 0, I && f2 && vg(b), Xi(null, b, e2, c2), b = b.child);
              return b;
            case 16:
              d2 = b.elementType;
              a: {
                ij(a2, b);
                a2 = b.pendingProps;
                e2 = d2._init;
                d2 = e2(d2._payload);
                b.type = d2;
                e2 = b.tag = Zk(d2);
                a2 = Ci(d2, a2);
                switch (e2) {
                  case 0:
                    b = cj(null, b, d2, a2, c2);
                    break a;
                  case 1:
                    b = hj(null, b, d2, a2, c2);
                    break a;
                  case 11:
                    b = Yi(null, b, d2, a2, c2);
                    break a;
                  case 14:
                    b = $i(null, b, d2, Ci(d2.type, a2), c2);
                    break a;
                }
                throw Error(p2(
                  306,
                  d2,
                  ""
                ));
              }
              return b;
            case 0:
              return d2 = b.type, e2 = b.pendingProps, e2 = b.elementType === d2 ? e2 : Ci(d2, e2), cj(a2, b, d2, e2, c2);
            case 1:
              return d2 = b.type, e2 = b.pendingProps, e2 = b.elementType === d2 ? e2 : Ci(d2, e2), hj(a2, b, d2, e2, c2);
            case 3:
              a: {
                kj(b);
                if (null === a2) throw Error(p2(387));
                d2 = b.pendingProps;
                f2 = b.memoizedState;
                e2 = f2.element;
                lh(a2, b);
                qh(b, d2, null, c2);
                var g2 = b.memoizedState;
                d2 = g2.element;
                if (f2.isDehydrated) if (f2 = { element: d2, isDehydrated: false, cache: g2.cache, pendingSuspenseBoundaries: g2.pendingSuspenseBoundaries, transitions: g2.transitions }, b.updateQueue.baseState = f2, b.memoizedState = f2, b.flags & 256) {
                  e2 = Ji(Error(p2(423)), b);
                  b = lj(a2, b, d2, c2, e2);
                  break a;
                } else if (d2 !== e2) {
                  e2 = Ji(Error(p2(424)), b);
                  b = lj(a2, b, d2, c2, e2);
                  break a;
                } else for (yg = Lf(b.stateNode.containerInfo.firstChild), xg = b, I = true, zg = null, c2 = Vg(b, null, d2, c2), b.child = c2; c2; ) c2.flags = c2.flags & -3 | 4096, c2 = c2.sibling;
                else {
                  Ig();
                  if (d2 === e2) {
                    b = Zi(a2, b, c2);
                    break a;
                  }
                  Xi(a2, b, d2, c2);
                }
                b = b.child;
              }
              return b;
            case 5:
              return Ah(b), null === a2 && Eg(b), d2 = b.type, e2 = b.pendingProps, f2 = null !== a2 ? a2.memoizedProps : null, g2 = e2.children, Ef(d2, e2) ? g2 = null : null !== f2 && Ef(d2, f2) && (b.flags |= 32), gj(a2, b), Xi(a2, b, g2, c2), b.child;
            case 6:
              return null === a2 && Eg(b), null;
            case 13:
              return oj(a2, b, c2);
            case 4:
              return yh(b, b.stateNode.containerInfo), d2 = b.pendingProps, null === a2 ? b.child = Ug(b, null, d2, c2) : Xi(a2, b, d2, c2), b.child;
            case 11:
              return d2 = b.type, e2 = b.pendingProps, e2 = b.elementType === d2 ? e2 : Ci(d2, e2), Yi(a2, b, d2, e2, c2);
            case 7:
              return Xi(a2, b, b.pendingProps, c2), b.child;
            case 8:
              return Xi(a2, b, b.pendingProps.children, c2), b.child;
            case 12:
              return Xi(a2, b, b.pendingProps.children, c2), b.child;
            case 10:
              a: {
                d2 = b.type._context;
                e2 = b.pendingProps;
                f2 = b.memoizedProps;
                g2 = e2.value;
                G(Wg, d2._currentValue);
                d2._currentValue = g2;
                if (null !== f2) if (He(f2.value, g2)) {
                  if (f2.children === e2.children && !Wf.current) {
                    b = Zi(a2, b, c2);
                    break a;
                  }
                } else for (f2 = b.child, null !== f2 && (f2.return = b); null !== f2; ) {
                  var h2 = f2.dependencies;
                  if (null !== h2) {
                    g2 = f2.child;
                    for (var k = h2.firstContext; null !== k; ) {
                      if (k.context === d2) {
                        if (1 === f2.tag) {
                          k = mh(-1, c2 & -c2);
                          k.tag = 2;
                          var l2 = f2.updateQueue;
                          if (null !== l2) {
                            l2 = l2.shared;
                            var m2 = l2.pending;
                            null === m2 ? k.next = k : (k.next = m2.next, m2.next = k);
                            l2.pending = k;
                          }
                        }
                        f2.lanes |= c2;
                        k = f2.alternate;
                        null !== k && (k.lanes |= c2);
                        bh(
                          f2.return,
                          c2,
                          b
                        );
                        h2.lanes |= c2;
                        break;
                      }
                      k = k.next;
                    }
                  } else if (10 === f2.tag) g2 = f2.type === b.type ? null : f2.child;
                  else if (18 === f2.tag) {
                    g2 = f2.return;
                    if (null === g2) throw Error(p2(341));
                    g2.lanes |= c2;
                    h2 = g2.alternate;
                    null !== h2 && (h2.lanes |= c2);
                    bh(g2, c2, b);
                    g2 = f2.sibling;
                  } else g2 = f2.child;
                  if (null !== g2) g2.return = f2;
                  else for (g2 = f2; null !== g2; ) {
                    if (g2 === b) {
                      g2 = null;
                      break;
                    }
                    f2 = g2.sibling;
                    if (null !== f2) {
                      f2.return = g2.return;
                      g2 = f2;
                      break;
                    }
                    g2 = g2.return;
                  }
                  f2 = g2;
                }
                Xi(a2, b, e2.children, c2);
                b = b.child;
              }
              return b;
            case 9:
              return e2 = b.type, d2 = b.pendingProps.children, ch(b, c2), e2 = eh(e2), d2 = d2(e2), b.flags |= 1, Xi(a2, b, d2, c2), b.child;
            case 14:
              return d2 = b.type, e2 = Ci(d2, b.pendingProps), e2 = Ci(d2.type, e2), $i(a2, b, d2, e2, c2);
            case 15:
              return bj(a2, b, b.type, b.pendingProps, c2);
            case 17:
              return d2 = b.type, e2 = b.pendingProps, e2 = b.elementType === d2 ? e2 : Ci(d2, e2), ij(a2, b), b.tag = 1, Zf(d2) ? (a2 = true, cg(b)) : a2 = false, ch(b, c2), Gi(b, d2, e2), Ii(b, d2, e2, c2), jj(null, b, d2, true, a2, c2);
            case 19:
              return xj(a2, b, c2);
            case 22:
              return dj(a2, b, c2);
          }
          throw Error(p2(156, b.tag));
        };
        function Fk(a2, b) {
          return ac(a2, b);
        }
        function $k(a2, b, c2, d2) {
          this.tag = a2;
          this.key = c2;
          this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
          this.index = 0;
          this.ref = null;
          this.pendingProps = b;
          this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
          this.mode = d2;
          this.subtreeFlags = this.flags = 0;
          this.deletions = null;
          this.childLanes = this.lanes = 0;
          this.alternate = null;
        }
        function Bg(a2, b, c2, d2) {
          return new $k(a2, b, c2, d2);
        }
        function aj(a2) {
          a2 = a2.prototype;
          return !(!a2 || !a2.isReactComponent);
        }
        function Zk(a2) {
          if ("function" === typeof a2) return aj(a2) ? 1 : 0;
          if (void 0 !== a2 && null !== a2) {
            a2 = a2.$$typeof;
            if (a2 === Da) return 11;
            if (a2 === Ga) return 14;
          }
          return 2;
        }
        function Pg(a2, b) {
          var c2 = a2.alternate;
          null === c2 ? (c2 = Bg(a2.tag, b, a2.key, a2.mode), c2.elementType = a2.elementType, c2.type = a2.type, c2.stateNode = a2.stateNode, c2.alternate = a2, a2.alternate = c2) : (c2.pendingProps = b, c2.type = a2.type, c2.flags = 0, c2.subtreeFlags = 0, c2.deletions = null);
          c2.flags = a2.flags & 14680064;
          c2.childLanes = a2.childLanes;
          c2.lanes = a2.lanes;
          c2.child = a2.child;
          c2.memoizedProps = a2.memoizedProps;
          c2.memoizedState = a2.memoizedState;
          c2.updateQueue = a2.updateQueue;
          b = a2.dependencies;
          c2.dependencies = null === b ? null : { lanes: b.lanes, firstContext: b.firstContext };
          c2.sibling = a2.sibling;
          c2.index = a2.index;
          c2.ref = a2.ref;
          return c2;
        }
        function Rg(a2, b, c2, d2, e2, f2) {
          var g2 = 2;
          d2 = a2;
          if ("function" === typeof a2) aj(a2) && (g2 = 1);
          else if ("string" === typeof a2) g2 = 5;
          else a: switch (a2) {
            case ya:
              return Tg(c2.children, e2, f2, b);
            case za:
              g2 = 8;
              e2 |= 8;
              break;
            case Aa:
              return a2 = Bg(12, c2, b, e2 | 2), a2.elementType = Aa, a2.lanes = f2, a2;
            case Ea:
              return a2 = Bg(13, c2, b, e2), a2.elementType = Ea, a2.lanes = f2, a2;
            case Fa:
              return a2 = Bg(19, c2, b, e2), a2.elementType = Fa, a2.lanes = f2, a2;
            case Ia:
              return pj(c2, e2, f2, b);
            default:
              if ("object" === typeof a2 && null !== a2) switch (a2.$$typeof) {
                case Ba:
                  g2 = 10;
                  break a;
                case Ca:
                  g2 = 9;
                  break a;
                case Da:
                  g2 = 11;
                  break a;
                case Ga:
                  g2 = 14;
                  break a;
                case Ha:
                  g2 = 16;
                  d2 = null;
                  break a;
              }
              throw Error(p2(130, null == a2 ? a2 : typeof a2, ""));
          }
          b = Bg(g2, c2, b, e2);
          b.elementType = a2;
          b.type = d2;
          b.lanes = f2;
          return b;
        }
        function Tg(a2, b, c2, d2) {
          a2 = Bg(7, a2, d2, b);
          a2.lanes = c2;
          return a2;
        }
        function pj(a2, b, c2, d2) {
          a2 = Bg(22, a2, d2, b);
          a2.elementType = Ia;
          a2.lanes = c2;
          a2.stateNode = { isHidden: false };
          return a2;
        }
        function Qg(a2, b, c2) {
          a2 = Bg(6, a2, null, b);
          a2.lanes = c2;
          return a2;
        }
        function Sg(a2, b, c2) {
          b = Bg(4, null !== a2.children ? a2.children : [], a2.key, b);
          b.lanes = c2;
          b.stateNode = { containerInfo: a2.containerInfo, pendingChildren: null, implementation: a2.implementation };
          return b;
        }
        function al(a2, b, c2, d2, e2) {
          this.tag = b;
          this.containerInfo = a2;
          this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
          this.timeoutHandle = -1;
          this.callbackNode = this.pendingContext = this.context = null;
          this.callbackPriority = 0;
          this.eventTimes = zc(0);
          this.expirationTimes = zc(-1);
          this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
          this.entanglements = zc(0);
          this.identifierPrefix = d2;
          this.onRecoverableError = e2;
          this.mutableSourceEagerHydrationData = null;
        }
        function bl(a2, b, c2, d2, e2, f2, g2, h2, k) {
          a2 = new al(a2, b, c2, h2, k);
          1 === b ? (b = 1, true === f2 && (b |= 8)) : b = 0;
          f2 = Bg(3, null, null, b);
          a2.current = f2;
          f2.stateNode = a2;
          f2.memoizedState = { element: d2, isDehydrated: c2, cache: null, transitions: null, pendingSuspenseBoundaries: null };
          kh(f2);
          return a2;
        }
        function cl(a2, b, c2) {
          var d2 = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
          return { $$typeof: wa, key: null == d2 ? null : "" + d2, children: a2, containerInfo: b, implementation: c2 };
        }
        function dl(a2) {
          if (!a2) return Vf;
          a2 = a2._reactInternals;
          a: {
            if (Vb(a2) !== a2 || 1 !== a2.tag) throw Error(p2(170));
            var b = a2;
            do {
              switch (b.tag) {
                case 3:
                  b = b.stateNode.context;
                  break a;
                case 1:
                  if (Zf(b.type)) {
                    b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                    break a;
                  }
              }
              b = b.return;
            } while (null !== b);
            throw Error(p2(171));
          }
          if (1 === a2.tag) {
            var c2 = a2.type;
            if (Zf(c2)) return bg(a2, c2, b);
          }
          return b;
        }
        function el(a2, b, c2, d2, e2, f2, g2, h2, k) {
          a2 = bl(c2, d2, true, a2, e2, f2, g2, h2, k);
          a2.context = dl(null);
          c2 = a2.current;
          d2 = R();
          e2 = yi(c2);
          f2 = mh(d2, e2);
          f2.callback = void 0 !== b && null !== b ? b : null;
          nh(c2, f2, e2);
          a2.current.lanes = e2;
          Ac(a2, e2, d2);
          Dk(a2, d2);
          return a2;
        }
        function fl(a2, b, c2, d2) {
          var e2 = b.current, f2 = R(), g2 = yi(e2);
          c2 = dl(c2);
          null === b.context ? b.context = c2 : b.pendingContext = c2;
          b = mh(f2, g2);
          b.payload = { element: a2 };
          d2 = void 0 === d2 ? null : d2;
          null !== d2 && (b.callback = d2);
          a2 = nh(e2, b, g2);
          null !== a2 && (gi(a2, e2, g2, f2), oh(a2, e2, g2));
          return g2;
        }
        function gl(a2) {
          a2 = a2.current;
          if (!a2.child) return null;
          switch (a2.child.tag) {
            case 5:
              return a2.child.stateNode;
            default:
              return a2.child.stateNode;
          }
        }
        function hl(a2, b) {
          a2 = a2.memoizedState;
          if (null !== a2 && null !== a2.dehydrated) {
            var c2 = a2.retryLane;
            a2.retryLane = 0 !== c2 && c2 < b ? c2 : b;
          }
        }
        function il(a2, b) {
          hl(a2, b);
          (a2 = a2.alternate) && hl(a2, b);
        }
        function jl() {
          return null;
        }
        var kl = "function" === typeof reportError ? reportError : function(a2) {
          console.error(a2);
        };
        function ll(a2) {
          this._internalRoot = a2;
        }
        ml.prototype.render = ll.prototype.render = function(a2) {
          var b = this._internalRoot;
          if (null === b) throw Error(p2(409));
          fl(a2, b, null, null);
        };
        ml.prototype.unmount = ll.prototype.unmount = function() {
          var a2 = this._internalRoot;
          if (null !== a2) {
            this._internalRoot = null;
            var b = a2.containerInfo;
            Rk(function() {
              fl(null, a2, null, null);
            });
            b[uf] = null;
          }
        };
        function ml(a2) {
          this._internalRoot = a2;
        }
        ml.prototype.unstable_scheduleHydration = function(a2) {
          if (a2) {
            var b = Hc();
            a2 = { blockedOn: null, target: a2, priority: b };
            for (var c2 = 0; c2 < Qc.length && 0 !== b && b < Qc[c2].priority; c2++) ;
            Qc.splice(c2, 0, a2);
            0 === c2 && Vc(a2);
          }
        };
        function nl(a2) {
          return !(!a2 || 1 !== a2.nodeType && 9 !== a2.nodeType && 11 !== a2.nodeType);
        }
        function ol(a2) {
          return !(!a2 || 1 !== a2.nodeType && 9 !== a2.nodeType && 11 !== a2.nodeType && (8 !== a2.nodeType || " react-mount-point-unstable " !== a2.nodeValue));
        }
        function pl() {
        }
        function ql(a2, b, c2, d2, e2) {
          if (e2) {
            if ("function" === typeof d2) {
              var f2 = d2;
              d2 = function() {
                var a3 = gl(g2);
                f2.call(a3);
              };
            }
            var g2 = el(b, d2, a2, 0, null, false, false, "", pl);
            a2._reactRootContainer = g2;
            a2[uf] = g2.current;
            sf(8 === a2.nodeType ? a2.parentNode : a2);
            Rk();
            return g2;
          }
          for (; e2 = a2.lastChild; ) a2.removeChild(e2);
          if ("function" === typeof d2) {
            var h2 = d2;
            d2 = function() {
              var a3 = gl(k);
              h2.call(a3);
            };
          }
          var k = bl(a2, 0, false, null, null, false, false, "", pl);
          a2._reactRootContainer = k;
          a2[uf] = k.current;
          sf(8 === a2.nodeType ? a2.parentNode : a2);
          Rk(function() {
            fl(b, k, c2, d2);
          });
          return k;
        }
        function rl(a2, b, c2, d2, e2) {
          var f2 = c2._reactRootContainer;
          if (f2) {
            var g2 = f2;
            if ("function" === typeof e2) {
              var h2 = e2;
              e2 = function() {
                var a3 = gl(g2);
                h2.call(a3);
              };
            }
            fl(b, g2, a2, e2);
          } else g2 = ql(c2, b, a2, e2, d2);
          return gl(g2);
        }
        Ec = function(a2) {
          switch (a2.tag) {
            case 3:
              var b = a2.stateNode;
              if (b.current.memoizedState.isDehydrated) {
                var c2 = tc(b.pendingLanes);
                0 !== c2 && (Cc(b, c2 | 1), Dk(b, B()), 0 === (K & 6) && (Gj = B() + 500, jg()));
              }
              break;
            case 13:
              Rk(function() {
                var b2 = ih(a2, 1);
                if (null !== b2) {
                  var c3 = R();
                  gi(b2, a2, 1, c3);
                }
              }), il(a2, 1);
          }
        };
        Fc = function(a2) {
          if (13 === a2.tag) {
            var b = ih(a2, 134217728);
            if (null !== b) {
              var c2 = R();
              gi(b, a2, 134217728, c2);
            }
            il(a2, 134217728);
          }
        };
        Gc = function(a2) {
          if (13 === a2.tag) {
            var b = yi(a2), c2 = ih(a2, b);
            if (null !== c2) {
              var d2 = R();
              gi(c2, a2, b, d2);
            }
            il(a2, b);
          }
        };
        Hc = function() {
          return C;
        };
        Ic = function(a2, b) {
          var c2 = C;
          try {
            return C = a2, b();
          } finally {
            C = c2;
          }
        };
        yb = function(a2, b, c2) {
          switch (b) {
            case "input":
              bb(a2, c2);
              b = c2.name;
              if ("radio" === c2.type && null != b) {
                for (c2 = a2; c2.parentNode; ) c2 = c2.parentNode;
                c2 = c2.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for (b = 0; b < c2.length; b++) {
                  var d2 = c2[b];
                  if (d2 !== a2 && d2.form === a2.form) {
                    var e2 = Db(d2);
                    if (!e2) throw Error(p2(90));
                    Wa(d2);
                    bb(d2, e2);
                  }
                }
              }
              break;
            case "textarea":
              ib(a2, c2);
              break;
            case "select":
              b = c2.value, null != b && fb(a2, !!c2.multiple, b, false);
          }
        };
        Gb = Qk;
        Hb = Rk;
        var sl = { usingClientEntryPoint: false, Events: [Cb, ue, Db, Eb, Fb, Qk] }, tl = { findFiberByHostInstance: Wc, bundleType: 0, version: "18.3.1", rendererPackageName: "react-dom" };
        var ul = { bundleType: tl.bundleType, version: tl.version, rendererPackageName: tl.rendererPackageName, rendererConfig: tl.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setErrorHandler: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: ua.ReactCurrentDispatcher, findHostInstanceByFiber: function(a2) {
          a2 = Zb(a2);
          return null === a2 ? null : a2.stateNode;
        }, findFiberByHostInstance: tl.findFiberByHostInstance || jl, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null, reconcilerVersion: "18.3.1-next-f1338f8080-20240426" };
        if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
          var vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
          if (!vl.isDisabled && vl.supportsFiber) try {
            kc = vl.inject(ul), lc = vl;
          } catch (a2) {
          }
        }
        reactDom_production_min.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = sl;
        reactDom_production_min.createPortal = function(a2, b) {
          var c2 = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
          if (!nl(b)) throw Error(p2(200));
          return cl(a2, b, null, c2);
        };
        reactDom_production_min.createRoot = function(a2, b) {
          if (!nl(a2)) throw Error(p2(299));
          var c2 = false, d2 = "", e2 = kl;
          null !== b && void 0 !== b && (true === b.unstable_strictMode && (c2 = true), void 0 !== b.identifierPrefix && (d2 = b.identifierPrefix), void 0 !== b.onRecoverableError && (e2 = b.onRecoverableError));
          b = bl(a2, 1, false, null, null, c2, false, d2, e2);
          a2[uf] = b.current;
          sf(8 === a2.nodeType ? a2.parentNode : a2);
          return new ll(b);
        };
        reactDom_production_min.findDOMNode = function(a2) {
          if (null == a2) return null;
          if (1 === a2.nodeType) return a2;
          var b = a2._reactInternals;
          if (void 0 === b) {
            if ("function" === typeof a2.render) throw Error(p2(188));
            a2 = Object.keys(a2).join(",");
            throw Error(p2(268, a2));
          }
          a2 = Zb(b);
          a2 = null === a2 ? null : a2.stateNode;
          return a2;
        };
        reactDom_production_min.flushSync = function(a2) {
          return Rk(a2);
        };
        reactDom_production_min.hydrate = function(a2, b, c2) {
          if (!ol(b)) throw Error(p2(200));
          return rl(null, a2, b, true, c2);
        };
        reactDom_production_min.hydrateRoot = function(a2, b, c2) {
          if (!nl(a2)) throw Error(p2(405));
          var d2 = null != c2 && c2.hydratedSources || null, e2 = false, f2 = "", g2 = kl;
          null !== c2 && void 0 !== c2 && (true === c2.unstable_strictMode && (e2 = true), void 0 !== c2.identifierPrefix && (f2 = c2.identifierPrefix), void 0 !== c2.onRecoverableError && (g2 = c2.onRecoverableError));
          b = el(b, null, a2, 1, null != c2 ? c2 : null, e2, false, f2, g2);
          a2[uf] = b.current;
          sf(a2);
          if (d2) for (a2 = 0; a2 < d2.length; a2++) c2 = d2[a2], e2 = c2._getVersion, e2 = e2(c2._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [c2, e2] : b.mutableSourceEagerHydrationData.push(
            c2,
            e2
          );
          return new ml(b);
        };
        reactDom_production_min.render = function(a2, b, c2) {
          if (!ol(b)) throw Error(p2(200));
          return rl(null, a2, b, false, c2);
        };
        reactDom_production_min.unmountComponentAtNode = function(a2) {
          if (!ol(a2)) throw Error(p2(40));
          return a2._reactRootContainer ? (Rk(function() {
            rl(null, null, a2, false, function() {
              a2._reactRootContainer = null;
              a2[uf] = null;
            });
          }), true) : false;
        };
        reactDom_production_min.unstable_batchedUpdates = Qk;
        reactDom_production_min.unstable_renderSubtreeIntoContainer = function(a2, b, c2, d2) {
          if (!ol(c2)) throw Error(p2(200));
          if (null == a2 || void 0 === a2._reactInternals) throw Error(p2(38));
          return rl(a2, b, c2, false, d2);
        };
        reactDom_production_min.version = "18.3.1-next-f1338f8080-20240426";
        return reactDom_production_min;
      }
      var hasRequiredReactDom;
      function requireReactDom() {
        if (hasRequiredReactDom) return reactDom.exports;
        hasRequiredReactDom = 1;
        function checkDCE() {
          if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") {
            return;
          }
          try {
            __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
          } catch (err) {
            console.error(err);
          }
        }
        {
          checkDCE();
          reactDom.exports = requireReactDom_production_min();
        }
        return reactDom.exports;
      }
      var hasRequiredClient;
      function requireClient() {
        if (hasRequiredClient) return client;
        hasRequiredClient = 1;
        var m2 = requireReactDom();
        {
          client.createRoot = m2.createRoot;
          client.hydrateRoot = m2.hydrateRoot;
        }
        return client;
      }
      var clientExports = requireClient();
      const sall = (fn) => fn();
      function isBreakpoint(query) {
        const mediaQuery = window.matchMedia(query);
        return mediaQuery.matches;
      }
      function isMobile() {
        return isBreakpoint("(max-width: 767px)");
      }
      function lib(l2) {
        return () => l2();
      }
      const getReactMountNode = exports("g", sall(() => {
        let root = null;
        function reducer(state, action) {
          switch (action.type) {
            case "push":
              return [...state, action.payload];
            case "remove":
              return state.filter((n2) => n2 !== action.payload);
            default:
              return state;
          }
        }
        const Container = reactExports.forwardRef(function Container2(_props, ref) {
          const [nodes, dispatch] = reactExports.useReducer(reducer, []);
          reactExports.useImperativeHandle(ref, () => ({
            dispatch
          }));
          return reactExports.createElement("div", {}, nodes);
        });
        let resolve = (_ref) => {
        };
        const p2 = new Promise((r) => resolve = r);
        return async () => {
          if (!root) {
            root = document.createElement("div");
            root.id = "elegoo-theme-root";
            document.body.appendChild(root);
            const app = clientExports.createRoot(root);
            app.render(reactExports.createElement(Container, {
              ref: (ref2) => {
                resolve(ref2);
              }
            }));
          }
          const ref = await p2;
          return {
            async push(node) {
              ref.dispatch({
                type: "push",
                payload: node
              });
            },
            remove(node) {
              ref.dispatch({
                type: "remove",
                payload: node
              });
            }
          };
        };
      }));
      function hex2rgb(hex) {
        const color = parseInt(hex.slice(1), 16);
        const r = color >> 16 & 255;
        const g2 = color >> 8 & 255;
        const b = color & 255;
        return {
          r,
          g: g2,
          b
        };
      }
      var reactDomExports = exports("d", requireReactDom());
      const ReactDOM = exports("k", /* @__PURE__ */ getDefaultExportFromCjs(reactDomExports));
      function withOnMount(comp, cb) {
        return (props) => {
          reactExports.useEffect(() => {
            cb == null ? void 0 : cb();
          }, []);
          return reactExports.createElement(comp, props);
        };
      }
      const call = async (m2, params, cb) => {
        const mod = await m2;
        if (typeof mod === "function") {
          return mod(params);
        }
        if (params.container) {
          const container = params.container;
          const payload = params.payload;
          const mount = await getReactMountNode();
          const Comp = mod.default;
          const portalEl = typeof container === "string" ? document.querySelector(container) : container;
          if (portalEl) {
            const portal = reactDomExports.createPortal(reactExports.createElement(withOnMount(Comp, cb), payload), portalEl);
            mount.push(portal);
          }
        } else {
          if (typeof mod.invoke === "function") {
            mod.invoke(params);
          } else {
            mod.default(params);
          }
        }
      };
      const INVOKES = {
        startCarousel: () => module.import("./dyn-embla.js").then((n2) => n2.e).then((m2) => m2.startCarousel),
        "initChaoticEffect": () => module.import("./dyn-hero-effects.js").then((m2) => m2.initChaoticEffect),
        "retable": () => module.import("./dyn-retable.js"),
        "parallax-banner": () => module.import("./dyn-parallax-banner.js").then((n2) => n2.ay),
        "expandable-cards": () => module.import("./dyn-scroll-follow-action.js").then((m2) => m2.initExpandableCards),
        "scroll-follow-video": () => module.import("./dyn-scroll-follow-action.js").then((m2) => m2.initScrollFollowVideo),
        "scrolling-reveal": () => module.import("./dyn-scroll-follow-action.js").then((m2) => m2.initScrollingReveal),
        "scroll-progress": () => module.import("./dyn-scroll-follow-action.js").then((m2) => m2.initScrollProgress),
        "timeline": () => module.import("./dyn-timeline.js"),
        "milestones": () => module.import("./dyn-milestones.js"),
        "media-3d-carousel": () => module.import("./dyn-media-3d-carousel.js"),
        "scroll-and-hover": () => module.import("./dyn-scroll-and-hover.js"),
        "user-story": () => module.import("./dyn-user-story.js"),
        "social-media-reviews": () => module.import("./dyn-social-media-reviews.js"),
        "sns-masonry": () => module.import("./dyn-sns-masonry.js"),
        "flip-clock": () => module.import("./dyn-flip-clock.js")
      };
      function invoke(strOrElement, cb) {
        const KEY_INVOKED = "__dyn_invoked";
        let jsonStr = "{}";
        let el = null;
        if (strOrElement instanceof HTMLScriptElement) {
          el = strOrElement;
          jsonStr = el.textContent || "{}";
        } else if (typeof strOrElement === "string") {
          try {
            el = document.querySelector(strOrElement);
            if (el) {
              jsonStr = el.textContent || "{}";
            }
          } catch {
          }
        }
        if (get(el, KEY_INVOKED)) return Promise.resolve();
        const params = JSON.parse(jsonStr);
        if (params.type in INVOKES) {
          call(INVOKES[params.type](), params, cb);
          if (el) el[KEY_INVOKED] = true;
        }
      }
      m(reactExports.createElement, n);
      class LazyDep {
        constructor(loader) {
          __publicField(this, "loader");
          this.loader = loader;
        }
        load() {
          return this.loader();
        }
      }
      const modules = {
        ClipboardJS: lib(() => module.import("./dyn-clipboard.js").then((n2) => n2.c).then((m2) => m2.default)),
        invoke: () => Promise.resolve(invoke)
      };
      const LAZY_MODULES = {
        manualInvoke,
        ClipboardJS: new LazyDep(() => module.import("./dyn-clipboard.js").then((n2) => n2.c).then((m2) => m2.default)),
        motion: new LazyDep(() => module.import("./dyn-index3.js"))
      };
      if (!((_a = window.importDynamic) == null ? void 0 : _a.initialized)) {
        const importDynamic = function(name, cb) {
          var _a2;
          const m2 = (_a2 = modules[name]) == null ? void 0 : _a2.call(modules);
          if (typeof cb === "function") {
            cb(m2);
          }
          return m2;
        };
        importDynamic.initialized = true;
        if ((_b = window._dynamics) == null ? void 0 : _b.length) {
          window._dynamics.forEach(([name, resolve]) => {
            importDynamic(name).then(resolve);
          });
          window._dynamics = [];
        }
        window.importDynamic = importDynamic;
      }
      function autoInvoke() {
        Array.from(document.querySelectorAll('script[dyn-invoke][type="application/json"]')).forEach((script) => {
          if (script instanceof HTMLScriptElement) {
            invoke(script);
          }
        });
      }
      function manualInvoke(el, cb) {
        let elem = el;
        if (typeof el === "string") {
          elem = document.querySelector(el);
        }
        if (!elem) return;
        const scripts = Array.from(elem.querySelectorAll('script[dyn-invoke][type="application/json"]'));
        scripts.forEach((script) => invoke(script, cb));
      }
      async function callWithDeps(config) {
        if (Array.isArray(config)) {
          const fn = config.pop();
          const deps = config;
          if (typeof fn === "function") {
            fn.apply(null, await Promise.all(deps.map(async (depName) => {
              const name = depName.split(".")[0];
              const dep = get(LAZY_MODULES, name);
              const isLazyDep = dep instanceof LazyDep;
              if (isLazyDep) {
                const m2 = await dep.load();
                if (depName !== name) {
                  return get(m2, depName.split(".").slice(1).join("."));
                }
                return m2;
              }
              return get(LAZY_MODULES, depName);
            })));
          }
        }
      }
      window.ELEGOO_THEME = window.ELEGOO_THEME || [];
      const ELEGOO_THEME = window.ELEGOO_THEME;
      window.ELEGOO_THEME.push = new Proxy(ELEGOO_THEME.push, {
        apply(target, thisArg, args) {
          if (Array.isArray(args)) {
            args.forEach((config) => callWithDeps(config));
          }
          const result = Reflect.apply(target, thisArg, args);
          return result;
        }
      });
      ELEGOO_THEME.forEach((config) => callWithDeps(config));
      document.addEventListener("shopify:section:load", () => {
        autoInvoke();
      });
      autoInvoke();
    }
  };
});
